const GlassisTeaserGlassesSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 357 230"
      fill="none"
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M104.723 27.594C104.969 27.594 105.168 27.3945 105.168 27.1484C105.168 26.9023 104.969 26.7028 104.723 26.7028C104.477 26.7028 104.277 26.9023 104.277 27.1484C104.277 27.3945 104.477 27.594 104.723 27.594Z"
        fill="white"
      />
      <path
        d="M104.723 82.4458C104.973 82.4458 105.175 82.2431 105.175 81.9931C105.175 81.743 104.973 81.5403 104.723 81.5403C104.473 81.5403 104.27 81.743 104.27 81.9931C104.27 82.2431 104.473 82.4458 104.723 82.4458Z"
        fill="white"
      />
      <path
        d="M98.6695 88.5381C98.9196 88.5381 99.1223 88.3354 99.1223 88.0853C99.1223 87.8353 98.9196 87.6326 98.6695 87.6326C98.4195 87.6326 98.2168 87.8353 98.2168 88.0853C98.2168 88.3354 98.4195 88.5381 98.6695 88.5381Z"
        fill="white"
      />
      <path
        d="M92.5345 88.4454C92.7334 88.4454 92.8945 88.2842 92.8945 88.0853C92.8945 87.8865 92.7334 87.7253 92.5345 87.7253C92.3357 87.7253 92.1745 87.8865 92.1745 88.0853C92.1745 88.2842 92.3357 88.4454 92.5345 88.4454Z"
        fill="white"
      />
      <path
        d="M110.833 76.3357C111.083 76.3357 111.285 76.133 111.285 75.883C111.285 75.6329 111.083 75.4302 110.833 75.4302C110.583 75.4302 110.38 75.6329 110.38 75.883C110.38 76.133 110.583 76.3357 110.833 76.3357Z"
        fill="white"
      />
      <path
        d="M104.723 76.3357C104.973 76.3357 105.175 76.133 105.175 75.883C105.175 75.6329 104.973 75.4302 104.723 75.4302C104.473 75.4302 104.27 75.6329 104.27 75.883C104.27 76.133 104.473 76.3357 104.723 76.3357Z"
        fill="white"
      />
      <path
        d="M98.6695 82.4886C98.9432 82.4886 99.1651 82.2667 99.1651 81.9931C99.1651 81.7194 98.9432 81.4975 98.6695 81.4975C98.3959 81.4975 98.174 81.7194 98.174 81.9931C98.174 82.2667 98.3959 82.4886 98.6695 82.4886Z"
        fill="white"
      />
      <path
        d="M226.646 23.6905C228.115 23.6905 229.306 22.4999 229.306 21.0312C229.306 19.5624 228.115 18.3718 226.646 18.3718C225.178 18.3718 223.987 19.5624 223.987 21.0312C223.987 22.4999 225.178 23.6905 226.646 23.6905Z"
        fill="white"
      />
      <path
        d="M220.543 54.1447C222.008 54.1447 223.196 52.9573 223.196 51.4925C223.196 50.0277 222.008 48.8403 220.543 48.8403C219.079 48.8403 217.891 50.0277 217.891 51.4925C217.891 52.9573 219.079 54.1447 220.543 54.1447Z"
        fill="white"
      />
      <path
        d="M226.611 29.7863C228.068 29.7863 229.249 28.6053 229.249 27.1484C229.249 25.6915 228.068 24.5104 226.611 24.5104C225.154 24.5104 223.973 25.6915 223.973 27.1484C223.973 28.6053 225.154 29.7863 226.611 29.7863Z"
        fill="white"
      />
      <path
        d="M299.779 114.911C301.131 114.911 302.228 113.814 302.228 112.462C302.228 111.109 301.131 110.012 299.779 110.012C298.426 110.012 297.33 111.109 297.33 112.462C297.33 113.814 298.426 114.911 299.779 114.911Z"
        fill="white"
      />
      <path
        d="M183.944 29.5546C185.288 29.5546 186.378 28.4646 186.378 27.1199C186.378 25.7752 185.288 24.6851 183.944 24.6851C182.599 24.6851 181.509 25.7752 181.509 27.1199C181.509 28.4646 182.599 29.5546 183.944 29.5546Z"
        fill="white"
      />
      <path
        d="M74.2078 35.5934C75.5269 35.5934 76.5962 34.5241 76.5962 33.205C76.5962 31.8859 75.5269 30.8166 74.2078 30.8166C72.8887 30.8166 71.8194 31.8859 71.8194 33.205C71.8194 34.5241 72.8887 35.5934 74.2078 35.5934Z"
        fill="white"
      />
      <path
        d="M183.954 41.6964C185.26 41.6964 186.318 40.6382 186.318 39.3329C186.318 38.0276 185.26 36.9695 183.954 36.9695C182.649 36.9695 181.591 38.0276 181.591 39.3329C181.591 40.6382 182.649 41.6964 183.954 41.6964Z"
        fill="white"
      />
      <path
        d="M62.0696 47.7637C63.3651 47.7637 64.4152 46.7135 64.4152 45.4181C64.4152 44.1226 63.3651 43.0724 62.0696 43.0724C60.7741 43.0724 59.7239 44.1226 59.7239 45.4181C59.7239 46.7135 60.7741 47.7637 62.0696 47.7637Z"
        fill="white"
      />
      <path
        d="M123.039 145.272C124.326 145.272 125.37 144.228 125.37 142.941C125.37 141.653 124.326 140.609 123.039 140.609C121.751 140.609 120.707 141.653 120.707 142.941C120.707 144.228 121.751 145.272 123.039 145.272Z"
        fill="white"
      />
      <path
        d="M177.862 35.5507C179.15 35.5507 180.193 34.5069 180.193 33.2193C180.193 31.9317 179.15 30.8879 177.862 30.8879C176.574 30.8879 175.531 31.9317 175.531 33.2193C175.531 34.5069 176.574 35.5507 177.862 35.5507Z"
        fill="white"
      />
      <path
        d="M275.402 96.4983C276.686 96.4983 277.727 95.4577 277.727 94.174C277.727 92.8904 276.686 91.8498 275.402 91.8498C274.119 91.8498 273.078 92.8904 273.078 94.174C273.078 95.4577 274.119 96.4983 275.402 96.4983Z"
        fill="white"
      />
      <path
        d="M226.646 65.987C227.902 65.987 228.921 64.9688 228.921 63.7127C228.921 62.4566 227.902 61.4383 226.646 61.4383C225.39 61.4383 224.372 62.4566 224.372 63.7127C224.372 64.9688 225.39 65.987 226.646 65.987Z"
        fill="white"
      />
      <path
        d="M226.654 187.886C227.908 187.886 228.924 186.869 228.924 185.615C228.924 184.361 227.908 183.344 226.654 183.344C225.399 183.344 224.383 184.361 224.383 185.615C224.383 186.869 225.399 187.886 226.654 187.886Z"
        fill="white"
      />
      <path
        d="M342.432 212.234C343.686 212.234 344.702 211.217 344.702 209.963C344.702 208.709 343.686 207.692 342.432 207.692C341.177 207.692 340.161 208.709 340.161 209.963C340.161 211.217 341.177 212.234 342.432 212.234Z"
        fill="white"
      />
      <path
        d="M147.39 65.9443C148.618 65.9443 149.614 64.9483 149.614 63.7198C149.614 62.4913 148.618 61.4954 147.39 61.4954C146.161 61.4954 145.165 62.4913 145.165 63.7198C145.165 64.9483 146.161 65.9443 147.39 65.9443Z"
        fill="white"
      />
      <path
        d="M202.235 41.5431C203.461 41.5431 204.455 40.5488 204.455 39.3222C204.455 38.0957 203.461 37.1013 202.235 37.1013C201.008 37.1013 200.014 38.0957 200.014 39.3222C200.014 40.5488 201.008 41.5431 202.235 41.5431Z"
        fill="white"
      />
      <path
        d="M37.6791 139.059C38.9037 139.059 39.8965 138.066 39.8965 136.841C39.8965 135.617 38.9037 134.624 37.6791 134.624C36.4546 134.624 35.4618 135.617 35.4618 136.841C35.4618 138.066 36.4546 139.059 37.6791 139.059Z"
        fill="white"
      />
      <path
        d="M62.0874 139.051C63.3061 139.051 64.294 138.064 64.294 136.845C64.294 135.626 63.3061 134.638 62.0874 134.638C60.8687 134.638 59.8808 135.626 59.8808 136.845C59.8808 138.064 60.8687 139.051 62.0874 139.051Z"
        fill="white"
      />
      <path
        d="M55.9631 139.037C57.1818 139.037 58.1697 138.049 58.1697 136.831C58.1697 135.612 57.1818 134.624 55.9631 134.624C54.7444 134.624 53.7565 135.612 53.7565 136.831C53.7565 138.049 54.7444 139.037 55.9631 139.037Z"
        fill="white"
      />
      <path
        d="M141.305 72.0009C142.525 72.0009 143.515 71.0114 143.515 69.7907C143.515 68.5701 142.525 67.5805 141.305 67.5805C140.084 67.5805 139.095 68.5701 139.095 69.7907C139.095 71.0114 140.084 72.0009 141.305 72.0009Z"
        fill="white"
      />
      <path
        d="M342.424 169.52C343.641 169.52 344.628 168.534 344.628 167.317C344.628 166.1 343.641 165.114 342.424 165.114C341.208 165.114 340.221 166.1 340.221 167.317C340.221 168.534 341.208 169.52 342.424 169.52Z"
        fill="white"
      />
      <path
        d="M226.632 59.795C227.849 59.795 228.835 58.8086 228.835 57.5919C228.835 56.3752 227.849 55.3888 226.632 55.3888C225.415 55.3888 224.429 56.3752 224.429 57.5919C224.429 58.8086 225.415 59.795 226.632 59.795Z"
        fill="white"
      />
      <path
        d="M80.3607 132.952C81.5794 132.952 82.5673 131.964 82.5673 130.745C82.5673 129.527 81.5794 128.539 80.3607 128.539C79.142 128.539 78.154 129.527 78.154 130.745C78.154 131.964 79.142 132.952 80.3607 132.952Z"
        fill="white"
      />
      <path
        d="M85.6188 128.742C89.0374 127.822 89.5971 132.075 87.1873 132.788C84.1394 133.69 83.1911 129.394 85.6188 128.742Z"
        fill="white"
      />
      <path
        d="M165.677 47.6033C166.888 47.6033 167.87 46.6217 167.87 45.4109C167.87 44.2001 166.888 43.2186 165.677 43.2186C164.467 43.2186 163.485 44.2001 163.485 45.4109C163.485 46.6217 164.467 47.6033 165.677 47.6033Z"
        fill="white"
      />
      <path
        d="M55.9702 145.151C57.1849 145.151 58.1697 144.166 58.1697 142.951C58.1697 141.737 57.1849 140.752 55.9702 140.752C54.7555 140.752 53.7707 141.737 53.7707 142.951C53.7707 144.166 54.7555 145.151 55.9702 145.151Z"
        fill="white"
      />
      <path
        d="M62.0553 145.119C63.2662 145.119 64.2477 144.137 64.2477 142.926C64.2477 141.716 63.2662 140.734 62.0553 140.734C60.8445 140.734 59.863 141.716 59.863 142.926C59.863 144.137 60.8445 145.119 62.0553 145.119Z"
        fill="white"
      />
      <path
        d="M183.954 11.0461C185.165 11.0461 186.147 10.0646 186.147 8.85374C186.147 7.64294 185.165 6.66138 183.954 6.66138C182.743 6.66138 181.762 7.64294 181.762 8.85374C181.762 10.0646 182.743 11.0461 183.954 11.0461Z"
        fill="white"
      />
      <path
        d="M68.1868 145.126C69.3917 145.126 70.3685 144.149 70.3685 142.944C70.3685 141.739 69.3917 140.763 68.1868 140.763C66.9819 140.763 66.0051 141.739 66.0051 142.944C66.0051 144.149 66.9819 145.126 68.1868 145.126Z"
        fill="white"
      />
      <path
        d="M43.775 139.03C44.9799 139.03 45.9566 138.053 45.9566 136.848C45.9566 135.644 44.9799 134.667 43.775 134.667C42.5701 134.667 41.5933 135.644 41.5933 136.848C41.5933 138.053 42.5701 139.03 43.775 139.03Z"
        fill="white"
      />
      <path
        d="M49.8708 139.034C51.0757 139.034 52.0525 138.057 52.0525 136.852C52.0525 135.647 51.0757 134.67 49.8708 134.67C48.6659 134.67 47.6891 135.647 47.6891 136.852C47.6891 138.057 48.6659 139.034 49.8708 139.034Z"
        fill="white"
      />
      <path
        d="M68.1547 132.952C69.3616 132.952 70.34 131.974 70.34 130.767C70.34 129.56 69.3616 128.582 68.1547 128.582C66.9479 128.582 65.9695 129.56 65.9695 130.767C65.9695 131.974 66.9479 132.952 68.1547 132.952Z"
        fill="white"
      />
      <path
        d="M25.4875 132.927C26.6924 132.927 27.6691 131.95 27.6691 130.745C27.6691 129.541 26.6924 128.564 25.4875 128.564C24.2826 128.564 23.3058 129.541 23.3058 130.745C23.3058 131.95 24.2826 132.927 25.4875 132.927Z"
        fill="white"
      />
      <path
        d="M49.8815 59.8057C51.0884 59.8057 52.0667 58.8273 52.0667 57.6204C52.0667 56.4136 51.0884 55.4352 49.8815 55.4352C48.6746 55.4352 47.6963 56.4136 47.6963 57.6204C47.6963 58.8273 48.6746 59.8057 49.8815 59.8057Z"
        fill="white"
      />
      <path
        d="M275.406 90.242C276.609 90.242 277.584 89.2669 277.584 88.0639C277.584 86.861 276.609 85.8858 275.406 85.8858C274.203 85.8858 273.228 86.861 273.228 88.0639C273.228 89.2669 274.203 90.242 275.406 90.242Z"
        fill="white"
      />
      <path
        d="M104.723 102.452C105.924 102.452 106.897 101.478 106.897 100.277C106.897 99.076 105.924 98.1025 104.723 98.1025C103.522 98.1025 102.548 99.076 102.548 100.277C102.548 101.478 103.522 102.452 104.723 102.452Z"
        fill="white"
      />
      <path
        d="M342.457 163.413C343.659 163.413 344.635 162.438 344.635 161.235C344.635 160.032 343.659 159.057 342.457 159.057C341.254 159.057 340.278 160.032 340.278 161.235C340.278 162.438 341.254 163.413 342.457 163.413Z"
        fill="white"
      />
      <path
        d="M214.408 53.6813C215.609 53.6813 216.583 52.7077 216.583 51.5068C216.583 50.3058 215.609 49.3322 214.408 49.3322C213.207 49.3322 212.234 50.3058 212.234 51.5068C212.234 52.7077 213.207 53.6813 214.408 53.6813Z"
        fill="white"
      />
      <path
        d="M55.9738 132.934C57.1728 132.934 58.1447 131.962 58.1447 130.763C58.1447 129.564 57.1728 128.592 55.9738 128.592C54.7748 128.592 53.8028 129.564 53.8028 130.763C53.8028 131.962 54.7748 132.934 55.9738 132.934Z"
        fill="white"
      />
      <path
        d="M43.7857 132.931C44.9827 132.931 45.9531 131.96 45.9531 130.763C45.9531 129.566 44.9827 128.596 43.7857 128.596C42.5886 128.596 41.6183 129.566 41.6183 130.763C41.6183 131.96 42.5886 132.931 43.7857 132.931Z"
        fill="white"
      />
      <path
        d="M62.0589 132.927C63.2559 132.927 64.2263 131.957 64.2263 130.76C64.2263 129.563 63.2559 128.592 62.0589 128.592C60.8619 128.592 59.8915 129.563 59.8915 130.76C59.8915 131.957 60.8619 132.927 62.0589 132.927Z"
        fill="white"
      />
      <path
        d="M49.8779 132.913C51.071 132.913 52.0382 131.946 52.0382 130.753C52.0382 129.56 51.071 128.592 49.8779 128.592C48.6848 128.592 47.7177 129.56 47.7177 130.753C47.7177 131.946 48.6848 132.913 49.8779 132.913Z"
        fill="white"
      />
      <path
        d="M299.793 108.49C300.976 108.49 301.935 107.531 301.935 106.348C301.935 105.165 300.976 104.205 299.793 104.205C298.61 104.205 297.65 105.165 297.65 106.348C297.65 107.531 298.61 108.49 299.793 108.49Z"
        fill="white"
      />
      <path
        d="M86.4422 138.991C87.6235 138.991 88.5811 138.033 88.5811 136.852C88.5811 135.671 87.6235 134.713 86.4422 134.713C85.261 134.713 84.3034 135.671 84.3034 136.852C84.3034 138.033 85.261 138.991 86.4422 138.991Z"
        fill="white"
      />
      <path
        d="M165.663 53.6314C166.837 53.6314 167.788 52.6802 167.788 51.5068C167.788 50.3334 166.837 49.3821 165.663 49.3821C164.49 49.3821 163.538 50.3334 163.538 51.5068C163.538 52.6802 164.49 53.6314 165.663 53.6314Z"
        fill="white"
      />
      <path
        d="M74.2399 145.055C75.4113 145.055 76.3609 144.105 76.3609 142.934C76.3609 141.762 75.4113 140.812 74.2399 140.812C73.0684 140.812 72.1188 141.762 72.1188 142.934C72.1188 144.105 73.0684 145.055 74.2399 145.055Z"
        fill="white"
      />
      <path
        d="M165.677 163.346C166.845 163.346 167.791 162.399 167.791 161.232C167.791 160.064 166.845 159.118 165.677 159.118C164.51 159.118 163.563 160.064 163.563 161.232C163.563 162.399 164.51 163.346 165.677 163.346Z"
        fill="white"
      />
      <path
        d="M196.135 41.4433C197.303 41.4433 198.249 40.4969 198.249 39.3294C198.249 38.1619 197.303 37.2154 196.135 37.2154C194.968 37.2154 194.021 38.1619 194.021 39.3294C194.021 40.4969 194.968 41.4433 196.135 41.4433Z"
        fill="white"
      />
      <path
        d="M354.645 193.782C355.802 193.782 356.741 192.844 356.741 191.686C356.741 190.528 355.802 189.59 354.645 189.59C353.487 189.59 352.549 190.528 352.549 191.686C352.549 192.844 353.487 193.782 354.645 193.782Z"
        fill="white"
      />
      <path
        d="M171.766 41.4041C172.922 41.4041 173.859 40.4672 173.859 39.3115C173.859 38.1558 172.922 37.219 171.766 37.219C170.61 37.219 169.674 38.1558 169.674 39.3115C169.674 40.4672 170.61 41.4041 171.766 41.4041Z"
        fill="white"
      />
      <path
        d="M68.1583 126.735C69.312 126.735 70.2473 125.8 70.2473 124.646C70.2473 123.492 69.312 122.557 68.1583 122.557C67.0046 122.557 66.0693 123.492 66.0693 124.646C66.0693 125.8 67.0046 126.735 68.1583 126.735Z"
        fill="white"
      />
      <path
        d="M62.066 126.742C63.2197 126.742 64.155 125.807 64.155 124.653C64.155 123.499 63.2197 122.564 62.066 122.564C60.9123 122.564 59.9771 123.499 59.9771 124.653C59.9771 125.807 60.9123 126.742 62.066 126.742Z"
        fill="white"
      />
      <path
        d="M342.453 218.151C343.603 218.151 344.535 217.219 344.535 216.069C344.535 214.92 343.603 213.987 342.453 213.987C341.303 213.987 340.371 214.92 340.371 216.069C340.371 217.219 341.303 218.151 342.453 218.151Z"
        fill="white"
      />
      <path
        d="M123.014 96.2487C124.163 96.2487 125.096 95.3167 125.096 94.1669C125.096 93.0171 124.163 92.085 123.014 92.085C121.864 92.085 120.932 93.0171 120.932 94.1669C120.932 95.3167 121.864 96.2487 123.014 96.2487Z"
        fill="white"
      />
      <path
        d="M171.77 47.4999C172.919 47.4999 173.852 46.5678 173.852 45.4181C173.852 44.2683 172.919 43.3362 171.77 43.3362C170.62 43.3362 169.688 44.2683 169.688 45.4181C169.688 46.5678 170.62 47.4999 171.77 47.4999Z"
        fill="white"
      />
      <path
        d="M342.446 224.229C343.594 224.229 344.524 223.299 344.524 222.151C344.524 221.003 343.594 220.073 342.446 220.073C341.298 220.073 340.368 221.003 340.368 222.151C340.368 223.299 341.298 224.229 342.446 224.229Z"
        fill="white"
      />
      <path
        d="M74.2506 151.126C75.4004 151.126 76.3324 150.193 76.3324 149.044C76.3324 147.894 75.4004 146.962 74.2506 146.962C73.1008 146.962 72.1687 147.894 72.1687 149.044C72.1687 150.193 73.1008 151.126 74.2506 151.126Z"
        fill="white"
      />
      <path
        d="M92.5416 138.93C93.6894 138.93 94.6199 138 94.6199 136.852C94.6199 135.704 93.6894 134.774 92.5416 134.774C91.3938 134.774 90.4634 135.704 90.4634 136.852C90.4634 138 91.3938 138.93 92.5416 138.93Z"
        fill="white"
      />
      <path
        d="M55.9666 126.724C57.1144 126.724 58.0449 125.794 58.0449 124.646C58.0449 123.498 57.1144 122.568 55.9666 122.568C54.8188 122.568 53.8883 123.498 53.8883 124.646C53.8883 125.794 54.8188 126.724 55.9666 126.724Z"
        fill="white"
      />
      <path
        d="M190.079 47.4963C191.224 47.4963 192.153 46.5675 192.153 45.4216C192.153 44.2758 191.224 43.3469 190.079 43.3469C188.933 43.3469 188.004 44.2758 188.004 45.4216C188.004 46.5675 188.933 47.4963 190.079 47.4963Z"
        fill="white"
      />
      <path
        d="M37.6791 77.9577C38.825 77.9577 39.7539 77.0288 39.7539 75.883C39.7539 74.7371 38.825 73.8082 37.6791 73.8082C36.5333 73.8082 35.6044 74.7371 35.6044 75.883C35.6044 77.0288 36.5333 77.9577 37.6791 77.9577Z"
        fill="white"
      />
      <path
        d="M202.249 193.775C203.389 193.775 204.313 192.851 204.313 191.711C204.313 190.571 203.389 189.647 202.249 189.647C201.109 189.647 200.185 190.571 200.185 191.711C200.185 192.851 201.109 193.775 202.249 193.775Z"
        fill="white"
      />
      <path
        d="M74.2577 126.735C75.3996 126.735 76.3253 125.809 76.3253 124.667C76.3253 123.526 75.3996 122.6 74.2577 122.6C73.1158 122.6 72.1901 123.526 72.1901 124.667C72.1901 125.809 73.1158 126.735 74.2577 126.735Z"
        fill="white"
      />
      <path
        d="M80.35 23.0916C81.484 23.0916 82.4033 22.1723 82.4033 21.0383C82.4033 19.9043 81.484 18.985 80.35 18.985C79.216 18.985 78.2966 19.9043 78.2966 21.0383C78.2966 22.1723 79.216 23.0916 80.35 23.0916Z"
        fill="white"
      />
      <path
        d="M196.153 47.4536C197.287 47.4536 198.206 46.5343 198.206 45.4002C198.206 44.2662 197.287 43.3469 196.153 43.3469C195.019 43.3469 194.1 44.2662 194.1 45.4002C194.1 46.5343 195.019 47.4536 196.153 47.4536Z"
        fill="white"
      />
      <path
        d="M55.9595 53.5708C57.0935 53.5708 58.0128 52.6515 58.0128 51.5174C58.0128 50.3834 57.0935 49.4641 55.9595 49.4641C54.8255 49.4641 53.9062 50.3834 53.9062 51.5174C53.9062 52.6515 54.8255 53.5708 55.9595 53.5708Z"
        fill="white"
      />
      <path
        d="M80.3393 151.083C81.4713 151.083 82.3891 150.165 82.3891 149.033C82.3891 147.901 81.4713 146.983 80.3393 146.983C79.2072 146.983 78.2895 147.901 78.2895 149.033C78.2895 150.165 79.2072 151.083 80.3393 151.083Z"
        fill="white"
      />
      <path
        d="M98.6054 138.88C99.7256 138.88 100.634 137.972 100.634 136.852C100.634 135.732 99.7256 134.824 98.6054 134.824C97.4851 134.824 96.577 135.732 96.577 136.852C96.577 137.972 97.4851 138.88 98.6054 138.88Z"
        fill="white"
      />
      <path
        d="M159.582 53.5351C160.702 53.5351 161.61 52.627 161.61 51.5068C161.61 50.3865 160.702 49.4784 159.582 49.4784C158.461 49.4784 157.553 50.3865 157.553 51.5068C157.553 52.627 158.461 53.5351 159.582 53.5351Z"
        fill="white"
      />
      <path
        d="M208.338 47.4536C209.452 47.4536 210.355 46.5502 210.355 45.4359C210.355 44.3215 209.452 43.4182 208.338 43.4182C207.223 43.4182 206.32 44.3215 206.32 45.4359C206.32 46.5502 207.223 47.4536 208.338 47.4536Z"
        fill="white"
      />
      <path
        d="M19.3988 126.685C20.5111 126.685 21.4129 125.783 21.4129 124.671C21.4129 123.559 20.5111 122.657 19.3988 122.657C18.2864 122.657 17.3846 123.559 17.3846 124.671C17.3846 125.783 18.2864 126.685 19.3988 126.685Z"
        fill="white"
      />
      <path
        d="M196.16 35.2191C197.265 35.2191 198.16 34.3237 198.16 33.2193C198.16 32.1148 197.265 31.2194 196.16 31.2194C195.056 31.2194 194.16 32.1148 194.16 33.2193C194.16 34.3237 195.056 35.2191 196.16 35.2191Z"
        fill="white"
      />
      <path
        d="M62.0839 65.7232C63.1884 65.7232 64.0837 64.8279 64.0837 63.7234C64.0837 62.6189 63.1884 61.7235 62.0839 61.7235C60.9794 61.7235 60.084 62.6189 60.084 63.7234C60.084 64.8279 60.9794 65.7232 62.0839 65.7232Z"
        fill="white"
      />
      <path
        d="M196.167 16.9388C197.27 16.9388 198.164 16.045 198.164 14.9425C198.164 13.8399 197.27 12.9462 196.167 12.9462C195.065 12.9462 194.171 13.8399 194.171 14.9425C194.171 16.045 195.065 16.9388 196.167 16.9388Z"
        fill="white"
      />
      <path
        d="M86.4601 151.033C87.5508 151.033 88.435 150.149 88.435 149.058C88.435 147.967 87.5508 147.083 86.4601 147.083C85.3693 147.083 84.4851 147.967 84.4851 149.058C84.4851 150.149 85.3693 151.033 86.4601 151.033Z"
        fill="white"
      />
      <path
        d="M354.637 169.295C355.728 169.295 356.612 168.411 356.612 167.32C356.612 166.23 355.728 165.346 354.637 165.346C353.547 165.346 352.663 166.23 352.663 167.32C352.663 168.411 353.547 169.295 354.637 169.295Z"
        fill="white"
      />
      <path
        d="M183.986 187.583C185.077 187.583 185.961 186.699 185.961 185.608C185.961 184.517 185.077 183.633 183.986 183.633C182.896 183.633 182.011 184.517 182.011 185.608C182.011 186.699 182.896 187.583 183.986 187.583Z"
        fill="white"
      />
      <path
        d="M104.723 138.795C105.809 138.795 106.69 137.914 106.69 136.827C106.69 135.74 105.809 134.859 104.723 134.859C103.636 134.859 102.755 135.74 102.755 136.827C102.755 137.914 103.636 138.795 104.723 138.795Z"
        fill="white"
      />
      <path
        d="M342.424 205.835C343.505 205.835 344.382 204.959 344.382 203.878C344.382 202.797 343.505 201.921 342.424 201.921C341.344 201.921 340.467 202.797 340.467 203.878C340.467 204.959 341.344 205.835 342.424 205.835Z"
        fill="white"
      />
      <path
        d="M336.354 150.969C337.432 150.969 338.307 150.094 338.307 149.015C338.307 147.936 337.432 147.062 336.354 147.062C335.275 147.062 334.4 147.936 334.4 149.015C334.4 150.094 335.275 150.969 336.354 150.969Z"
        fill="white"
      />
      <path
        d="M68.1797 47.3644C69.2546 47.3644 70.1261 46.493 70.1261 45.418C70.1261 44.3431 69.2546 43.4717 68.1797 43.4717C67.1047 43.4717 66.2333 44.3431 66.2333 45.418C66.2333 46.493 67.1047 47.3644 68.1797 47.3644Z"
        fill="white"
      />
      <path
        d="M7.2071 108.319C8.28206 108.319 9.15349 107.448 9.15349 106.373C9.15349 105.298 8.28206 104.426 7.2071 104.426C6.13214 104.426 5.26071 105.298 5.26071 106.373C5.26071 107.448 6.13214 108.319 7.2071 108.319Z"
        fill="white"
      />
      <path
        d="M177.869 41.2864C178.942 41.2864 179.812 40.4166 179.812 39.3436C179.812 38.2706 178.942 37.4008 177.869 37.4008C176.796 37.4008 175.926 38.2706 175.926 39.3436C175.926 40.4166 176.796 41.2864 177.869 41.2864Z"
        fill="white"
      />
      <path
        d="M330.243 138.763C331.316 138.763 332.186 137.893 332.186 136.82C332.186 135.747 331.316 134.877 330.243 134.877C329.171 134.877 328.301 135.747 328.301 136.82C328.301 137.893 329.171 138.763 330.243 138.763Z"
        fill="white"
      />
      <path
        d="M43.7857 53.446C44.8567 53.446 45.7249 52.5778 45.7249 51.5068C45.7249 50.4357 44.8567 49.5675 43.7857 49.5675C42.7146 49.5675 41.8464 50.4357 41.8464 51.5068C41.8464 52.5778 42.7146 53.446 43.7857 53.446Z"
        fill="white"
      />
      <path
        d="M196.157 22.9455C197.22 22.9455 198.082 22.0836 198.082 21.0205C198.082 19.9573 197.22 19.0955 196.157 19.0955C195.093 19.0955 194.232 19.9573 194.232 21.0205C194.232 22.0836 195.093 22.9455 196.157 22.9455Z"
        fill="white"
      />
      <path
        d="M257.097 83.8931C258.15 83.8931 259.004 83.0392 259.004 81.9859C259.004 80.9326 258.15 80.0788 257.097 80.0788C256.044 80.0788 255.19 80.9326 255.19 81.9859C255.19 83.0392 256.044 83.8931 257.097 83.8931Z"
        fill="white"
      />
      <path
        d="M110.833 102.181C111.89 102.181 112.747 101.324 112.747 100.266C112.747 99.2091 111.89 98.352 110.833 98.352C109.775 98.352 108.918 99.2091 108.918 100.266C108.918 101.324 109.775 102.181 110.833 102.181Z"
        fill="white"
      />
      <path
        d="M49.8744 126.568C50.9296 126.568 51.7851 125.712 51.7851 124.657C51.7851 123.601 50.9296 122.746 49.8744 122.746C48.8191 122.746 47.9636 123.601 47.9636 124.657C47.9636 125.712 48.8191 126.568 49.8744 126.568Z"
        fill="white"
      />
      <path
        d="M342.449 175.313C343.505 175.313 344.36 174.457 344.36 173.402C344.36 172.347 343.505 171.491 342.449 171.491C341.394 171.491 340.539 172.347 340.539 173.402C340.539 174.457 341.394 175.313 342.449 175.313Z"
        fill="white"
      />
      <path
        d="M80.3607 144.841C81.412 144.841 82.2643 143.988 82.2643 142.937C82.2643 141.886 81.412 141.034 80.3607 141.034C79.3093 141.034 78.457 141.886 78.457 142.937C78.457 143.988 79.3093 144.841 80.3607 144.841Z"
        fill="white"
      />
      <path
        d="M159.596 59.524C160.647 59.524 161.499 58.6718 161.499 57.6204C161.499 56.5691 160.647 55.7168 159.596 55.7168C158.544 55.7168 157.692 56.5691 157.692 57.6204C157.692 58.6718 158.544 59.524 159.596 59.524Z"
        fill="white"
      />
      <path
        d="M62.0518 35.1015C63.0992 35.1015 63.9483 34.2524 63.9483 33.205C63.9483 32.1576 63.0992 31.3085 62.0518 31.3085C61.0044 31.3085 60.1553 32.1576 60.1553 33.205C60.1553 34.2524 61.0044 35.1015 62.0518 35.1015Z"
        fill="white"
      />
      <path
        d="M62.0625 71.6979C63.1079 71.6979 63.9554 70.8504 63.9554 69.805C63.9554 68.7595 63.1079 67.912 62.0625 67.912C61.017 67.912 60.1696 68.7595 60.1696 69.805C60.1696 70.8504 61.017 71.6979 62.0625 71.6979Z"
        fill="white"
      />
      <path
        d="M183.968 35.1015C185.014 35.1015 185.861 34.254 185.861 33.2086C185.861 32.1631 185.014 31.3157 183.968 31.3157C182.923 31.3157 182.076 32.1631 182.076 33.2086C182.076 34.254 182.923 35.1015 183.968 35.1015Z"
        fill="white"
      />
      <path
        d="M55.9738 120.45C57.0153 120.45 57.8596 119.606 57.8596 118.565C57.8596 117.523 57.0153 116.679 55.9738 116.679C54.9323 116.679 54.088 117.523 54.088 118.565C54.088 119.606 54.9323 120.45 55.9738 120.45Z"
        fill="white"
      />
      <path
        d="M98.6696 144.802C99.7051 144.802 100.545 143.962 100.545 142.926C100.545 141.891 99.7051 141.051 98.6696 141.051C97.634 141.051 96.7945 141.891 96.7945 142.926C96.7945 143.962 97.634 144.802 98.6696 144.802Z"
        fill="white"
      />
      <path
        d="M55.9809 41.2044C57.0184 41.2044 57.8596 40.3633 57.8596 39.3258C57.8596 38.2882 57.0184 37.4471 55.9809 37.4471C54.9433 37.4471 54.1022 38.2882 54.1022 39.3258C54.1022 40.3633 54.9433 41.2044 55.9809 41.2044Z"
        fill="white"
      />
      <path
        d="M116.939 144.816C117.977 144.816 118.818 143.975 118.818 142.937C118.818 141.9 117.977 141.058 116.939 141.058C115.902 141.058 115.061 141.9 115.061 142.937C115.061 143.975 115.902 144.816 116.939 144.816Z"
        fill="white"
      />
      <path
        d="M74.2078 29.027C75.2453 29.027 76.0865 28.1859 76.0865 27.1484C76.0865 26.1108 75.2453 25.2697 74.2078 25.2697C73.1702 25.2697 72.3291 26.1108 72.3291 27.1484C72.3291 28.1859 73.1702 29.027 74.2078 29.027Z"
        fill="white"
      />
      <path
        d="M92.5345 150.933C93.5681 150.933 94.406 150.095 94.406 149.061C94.406 148.028 93.5681 147.19 92.5345 147.19C91.5009 147.19 90.663 148.028 90.663 149.061C90.663 150.095 91.5009 150.933 92.5345 150.933Z"
        fill="white"
      />
      <path
        d="M55.9702 59.4884C57.0019 59.4884 57.8382 58.6521 57.8382 57.6204C57.8382 56.5888 57.0019 55.7525 55.9702 55.7525C54.9386 55.7525 54.1022 56.5888 54.1022 57.6204C54.1022 58.6521 54.9386 59.4884 55.9702 59.4884Z"
        fill="white"
      />
      <path
        d="M62.066 120.45C63.0977 120.45 63.934 119.614 63.934 118.582C63.934 117.551 63.0977 116.714 62.066 116.714C61.0344 116.714 60.1981 117.551 60.1981 118.582C60.1981 119.614 61.0344 120.45 62.066 120.45Z"
        fill="white"
      />
      <path
        d="M49.8851 53.3747C50.9108 53.3747 51.7423 52.5432 51.7423 51.5174C51.7423 50.4917 50.9108 49.6602 49.8851 49.6602C48.8593 49.6602 48.0278 50.4917 48.0278 51.5174C48.0278 52.5432 48.8593 53.3747 49.8851 53.3747Z"
        fill="white"
      />
      <path
        d="M348.524 193.568C349.554 193.568 350.388 192.733 350.388 191.704C350.388 190.674 349.554 189.839 348.524 189.839C347.494 189.839 346.659 190.674 346.659 191.704C346.659 192.733 347.494 193.568 348.524 193.568Z"
        fill="white"
      />
      <path
        d="M7.2071 102.145C8.23284 102.145 9.06437 101.313 9.06437 100.288C9.06437 99.262 8.23284 98.4304 7.2071 98.4304C6.18136 98.4304 5.34983 99.262 5.34983 100.288C5.34983 101.313 6.18136 102.145 7.2071 102.145Z"
        fill="white"
      />
      <path
        d="M202.263 35.0337C203.287 35.0337 204.117 34.2038 204.117 33.18C204.117 32.1563 203.287 31.3263 202.263 31.3263C201.239 31.3263 200.409 32.1563 200.409 33.18C200.409 34.2038 201.239 35.0337 202.263 35.0337Z"
        fill="white"
      />
      <path
        d="M251.026 211.838C252.048 211.838 252.876 211.01 252.876 209.988C252.876 208.966 252.048 208.138 251.026 208.138C250.004 208.138 249.176 208.966 249.176 209.988C249.176 211.01 250.004 211.838 251.026 211.838Z"
        fill="white"
      />
      <path
        d="M244.945 199.65C245.962 199.65 246.788 198.825 246.788 197.807C246.788 196.789 245.962 195.964 244.945 195.964C243.927 195.964 243.102 196.789 243.102 197.807C243.102 198.825 243.927 199.65 244.945 199.65Z"
        fill="white"
      />
      <path
        d="M92.5309 156.958C93.5488 156.958 94.374 156.132 94.374 155.115C94.374 154.097 93.5488 153.272 92.5309 153.272C91.5131 153.272 90.6879 154.097 90.6879 155.115C90.6879 156.132 91.5131 156.958 92.5309 156.958Z"
        fill="white"
      />
      <path
        d="M153.489 59.4313C154.499 59.4313 155.318 58.6126 155.318 57.6026C155.318 56.5926 154.499 55.7738 153.489 55.7738C152.479 55.7738 151.661 56.5926 151.661 57.6026C151.661 58.6126 152.479 59.4313 153.489 59.4313Z"
        fill="white"
      />
      <path
        d="M183.958 4.55815C184.97 4.55815 185.79 3.7378 185.79 2.72584C185.79 1.71388 184.97 0.893524 183.958 0.893524C182.946 0.893524 182.125 1.71388 182.125 2.72584C182.125 3.7378 182.946 4.55815 183.958 4.55815Z"
        fill="white"
      />
      <path
        d="M257.108 77.7153C258.116 77.7153 258.933 76.8981 258.933 75.8901C258.933 74.8821 258.116 74.0649 257.108 74.0649C256.1 74.0649 255.283 74.8821 255.283 75.8901C255.283 76.8981 256.1 77.7153 257.108 77.7153Z"
        fill="white"
      />
      <path
        d="M98.6695 95.9992C99.6736 95.9992 100.488 95.1852 100.488 94.1812C100.488 93.1771 99.6736 92.3631 98.6695 92.3631C97.6655 92.3631 96.8515 93.1771 96.8515 94.1812C96.8515 95.1852 97.6655 95.9992 98.6695 95.9992Z"
        fill="white"
      />
      <path
        d="M110.804 144.752C111.808 144.752 112.622 143.938 112.622 142.934C112.622 141.929 111.808 141.115 110.804 141.115C109.8 141.115 108.986 141.929 108.986 142.934C108.986 143.938 109.8 144.752 110.804 144.752Z"
        fill="white"
      />
      <path
        d="M62.066 83.8111C63.0701 83.8111 63.8841 82.9971 63.8841 81.9931C63.8841 80.989 63.0701 80.175 62.066 80.175C61.062 80.175 60.248 80.989 60.248 81.9931C60.248 82.9971 61.062 83.8111 62.066 83.8111Z"
        fill="white"
      />
      <path
        d="M104.723 89.8962C105.727 89.8962 106.541 89.0823 106.541 88.0782C106.541 87.0741 105.727 86.2601 104.723 86.2601C103.719 86.2601 102.905 87.0741 102.905 88.0782C102.905 89.0823 103.719 89.8962 104.723 89.8962Z"
        fill="white"
      />
      <path
        d="M37.6791 126.482C38.6813 126.482 39.4936 125.67 39.4936 124.667C39.4936 123.665 38.6813 122.853 37.6791 122.853C36.677 122.853 35.8647 123.665 35.8647 124.667C35.8647 125.67 36.677 126.482 37.6791 126.482Z"
        fill="white"
      />
      <path
        d="M348.567 199.6C349.567 199.6 350.378 198.789 350.378 197.789C350.378 196.789 349.567 195.978 348.567 195.978C347.566 195.978 346.756 196.789 346.756 197.789C346.756 198.789 347.566 199.6 348.567 199.6Z"
        fill="white"
      />
      <path
        d="M177.865 4.54033C178.868 4.54033 179.68 3.72795 179.68 2.72584C179.68 1.72372 178.868 0.911339 177.865 0.911339C176.863 0.911339 176.051 1.72372 176.051 2.72584C176.051 3.72795 176.863 4.54033 177.865 4.54033Z"
        fill="white"
      />
      <path
        d="M104.748 144.766C105.75 144.766 106.562 143.954 106.562 142.951C106.562 141.949 105.75 141.137 104.748 141.137C103.745 141.137 102.933 141.949 102.933 142.951C102.933 143.954 103.745 144.766 104.748 144.766Z"
        fill="white"
      />
      <path
        d="M183.968 47.2112C184.967 47.2112 185.776 46.402 185.776 45.4038C185.776 44.4056 184.967 43.5964 183.968 43.5964C182.97 43.5964 182.161 44.4056 182.161 45.4038C182.161 46.402 182.97 47.2112 183.968 47.2112Z"
        fill="white"
      />
      <path
        d="M98.6161 150.833C99.6103 150.833 100.416 150.027 100.416 149.033C100.416 148.039 99.6103 147.233 98.6161 147.233C97.6218 147.233 96.8158 148.039 96.8158 149.033C96.8158 150.027 97.6218 150.833 98.6161 150.833Z"
        fill="white"
      />
      <path
        d="M263.214 211.767C264.207 211.767 265.011 210.962 265.011 209.97C265.011 208.978 264.207 208.173 263.214 208.173C262.222 208.173 261.418 208.978 261.418 209.97C261.418 210.962 262.222 211.767 263.214 211.767Z"
        fill="white"
      />
      <path
        d="M68.1797 34.9981C69.17 34.9981 69.9728 34.1953 69.9728 33.205C69.9728 32.2147 69.17 31.4119 68.1797 31.4119C67.1894 31.4119 66.3866 32.2147 66.3866 33.205C66.3866 34.1953 67.1894 34.9981 68.1797 34.9981Z"
        fill="white"
      />
      <path
        d="M159.571 71.5802C160.561 71.5802 161.364 70.7774 161.364 69.7871C161.364 68.7968 160.561 67.994 159.571 67.994C158.581 67.994 157.778 68.7968 157.778 69.7871C157.778 70.7774 158.581 71.5802 159.571 71.5802Z"
        fill="white"
      />
      <path
        d="M135.22 71.5838C136.206 71.5838 137.006 70.7842 137.006 69.7978C137.006 68.8115 136.206 68.0119 135.22 68.0119C134.233 68.0119 133.434 68.8115 133.434 69.7978C133.434 70.7842 134.233 71.5838 135.22 71.5838Z"
        fill="white"
      />
      <path
        d="M110.826 169.103C111.812 169.103 112.612 168.303 112.612 167.317C112.612 166.331 111.812 165.531 110.826 165.531C109.839 165.531 109.04 166.331 109.04 167.317C109.04 168.303 109.839 169.103 110.826 169.103Z"
        fill="white"
      />
      <path
        d="M147.393 156.893C148.374 156.893 149.169 156.099 149.169 155.118C149.169 154.138 148.374 153.343 147.393 153.343C146.413 153.343 145.618 154.138 145.618 155.118C145.618 156.099 146.413 156.893 147.393 156.893Z"
        fill="white"
      />
      <path
        d="M49.8744 47.1933C50.8548 47.1933 51.6497 46.3985 51.6497 45.418C51.6497 44.4376 50.8548 43.6428 49.8744 43.6428C48.8939 43.6428 48.0991 44.4376 48.0991 45.418C48.0991 46.3985 48.8939 47.1933 49.8744 47.1933Z"
        fill="white"
      />
      <path
        d="M55.9524 65.4951C56.9309 65.4951 57.7241 64.7019 57.7241 63.7234C57.7241 62.7449 56.9309 61.9517 55.9524 61.9517C54.9739 61.9517 54.1807 62.7449 54.1807 63.7234C54.1807 64.7019 54.9739 65.4951 55.9524 65.4951Z"
        fill="white"
      />
      <path
        d="M68.1797 41.0975C69.1582 41.0975 69.9514 40.3043 69.9514 39.3258C69.9514 38.3473 69.1582 37.5541 68.1797 37.5541C67.2012 37.5541 66.408 38.3473 66.408 39.3258C66.408 40.3043 67.2012 41.0975 68.1797 41.0975Z"
        fill="white"
      />
      <path
        d="M98.6696 102.052C99.648 102.052 100.441 101.259 100.441 100.281C100.441 99.3021 99.648 98.5089 98.6696 98.5089C97.6911 98.5089 96.8978 99.3021 96.8978 100.281C96.8978 101.259 97.6911 102.052 98.6696 102.052Z"
        fill="white"
      />
      <path
        d="M98.6232 156.915C99.6017 156.915 100.395 156.122 100.395 155.143C100.395 154.165 99.6017 153.371 98.6232 153.371C97.6447 153.371 96.8515 154.165 96.8515 155.143C96.8515 156.122 97.6447 156.915 98.6232 156.915Z"
        fill="white"
      />
      <path
        d="M196.185 10.5791C197.154 10.5791 197.939 9.79388 197.939 8.82524C197.939 7.85659 197.154 7.07134 196.185 7.07134C195.216 7.07134 194.431 7.85659 194.431 8.82524C194.431 9.79388 195.216 10.5791 196.185 10.5791Z"
        fill="white"
      />
      <path
        d="M196.153 28.8666C197.114 28.8666 197.893 28.0878 197.893 27.127C197.893 26.1662 197.114 25.3874 196.153 25.3874C195.192 25.3874 194.413 26.1662 194.413 27.127C194.413 28.0878 195.192 28.8666 196.153 28.8666Z"
        fill="white"
      />
      <path
        d="M135.198 150.762C136.153 150.762 136.927 149.988 136.927 149.033C136.927 148.078 136.153 147.304 135.198 147.304C134.243 147.304 133.469 148.078 133.469 149.033C133.469 149.988 134.243 150.762 135.198 150.762Z"
        fill="white"
      />
      <path
        d="M165.688 65.4416C166.639 65.4416 167.41 64.6707 167.41 63.7198C167.41 62.7689 166.639 61.998 165.688 61.998C164.737 61.998 163.966 62.7689 163.966 63.7198C163.966 64.6707 164.737 65.4416 165.688 65.4416Z"
        fill="white"
      />
      <path
        d="M232.717 16.6678C233.672 16.6678 234.446 15.8937 234.446 14.9389C234.446 13.984 233.672 13.2099 232.717 13.2099C231.762 13.2099 230.988 13.984 230.988 14.9389C230.988 15.8937 231.762 16.6678 232.717 16.6678Z"
        fill="white"
      />
      <path
        d="M129.11 150.744C130.057 150.744 130.824 149.976 130.824 149.029C130.824 148.082 130.057 147.315 129.11 147.315C128.163 147.315 127.395 148.082 127.395 149.029C127.395 149.976 128.163 150.744 129.11 150.744Z"
        fill="white"
      />
      <path
        d="M43.7714 126.357C44.7145 126.357 45.479 125.593 45.479 124.65C45.479 123.707 44.7145 122.942 43.7714 122.942C42.8284 122.942 42.0639 123.707 42.0639 124.65C42.0639 125.593 42.8284 126.357 43.7714 126.357Z"
        fill="white"
      />
      <path
        d="M104.755 150.719C105.694 150.719 106.455 149.958 106.455 149.019C106.455 148.08 105.694 147.318 104.755 147.318C103.816 147.318 103.054 148.08 103.054 149.019C103.054 149.958 103.816 150.719 104.755 150.719Z"
        fill="white"
      />
      <path
        d="M208.338 181.184C209.277 181.184 210.038 180.423 210.038 179.484C210.038 178.544 209.277 177.783 208.338 177.783C207.398 177.783 206.637 178.544 206.637 179.484C206.637 180.423 207.398 181.184 208.338 181.184Z"
        fill="white"
      />
      <path
        d="M324.155 132.428C325.096 132.428 325.859 131.665 325.859 130.724C325.859 129.783 325.096 129.02 324.155 129.02C323.214 129.02 322.451 129.783 322.451 130.724C322.451 131.665 323.214 132.428 324.155 132.428Z"
        fill="white"
      />
      <path
        d="M348.552 217.741C349.478 217.741 350.228 216.991 350.228 216.066C350.228 215.14 349.478 214.39 348.552 214.39C347.627 214.39 346.877 215.14 346.877 216.066C346.877 216.991 347.627 217.741 348.552 217.741Z"
        fill="white"
      />
      <path
        d="M68.1654 120.233C69.0908 120.233 69.8409 119.483 69.8409 118.557C69.8409 117.632 69.0908 116.882 68.1654 116.882C67.2401 116.882 66.49 117.632 66.49 118.557C66.49 119.483 67.2401 120.233 68.1654 120.233Z"
        fill="white"
      />
      <path
        d="M208.338 4.39773C209.259 4.39773 210.006 3.65079 210.006 2.7294C210.006 1.808 209.259 1.06107 208.338 1.06107C207.416 1.06107 206.669 1.808 206.669 2.7294C206.669 3.65079 207.416 4.39773 208.338 4.39773Z"
        fill="white"
      />
      <path
        d="M55.9702 47.0864C56.8916 47.0864 57.6385 46.3395 57.6385 45.4181C57.6385 44.4967 56.8916 43.7497 55.9702 43.7497C55.0488 43.7497 54.3019 44.4967 54.3019 45.4181C54.3019 46.3395 55.0488 47.0864 55.9702 47.0864Z"
        fill="white"
      />
      <path
        d="M92.5238 132.432C93.4413 132.432 94.185 131.688 94.185 130.77C94.185 129.853 93.4413 129.109 92.5238 129.109C91.6064 129.109 90.8626 129.853 90.8626 130.77C90.8626 131.688 91.6064 132.432 92.5238 132.432Z"
        fill="white"
      />
      <path
        d="M177.876 168.957C178.792 168.957 179.534 168.215 179.534 167.299C179.534 166.384 178.792 165.641 177.876 165.641C176.961 165.641 176.219 166.384 176.219 167.299C176.219 168.215 176.961 168.957 177.876 168.957Z"
        fill="white"
      />
      <path
        d="M13.2851 132.403C14.2006 132.403 14.9427 131.661 14.9427 130.745C14.9427 129.83 14.2006 129.088 13.2851 129.088C12.3696 129.088 11.6275 129.83 11.6275 130.745C11.6275 131.661 12.3696 132.403 13.2851 132.403Z"
        fill="white"
      />
      <path
        d="M269.314 223.816C270.227 223.816 270.968 223.075 270.968 222.162C270.968 221.248 270.227 220.508 269.314 220.508C268.4 220.508 267.66 221.248 267.66 222.162C267.66 223.075 268.4 223.816 269.314 223.816Z"
        fill="white"
      />
      <path
        d="M31.5726 114.112C32.4842 114.112 33.2231 113.373 33.2231 112.462C33.2231 111.55 32.4842 110.811 31.5726 110.811C30.6611 110.811 29.9221 111.55 29.9221 112.462C29.9221 113.373 30.6611 114.112 31.5726 114.112Z"
        fill="white"
      />
      <path
        d="M171.791 59.2781C172.703 59.2781 173.442 58.5391 173.442 57.6275C173.442 56.716 172.703 55.977 171.791 55.977C170.879 55.977 170.141 56.716 170.141 57.6275C170.141 58.5391 170.879 59.2781 171.791 59.2781Z"
        fill="white"
      />
      <path
        d="M190.061 28.7882C190.968 28.7882 191.704 28.0524 191.704 27.1448C191.704 26.2372 190.968 25.5014 190.061 25.5014C189.153 25.5014 188.417 26.2372 188.417 27.1448C188.417 28.0524 189.153 28.7882 190.061 28.7882Z"
        fill="white"
      />
      <path
        d="M43.7465 65.3596C44.6501 65.3596 45.3827 64.6271 45.3827 63.7234C45.3827 62.8197 44.6501 62.0871 43.7465 62.0871C42.8428 62.0871 42.1102 62.8197 42.1102 63.7234C42.1102 64.6271 42.8428 65.3596 43.7465 65.3596Z"
        fill="white"
      />
      <path
        d="M68.1547 150.694C69.0624 150.694 69.7981 149.958 69.7981 149.051C69.7981 148.143 69.0624 147.407 68.1547 147.407C67.2471 147.407 66.5114 148.143 66.5114 149.051C66.5114 149.958 67.2471 150.694 68.1547 150.694Z"
        fill="white"
      />
      <path
        d="M220.561 199.411C221.463 199.411 222.194 198.68 222.194 197.778C222.194 196.877 221.463 196.146 220.561 196.146C219.66 196.146 218.929 196.877 218.929 197.778C218.929 198.68 219.66 199.411 220.561 199.411Z"
        fill="white"
      />
      <path
        d="M348.52 187.216C349.422 187.216 350.153 186.485 350.153 185.583C350.153 184.681 349.422 183.95 348.52 183.95C347.619 183.95 346.888 184.681 346.888 185.583C346.888 186.485 347.619 187.216 348.52 187.216Z"
        fill="white"
      />
      <path
        d="M214.437 47.0329C215.341 47.0329 216.073 46.3003 216.073 45.3967C216.073 44.493 215.341 43.7604 214.437 43.7604C213.533 43.7604 212.801 44.493 212.801 45.3967C212.801 46.3003 213.533 47.0329 214.437 47.0329Z"
        fill="white"
      />
      <path
        d="M226.646 205.503C227.544 205.503 228.272 204.775 228.272 203.878C228.272 202.98 227.544 202.252 226.646 202.252C225.749 202.252 225.021 202.98 225.021 203.878C225.021 204.775 225.749 205.503 226.646 205.503Z"
        fill="white"
      />
      <path
        d="M202.249 4.33713C203.147 4.33713 203.874 3.60935 203.874 2.71158C203.874 1.81381 203.147 1.08602 202.249 1.08602C201.351 1.08602 200.623 1.81381 200.623 2.71158C200.623 3.60935 201.351 4.33713 202.249 4.33713Z"
        fill="white"
      />
      <path
        d="M202.245 22.6639C203.141 22.6639 203.867 21.9377 203.867 21.0419C203.867 20.1461 203.141 19.4199 202.245 19.4199C201.349 19.4199 200.623 20.1461 200.623 21.0419C200.623 21.9377 201.349 22.6639 202.245 22.6639Z"
        fill="white"
      />
      <path
        d="M74.2078 89.7109C75.1056 89.7109 75.8334 88.9831 75.8334 88.0853C75.8334 87.1876 75.1056 86.4598 74.2078 86.4598C73.31 86.4598 72.5822 87.1876 72.5822 88.0853C72.5822 88.9831 73.31 89.7109 74.2078 89.7109Z"
        fill="white"
      />
      <path
        d="M202.249 10.4508C203.147 10.4508 203.874 9.723 203.874 8.82523C203.874 7.92746 203.147 7.19968 202.249 7.19968C201.351 7.19968 200.623 7.92746 200.623 8.82523C200.623 9.723 201.351 10.4508 202.249 10.4508Z"
        fill="white"
      />
      <path
        d="M141.298 65.2919C142.193 65.2919 142.92 64.5657 142.92 63.6699C142.92 62.7741 142.193 62.0479 141.298 62.0479C140.402 62.0479 139.676 62.7741 139.676 63.6699C139.676 64.5657 140.402 65.2919 141.298 65.2919Z"
        fill="white"
      />
      <path
        d="M74.2078 95.7889C75.1056 95.7889 75.8334 95.0611 75.8334 94.1633C75.8334 93.2656 75.1056 92.5378 74.2078 92.5378C73.31 92.5378 72.5822 93.2656 72.5822 94.1633C72.5822 95.0611 73.31 95.7889 74.2078 95.7889Z"
        fill="white"
      />
      <path
        d="M190.071 40.9406C190.967 40.9406 191.693 40.2145 191.693 39.3187C191.693 38.4229 190.967 37.6967 190.071 37.6967C189.176 37.6967 188.449 38.4229 188.449 39.3187C188.449 40.2145 189.176 40.9406 190.071 40.9406Z"
        fill="white"
      />
      <path
        d="M190.068 4.34069C190.96 4.34069 191.683 3.6177 191.683 2.72583C191.683 1.83397 190.96 1.11096 190.068 1.11096C189.176 1.11096 188.453 1.83397 188.453 2.72583C188.453 3.6177 189.176 4.34069 190.068 4.34069Z"
        fill="white"
      />
      <path
        d="M129.124 77.4978C130.018 77.4978 130.742 76.7732 130.742 75.8794C130.742 74.9856 130.018 74.261 129.124 74.261C128.23 74.261 127.505 74.9856 127.505 75.8794C127.505 76.7732 128.23 77.4978 129.124 77.4978Z"
        fill="white"
      />
      <path
        d="M244.93 71.3949C245.824 71.3949 246.549 70.6703 246.549 69.7765C246.549 68.8826 245.824 68.158 244.93 68.158C244.036 68.158 243.312 68.8826 243.312 69.7765C243.312 70.6703 244.036 71.3949 244.93 71.3949Z"
        fill="white"
      />
      <path
        d="M202.242 28.7454C203.132 28.7454 203.853 28.024 203.853 27.1341C203.853 26.2442 203.132 25.5228 202.242 25.5228C201.352 25.5228 200.63 26.2442 200.63 27.1341C200.63 28.024 201.352 28.7454 202.242 28.7454Z"
        fill="white"
      />
      <path
        d="M153.475 181.127C154.365 181.127 155.086 180.406 155.086 179.516C155.086 178.626 154.365 177.904 153.475 177.904C152.585 177.904 151.864 178.626 151.864 179.516C151.864 180.406 152.585 181.127 153.475 181.127Z"
        fill="white"
      />
      <path
        d="M208.359 40.9478C209.247 40.9478 209.967 40.228 209.967 39.34C209.967 38.4521 209.247 37.7323 208.359 37.7323C207.471 37.7323 206.751 38.4521 206.751 39.34C206.751 40.228 207.471 40.9478 208.359 40.9478Z"
        fill="white"
      />
      <path
        d="M232.707 205.475C233.591 205.475 234.307 204.758 234.307 203.874C234.307 202.99 233.591 202.273 232.707 202.273C231.823 202.273 231.106 202.99 231.106 203.874C231.106 204.758 231.823 205.475 232.707 205.475Z"
        fill="white"
      />
      <path
        d="M80.3607 126.257C81.2447 126.257 81.9613 125.541 81.9613 124.657C81.9613 123.773 81.2447 123.056 80.3607 123.056C79.4767 123.056 78.7601 123.773 78.7601 124.657C78.7601 125.541 79.4767 126.257 80.3607 126.257Z"
        fill="white"
      />
      <path
        d="M86.4422 107.963C87.3321 107.963 88.0535 107.241 88.0535 106.351C88.0535 105.462 87.3321 104.74 86.4422 104.74C85.5524 104.74 84.8309 105.462 84.8309 106.351C84.8309 107.241 85.5524 107.963 86.4422 107.963Z"
        fill="white"
      />
      <path
        d="M31.5726 95.7746C32.4586 95.7746 33.1768 95.0564 33.1768 94.1704C33.1768 93.2845 32.4586 92.5663 31.5726 92.5663C30.6866 92.5663 29.9684 93.2845 29.9684 94.1704C29.9684 95.0564 30.6866 95.7746 31.5726 95.7746Z"
        fill="white"
      />
      <path
        d="M37.6791 71.402C38.5612 71.402 39.2762 70.687 39.2762 69.805C39.2762 68.9229 38.5612 68.2079 37.6791 68.2079C36.7971 68.2079 36.0821 68.9229 36.0821 69.805C36.0821 70.687 36.7971 71.402 37.6791 71.402Z"
        fill="white"
      />
      <path
        d="M49.8744 95.7782C50.7544 95.7782 51.4678 95.0648 51.4678 94.1847C51.4678 93.3047 50.7544 92.5912 49.8744 92.5912C48.9943 92.5912 48.2809 93.3047 48.2809 94.1847C48.2809 95.0648 48.9943 95.7782 49.8744 95.7782Z"
        fill="white"
      />
      <path
        d="M202.249 16.5252C203.123 16.5252 203.832 15.8166 203.832 14.9425C203.832 14.0683 203.123 13.3597 202.249 13.3597C201.375 13.3597 200.666 14.0683 200.666 14.9425C200.666 15.8166 201.375 16.5252 202.249 16.5252Z"
        fill="white"
      />
      <path
        d="M68.1797 77.4657C69.0538 77.4657 69.7625 76.7571 69.7625 75.883C69.7625 75.0088 69.0538 74.3002 68.1797 74.3002C67.3055 74.3002 66.5969 75.0088 66.5969 75.883C66.5969 76.7571 67.3055 77.4657 68.1797 77.4657Z"
        fill="white"
      />
      <path
        d="M177.858 53.0895C178.732 53.0895 179.441 52.3809 179.441 51.5068C179.441 50.6326 178.732 49.924 177.858 49.924C176.984 49.924 176.276 50.6326 176.276 51.5068C176.276 52.3809 176.984 53.0895 177.858 53.0895Z"
        fill="white"
      />
      <path
        d="M208.338 22.6139C209.212 22.6139 209.92 21.9053 209.92 21.0312C209.92 20.157 209.212 19.4484 208.338 19.4484C207.463 19.4484 206.755 20.157 206.755 21.0312C206.755 21.9053 207.463 22.6139 208.338 22.6139Z"
        fill="white"
      />
      <path
        d="M104.737 156.687C105.611 156.687 106.32 155.978 106.32 155.104C106.32 154.23 105.611 153.521 104.737 153.521C103.863 153.521 103.154 154.23 103.154 155.104C103.154 155.978 103.863 156.687 104.737 156.687Z"
        fill="white"
      />
      <path
        d="M220.511 22.6068C221.382 22.6068 222.087 21.9014 222.087 21.0312C222.087 20.1609 221.382 19.4555 220.511 19.4555C219.641 19.4555 218.936 20.1609 218.936 21.0312C218.936 21.9014 219.641 22.6068 220.511 22.6068Z"
        fill="white"
      />
      <path
        d="M214.448 40.9014C215.318 40.9014 216.023 40.196 216.023 39.3258C216.023 38.4556 215.318 37.7502 214.448 37.7502C213.577 37.7502 212.872 38.4556 212.872 39.3258C212.872 40.196 213.577 40.9014 214.448 40.9014Z"
        fill="white"
      />
      <path
        d="M214.448 10.4223C215.318 10.4223 216.023 9.71683 216.023 8.84662C216.023 7.97642 215.318 7.27098 214.448 7.27098C213.577 7.27098 212.872 7.97642 212.872 8.84662C212.872 9.71683 213.577 10.4223 214.448 10.4223Z"
        fill="white"
      />
      <path
        d="M208.348 10.4187C209.22 10.4187 209.927 9.71167 209.927 8.83949C209.927 7.96732 209.22 7.26027 208.348 7.26027C207.476 7.26027 206.769 7.96732 206.769 8.83949C206.769 9.71167 207.476 10.4187 208.348 10.4187Z"
        fill="white"
      />
      <path
        d="M190.057 10.4401C190.929 10.4401 191.636 9.73306 191.636 8.86089C191.636 7.98871 190.929 7.28168 190.057 7.28168C189.185 7.28168 188.478 7.98871 188.478 8.86089C188.478 9.73306 189.185 10.4401 190.057 10.4401Z"
        fill="white"
      />
      <path
        d="M31.5726 126.257C32.4428 126.257 33.1483 125.552 33.1483 124.682C33.1483 123.812 32.4428 123.106 31.5726 123.106C30.7024 123.106 29.997 123.812 29.997 124.682C29.997 125.552 30.7024 126.257 31.5726 126.257Z"
        fill="white"
      />
      <path
        d="M55.9773 83.5651C56.8456 83.5651 57.5494 82.8613 57.5494 81.9931C57.5494 81.1248 56.8456 80.421 55.9773 80.421C55.1091 80.421 54.4052 81.1248 54.4052 81.9931C54.4052 82.8613 55.1091 83.5651 55.9773 83.5651Z"
        fill="white"
      />
      <path
        d="M324.162 138.403C325.026 138.403 325.727 137.702 325.727 136.838C325.727 135.973 325.026 135.273 324.162 135.273C323.298 135.273 322.597 135.973 322.597 136.838C322.597 137.702 323.298 138.403 324.162 138.403Z"
        fill="white"
      />
      <path
        d="M214.419 16.4967C215.283 16.4967 215.984 15.7961 215.984 14.9318C215.984 14.0675 215.283 13.3668 214.419 13.3668C213.555 13.3668 212.854 14.0675 212.854 14.9318C212.854 15.7961 213.555 16.4967 214.419 16.4967Z"
        fill="white"
      />
      <path
        d="M214.451 22.5997C215.315 22.5997 216.016 21.899 216.016 21.0347C216.016 20.1704 215.315 19.4698 214.451 19.4698C213.587 19.4698 212.886 20.1704 212.886 21.0347C212.886 21.899 213.587 22.5997 214.451 22.5997Z"
        fill="white"
      />
      <path
        d="M214.448 34.7949C215.31 34.7949 216.009 34.0959 216.009 33.2335C216.009 32.3712 215.31 31.6721 214.448 31.6721C213.585 31.6721 212.886 32.3712 212.886 33.2335C212.886 34.0959 213.585 34.7949 214.448 34.7949Z"
        fill="white"
      />
      <path
        d="M110.833 150.584C111.695 150.584 112.394 149.885 112.394 149.022C112.394 148.16 111.695 147.461 110.833 147.461C109.97 147.461 109.271 148.16 109.271 149.022C109.271 149.885 109.97 150.584 110.833 150.584Z"
        fill="white"
      />
      <path
        d="M348.567 223.737C349.431 223.737 350.132 223.037 350.132 222.172C350.132 221.308 349.431 220.607 348.567 220.607C347.702 220.607 347.002 221.308 347.002 222.172C347.002 223.037 347.702 223.737 348.567 223.737Z"
        fill="white"
      />
      <path
        d="M208.338 34.7628C209.198 34.7628 209.895 34.0654 209.895 33.205C209.895 32.3447 209.198 31.6472 208.338 31.6472C207.477 31.6472 206.78 32.3447 206.78 33.205C206.78 34.0654 207.477 34.7628 208.338 34.7628Z"
        fill="white"
      />
      <path
        d="M293.679 77.4444C294.542 77.4444 295.241 76.7453 295.241 75.883C295.241 75.0206 294.542 74.3216 293.679 74.3216C292.817 74.3216 292.118 75.0206 292.118 75.883C292.118 76.7453 292.817 77.4444 293.679 77.4444Z"
        fill="white"
      />
      <path
        d="M49.8708 101.845C50.7292 101.845 51.4251 101.15 51.4251 100.291C51.4251 99.4329 50.7292 98.737 49.8708 98.737C49.0124 98.737 48.3165 99.4329 48.3165 100.291C48.3165 101.15 49.0124 101.845 49.8708 101.845Z"
        fill="white"
      />
      <path
        d="M214.44 28.6599C215.301 28.6599 215.998 27.9624 215.998 27.102C215.998 26.2417 215.301 25.5442 214.44 25.5442C213.58 25.5442 212.883 26.2417 212.883 27.102C212.883 27.9624 213.58 28.6599 214.44 28.6599Z"
        fill="white"
      />
      <path
        d="M220.526 28.6777C221.386 28.6777 222.083 27.9802 222.083 27.1199C222.083 26.2595 221.386 25.562 220.526 25.562C219.665 25.562 218.968 26.2595 218.968 27.1199C218.968 27.9802 219.665 28.6777 220.526 28.6777Z"
        fill="white"
      />
      <path
        d="M220.533 34.7628C221.389 34.7628 222.083 34.0686 222.083 33.2121C222.083 32.3557 221.389 31.6614 220.533 31.6614C219.676 31.6614 218.982 32.3557 218.982 33.2121C218.982 34.0686 219.676 34.7628 220.533 34.7628Z"
        fill="white"
      />
      <path
        d="M220.554 16.486C221.415 16.486 222.112 15.7886 222.112 14.9282C222.112 14.0678 221.415 13.3704 220.554 13.3704C219.694 13.3704 218.996 14.0678 218.996 14.9282C218.996 15.7886 219.694 16.486 220.554 16.486Z"
        fill="white"
      />
      <path
        d="M220.526 40.8658C221.382 40.8658 222.076 40.1715 222.076 39.3151C222.076 38.4587 221.382 37.7644 220.526 37.7644C219.669 37.7644 218.975 38.4587 218.975 39.3151C218.975 40.1715 219.669 40.8658 220.526 40.8658Z"
        fill="white"
      />
      <path
        d="M293.683 71.3343C294.535 71.3343 295.226 70.6432 295.226 69.7907C295.226 68.9382 294.535 68.2471 293.683 68.2471C292.83 68.2471 292.139 68.9382 292.139 69.7907C292.139 70.6432 292.83 71.3343 293.683 71.3343Z"
        fill="white"
      />
      <path
        d="M299.768 83.501C300.62 83.501 301.311 82.8099 301.311 81.9574C301.311 81.1049 300.62 80.4138 299.768 80.4138C298.915 80.4138 298.224 81.1049 298.224 81.9574C298.224 82.8099 298.915 83.501 299.768 83.501Z"
        fill="white"
      />
      <path
        d="M80.35 28.692C81.2025 28.692 81.8935 28.0009 81.8935 27.1484C81.8935 26.2959 81.2025 25.6048 80.35 25.6048C79.4975 25.6048 78.8064 26.2959 78.8064 27.1484C78.8064 28.0009 79.4975 28.692 80.35 28.692Z"
        fill="white"
      />
      <path
        d="M141.312 174.949C142.16 174.949 142.848 174.261 142.848 173.413C142.848 172.564 142.16 171.876 141.312 171.876C140.463 171.876 139.775 172.564 139.775 173.413C139.775 174.261 140.463 174.949 141.312 174.949Z"
        fill="white"
      />
      <path
        d="M49.8851 144.47C50.7336 144.47 51.4215 143.782 51.4215 142.934C51.4215 142.085 50.7336 141.397 49.8851 141.397C49.0365 141.397 48.3486 142.085 48.3486 142.934C48.3486 143.782 49.0365 144.47 49.8851 144.47Z"
        fill="white"
      />
      <path
        d="M208.355 28.6634C209.208 28.6634 209.899 27.9724 209.899 27.1199C209.899 26.2674 209.208 25.5763 208.355 25.5763C207.503 25.5763 206.812 26.2674 206.812 27.1199C206.812 27.9724 207.503 28.6634 208.355 28.6634Z"
        fill="white"
      />
      <path
        d="M49.8851 113.994C50.7336 113.994 51.4215 113.307 51.4215 112.458C51.4215 111.609 50.7336 110.922 49.8851 110.922C49.0365 110.922 48.3486 111.609 48.3486 112.458C48.3486 113.307 49.0365 113.994 49.8851 113.994Z"
        fill="white"
      />
      <path
        d="M208.355 16.4825C209.208 16.4825 209.899 15.7914 209.899 14.9389C209.899 14.0864 209.208 13.3953 208.355 13.3953C207.503 13.3953 206.812 14.0864 206.812 14.9389C206.812 15.7914 207.503 16.4825 208.355 16.4825Z"
        fill="white"
      />
      <path
        d="M305.871 83.5117C306.717 83.5117 307.404 82.8254 307.404 81.9788C307.404 81.1322 306.717 80.4459 305.871 80.4459C305.024 80.4459 304.338 81.1322 304.338 81.9788C304.338 82.8254 305.024 83.5117 305.871 83.5117Z"
        fill="white"
      />
      <path
        d="M43.7857 71.3414C44.6342 71.3414 45.3221 70.6535 45.3221 69.8049C45.3221 68.9564 44.6342 68.2685 43.7857 68.2685C42.9371 68.2685 42.2492 68.9564 42.2492 69.8049C42.2492 70.6535 42.9371 71.3414 43.7857 71.3414Z"
        fill="white"
      />
      <path
        d="M299.764 89.5861C300.611 89.5861 301.297 88.8998 301.297 88.0533C301.297 87.2067 300.611 86.5204 299.764 86.5204C298.918 86.5204 298.231 87.2067 298.231 88.0533C298.231 88.8998 298.918 89.5861 299.764 89.5861Z"
        fill="white"
      />
      <path
        d="M238.813 28.6349C239.66 28.6349 240.346 27.9486 240.346 27.102C240.346 26.2554 239.66 25.5692 238.813 25.5692C237.967 25.5692 237.28 26.2554 237.28 27.102C237.28 27.9486 237.967 28.6349 238.813 28.6349Z"
        fill="white"
      />
      <path
        d="M250.987 34.7699C251.83 34.7699 252.513 34.0869 252.513 33.2442C252.513 32.4016 251.83 31.7185 250.987 31.7185C250.144 31.7185 249.461 32.4016 249.461 33.2442C249.461 34.0869 250.144 34.7699 250.987 34.7699Z"
        fill="white"
      />
      <path
        d="M232.721 22.5533C233.563 22.5533 234.247 21.8702 234.247 21.0276C234.247 20.1849 233.563 19.5019 232.721 19.5019C231.878 19.5019 231.195 20.1849 231.195 21.0276C231.195 21.8702 231.878 22.5533 232.721 22.5533Z"
        fill="white"
      />
      <path
        d="M293.683 101.785C294.525 101.785 295.208 101.102 295.208 100.259C295.208 99.4165 294.525 98.7334 293.683 98.7334C292.84 98.7334 292.157 99.4165 292.157 100.259C292.157 101.102 292.84 101.785 293.683 101.785Z"
        fill="white"
      />
      <path
        d="M190.064 22.5676C190.907 22.5676 191.59 21.8845 191.59 21.0418C191.59 20.1992 190.907 19.5161 190.064 19.5161C189.222 19.5161 188.539 20.1992 188.539 21.0418C188.539 21.8845 189.222 22.5676 190.064 22.5676Z"
        fill="white"
      />
      <path
        d="M287.59 65.2455C288.435 65.2455 289.12 64.5609 289.12 63.7162C289.12 62.8716 288.435 62.1869 287.59 62.1869C286.746 62.1869 286.061 62.8716 286.061 63.7162C286.061 64.5609 286.746 65.2455 287.59 65.2455Z"
        fill="white"
      />
      <path
        d="M281.463 65.2456C282.305 65.2456 282.988 64.5625 282.988 63.7198C282.988 62.8772 282.305 62.1941 281.463 62.1941C280.62 62.1941 279.937 62.8772 279.937 63.7198C279.937 64.5625 280.62 65.2456 281.463 65.2456Z"
        fill="white"
      />
      <path
        d="M257.115 34.7735C257.958 34.7735 258.641 34.0904 258.641 33.2478C258.641 32.4051 257.958 31.722 257.115 31.722C256.272 31.722 255.589 32.4051 255.589 33.2478C255.589 34.0904 256.272 34.7735 257.115 34.7735Z"
        fill="white"
      />
      <path
        d="M49.8744 83.5117C50.7131 83.5117 51.393 82.8318 51.393 81.9931C51.393 81.1544 50.7131 80.4744 49.8744 80.4744C49.0357 80.4744 48.3558 81.1544 48.3558 81.9931C48.3558 82.8318 49.0357 83.5117 49.8744 83.5117Z"
        fill="white"
      />
      <path
        d="M257.115 40.8159C257.958 40.8159 258.641 40.1328 258.641 39.2901C258.641 38.4475 257.958 37.7644 257.115 37.7644C256.272 37.7644 255.589 38.4475 255.589 39.2901C255.589 40.1328 256.272 40.8159 257.115 40.8159Z"
        fill="white"
      />
      <path
        d="M43.7964 107.891C44.6351 107.891 45.315 107.212 45.315 106.373C45.315 105.534 44.6351 104.854 43.7964 104.854C42.9577 104.854 42.2777 105.534 42.2777 106.373C42.2777 107.212 42.9577 107.891 43.7964 107.891Z"
        fill="white"
      />
      <path
        d="M299.764 77.4087C300.603 77.4087 301.283 76.7288 301.283 75.8901C301.283 75.0514 300.603 74.3715 299.764 74.3715C298.926 74.3715 298.246 75.0514 298.246 75.8901C298.246 76.7288 298.926 77.4087 299.764 77.4087Z"
        fill="white"
      />
      <path
        d="M354.648 187.105C355.487 187.105 356.167 186.425 356.167 185.587C356.167 184.748 355.487 184.068 354.648 184.068C353.81 184.068 353.13 184.748 353.13 185.587C353.13 186.425 353.81 187.105 354.648 187.105Z"
        fill="white"
      />
      <path
        d="M269.307 59.1141C270.145 59.1141 270.825 58.4342 270.825 57.5955C270.825 56.7568 270.145 56.0769 269.307 56.0769C268.468 56.0769 267.788 56.7568 267.788 57.5955C267.788 58.4342 268.468 59.1141 269.307 59.1141Z"
        fill="white"
      />
      <path
        d="M287.594 71.295C288.437 71.295 289.12 70.6119 289.12 69.7693C289.12 68.9267 288.437 68.2436 287.594 68.2436C286.751 68.2436 286.068 68.9267 286.068 69.7693C286.068 70.6119 286.751 71.295 287.594 71.295Z"
        fill="white"
      />
      <path
        d="M293.672 83.5188C294.509 83.5188 295.187 82.8405 295.187 82.0038C295.187 81.167 294.509 80.4887 293.672 80.4887C292.835 80.4887 292.157 81.167 292.157 82.0038C292.157 82.8405 292.835 83.5188 293.672 83.5188Z"
        fill="white"
      />
      <path
        d="M13.2851 89.5968C14.1199 89.5968 14.7966 88.9201 14.7966 88.0853C14.7966 87.2506 14.1199 86.5738 13.2851 86.5738C12.4503 86.5738 11.7736 87.2506 11.7736 88.0853C11.7736 88.9201 12.4503 89.5968 13.2851 89.5968Z"
        fill="white"
      />
      <path
        d="M269.303 46.9188C270.138 46.9188 270.814 46.2421 270.814 45.4074C270.814 44.5726 270.138 43.8959 269.303 43.8959C268.468 43.8959 267.792 44.5726 267.792 45.4074C267.792 46.2421 268.468 46.9188 269.303 46.9188Z"
        fill="white"
      />
      <path
        d="M287.612 77.3945C288.447 77.3945 289.123 76.7177 289.123 75.883C289.123 75.0482 288.447 74.3715 287.612 74.3715C286.777 74.3715 286.1 75.0482 286.1 75.883C286.1 76.7177 286.777 77.3945 287.612 77.3945Z"
        fill="white"
      />
      <path
        d="M244.952 28.642C245.79 28.642 246.47 27.9621 246.47 27.1234C246.47 26.2847 245.79 25.6048 244.952 25.6048C244.113 25.6048 243.433 26.2847 243.433 27.1234C243.433 27.9621 244.113 28.642 244.952 28.642Z"
        fill="white"
      />
      <path
        d="M305.903 89.5932C306.742 89.5932 307.422 88.9133 307.422 88.0746C307.422 87.2359 306.742 86.556 305.903 86.556C305.064 86.556 304.384 87.2359 304.384 88.0746C304.384 88.9133 305.064 89.5932 305.903 89.5932Z"
        fill="white"
      />
      <path
        d="M269.292 53.0289C270.135 53.0289 270.818 52.3458 270.818 51.5032C270.818 50.6606 270.135 49.9775 269.292 49.9775C268.45 49.9775 267.767 50.6606 267.767 51.5032C267.767 52.3458 268.45 53.0289 269.292 53.0289Z"
        fill="white"
      />
      <path
        d="M275.395 53.0325C276.232 53.0325 276.91 52.3542 276.91 51.5175C276.91 50.6807 276.232 50.0024 275.395 50.0024C274.559 50.0024 273.88 50.6807 273.88 51.5175C273.88 52.3542 274.559 53.0325 275.395 53.0325Z"
        fill="white"
      />
      <path
        d="M275.427 59.1176C276.266 59.1176 276.946 58.4377 276.946 57.599C276.946 56.7603 276.266 56.0804 275.427 56.0804C274.589 56.0804 273.909 56.7603 273.909 57.599C273.909 58.4377 274.589 59.1176 275.427 59.1176Z"
        fill="white"
      />
      <path
        d="M281.484 59.1176C282.323 59.1176 283.003 58.4377 283.003 57.599C283.003 56.7603 282.323 56.0804 281.484 56.0804C280.645 56.0804 279.965 56.7603 279.965 57.599C279.965 58.4377 280.645 59.1176 281.484 59.1176Z"
        fill="white"
      />
      <path
        d="M269.289 65.242C270.12 65.242 270.793 64.5685 270.793 63.7376C270.793 62.9068 270.12 62.2333 269.289 62.2333C268.458 62.2333 267.784 62.9068 267.784 63.7376C267.784 64.5685 268.458 65.242 269.289 65.242Z"
        fill="white"
      />
      <path
        d="M311.942 120.037C312.773 120.037 313.446 119.363 313.446 118.532C313.446 117.702 312.773 117.028 311.942 117.028C311.111 117.028 310.437 117.702 310.437 118.532C310.437 119.363 311.111 120.037 311.942 120.037Z"
        fill="white"
      />
      <path
        d="M281.455 77.3909C282.286 77.3909 282.96 76.7174 282.96 75.8865C282.96 75.0557 282.286 74.3822 281.455 74.3822C280.625 74.3822 279.951 75.0557 279.951 75.8865C279.951 76.7174 280.625 77.3909 281.455 77.3909Z"
        fill="white"
      />
      <path
        d="M311.942 89.5576C312.773 89.5576 313.446 88.8841 313.446 88.0532C313.446 87.2224 312.773 86.5489 311.942 86.5489C311.111 86.5489 310.437 87.2224 310.437 88.0532C310.437 88.8841 311.111 89.5576 311.942 89.5576Z"
        fill="white"
      />
      <path
        d="M257.122 46.9153C257.953 46.9153 258.626 46.2418 258.626 45.4109C258.626 44.5801 257.953 43.9066 257.122 43.9066C256.291 43.9066 255.618 44.5801 255.618 45.4109C255.618 46.2418 256.291 46.9153 257.122 46.9153Z"
        fill="white"
      />
      <path
        d="M220.501 46.9153C221.331 46.9153 222.005 46.2418 222.005 45.4109C222.005 44.5801 221.331 43.9066 220.501 43.9066C219.67 43.9066 218.996 44.5801 218.996 45.4109C218.996 46.2418 219.67 46.9153 220.501 46.9153Z"
        fill="white"
      />
      <path
        d="M269.289 71.2594C270.12 71.2594 270.793 70.5859 270.793 69.7551C270.793 68.9242 270.12 68.2507 269.289 68.2507C268.458 68.2507 267.784 68.9242 267.784 69.7551C267.784 70.5859 268.458 71.2594 269.289 71.2594Z"
        fill="white"
      />
      <path
        d="M257.111 59.082C257.942 59.082 258.616 58.4085 258.616 57.5776C258.616 56.7468 257.942 56.0733 257.111 56.0733C256.28 56.0733 255.607 56.7468 255.607 57.5776C255.607 58.4085 256.28 59.082 257.111 59.082Z"
        fill="white"
      />
      <path
        d="M232.721 34.7129C233.554 34.7129 234.229 34.0378 234.229 33.205C234.229 32.3722 233.554 31.6971 232.721 31.6971C231.888 31.6971 231.213 32.3722 231.213 33.205C231.213 34.0378 231.888 34.7129 232.721 34.7129Z"
        fill="white"
      />
      <path
        d="M269.299 77.3802C270.126 77.3802 270.797 76.7099 270.797 75.883C270.797 75.0561 270.126 74.3857 269.299 74.3857C268.473 74.3857 267.802 75.0561 267.802 75.883C267.802 76.7099 268.473 77.3802 269.299 77.3802Z"
        fill="white"
      />
      <path
        d="M281.491 71.2844C282.322 71.2844 282.995 70.6108 282.995 69.78C282.995 68.9492 282.322 68.2757 281.491 68.2757C280.66 68.2757 279.987 68.9492 279.987 69.78C279.987 70.6108 280.66 71.2844 281.491 71.2844Z"
        fill="white"
      />
      <path
        d="M13.2851 83.501C14.1179 83.501 14.793 82.8259 14.793 81.9931C14.793 81.1603 14.1179 80.4851 13.2851 80.4851C12.4523 80.4851 11.7772 81.1603 11.7772 81.9931C11.7772 82.8259 12.4523 83.501 13.2851 83.501Z"
        fill="white"
      />
      <path
        d="M305.867 95.6606C306.698 95.6606 307.372 94.987 307.372 94.1562C307.372 93.3254 306.698 92.6519 305.867 92.6519C305.036 92.6519 304.363 93.3254 304.363 94.1562C304.363 94.987 305.036 95.6606 305.867 95.6606Z"
        fill="white"
      />
      <path
        d="M275.392 65.185C276.223 65.185 276.896 64.5114 276.896 63.6806C276.896 62.8498 276.223 62.1763 275.392 62.1763C274.561 62.1763 273.887 62.8498 273.887 63.6806C273.887 64.5114 274.561 65.185 275.392 65.185Z"
        fill="white"
      />
      <path
        d="M263.189 46.926C264.024 46.926 264.701 46.2493 264.701 45.4145C264.701 44.5797 264.024 43.903 263.189 43.903C262.355 43.903 261.678 44.5797 261.678 45.4145C261.678 46.2493 262.355 46.926 263.189 46.926Z"
        fill="white"
      />
      <path
        d="M43.7821 89.5825C44.609 89.5825 45.2793 88.9122 45.2793 88.0853C45.2793 87.2584 44.609 86.5881 43.7821 86.5881C42.9552 86.5881 42.2849 87.2584 42.2849 88.0853C42.2849 88.9122 42.9552 89.5825 43.7821 89.5825Z"
        fill="white"
      />
      <path
        d="M37.6791 107.877C38.506 107.877 39.1764 107.207 39.1764 106.38C39.1764 105.553 38.506 104.883 37.6791 104.883C36.8522 104.883 36.1819 105.553 36.1819 106.38C36.1819 107.207 36.8522 107.877 37.6791 107.877Z"
        fill="white"
      />
      <path
        d="M226.654 46.9117C227.478 46.9117 228.147 46.243 228.147 45.4181C228.147 44.5931 227.478 43.9244 226.654 43.9244C225.829 43.9244 225.16 44.5931 225.16 45.4181C225.16 46.243 225.829 46.9117 226.654 46.9117Z"
        fill="white"
      />
      <path
        d="M31.5726 101.767C32.3995 101.767 33.0698 101.097 33.0698 100.27C33.0698 99.443 32.3995 98.7726 31.5726 98.7726C30.7457 98.7726 30.0754 99.443 30.0754 100.27C30.0754 101.097 30.7457 101.767 31.5726 101.767Z"
        fill="white"
      />
      <path
        d="M263.196 65.1814C264.023 65.1814 264.694 64.5111 264.694 63.6842C264.694 62.8573 264.023 62.1869 263.196 62.1869C262.37 62.1869 261.699 62.8573 261.699 63.6842C261.699 64.5111 262.37 65.1814 263.196 65.1814Z"
        fill="white"
      />
      <path
        d="M226.654 16.4361C227.478 16.4361 228.147 15.7674 228.147 14.9424C228.147 14.1175 227.478 13.4488 226.654 13.4488C225.829 13.4488 225.16 14.1175 225.16 14.9424C225.16 15.7674 225.829 16.4361 226.654 16.4361Z"
        fill="white"
      />
      <path
        d="M287.601 89.5433C288.424 89.5433 289.091 88.8762 289.091 88.0532C289.091 87.2303 288.424 86.5631 287.601 86.5631C286.778 86.5631 286.111 87.2303 286.111 88.0532C286.111 88.8762 286.778 89.5433 287.601 89.5433Z"
        fill="white"
      />
      <path
        d="M251.019 71.2879C251.846 71.2879 252.516 70.6176 252.516 69.7907C252.516 68.9638 251.846 68.2935 251.019 68.2935C250.192 68.2935 249.522 68.9638 249.522 69.7907C249.522 70.6176 250.192 71.2879 251.019 71.2879Z"
        fill="white"
      />
      <path
        d="M232.703 28.6278C233.534 28.6278 234.207 27.9543 234.207 27.1234C234.207 26.2926 233.534 25.6191 232.703 25.6191C231.872 25.6191 231.199 26.2926 231.199 27.1234C231.199 27.9543 231.872 28.6278 232.703 28.6278Z"
        fill="white"
      />
      <path
        d="M311.97 95.6713C312.797 95.6713 313.467 95.0009 313.467 94.174C313.467 93.3471 312.797 92.6768 311.97 92.6768C311.143 92.6768 310.473 93.3471 310.473 94.174C310.473 95.0009 311.143 95.6713 311.97 95.6713Z"
        fill="white"
      />
      <path
        d="M287.587 83.4938C288.412 83.4938 289.081 82.8251 289.081 82.0002C289.081 81.1753 288.412 80.5065 287.587 80.5065C286.762 80.5065 286.093 81.1753 286.093 82.0002C286.093 82.8251 286.762 83.4938 287.587 83.4938Z"
        fill="white"
      />
      <path
        d="M263.193 59.1105C264.018 59.1105 264.687 58.4418 264.687 57.6169C264.687 56.7919 264.018 56.1232 263.193 56.1232C262.368 56.1232 261.699 56.7919 261.699 57.6169C261.699 58.4418 262.368 59.1105 263.193 59.1105Z"
        fill="white"
      />
      <path
        d="M275.406 71.2879C276.231 71.2879 276.9 70.6192 276.9 69.7943C276.9 68.9693 276.231 68.3006 275.406 68.3006C274.581 68.3006 273.912 68.9693 273.912 69.7943C273.912 70.6192 274.581 71.2879 275.406 71.2879Z"
        fill="white"
      />
      <path
        d="M7.2071 113.98C8.03006 113.98 8.69719 113.313 8.69719 112.49C8.69719 111.667 8.03006 111 7.2071 111C6.38415 111 5.71701 111.667 5.71701 112.49C5.71701 113.313 6.38415 113.98 7.2071 113.98Z"
        fill="white"
      />
      <path
        d="M232.714 59.1105C233.539 59.1105 234.207 58.4418 234.207 57.6169C234.207 56.7919 233.539 56.1232 232.714 56.1232C231.889 56.1232 231.22 56.7919 231.22 57.6169C231.22 58.4418 231.889 59.1105 232.714 59.1105Z"
        fill="white"
      />
      <path
        d="M263.182 53.0075C264.005 53.0075 264.672 52.3404 264.672 51.5175C264.672 50.6945 264.005 50.0274 263.182 50.0274C262.359 50.0274 261.692 50.6945 261.692 51.5175C261.692 52.3404 262.359 53.0075 263.182 53.0075Z"
        fill="white"
      />
      <path
        d="M257.111 53.0182C257.936 53.0182 258.605 52.3495 258.605 51.5246C258.605 50.6997 257.936 50.0309 257.111 50.0309C256.286 50.0309 255.618 50.6997 255.618 51.5246C255.618 52.3495 256.286 53.0182 257.111 53.0182Z"
        fill="white"
      />
      <path
        d="M62.0589 53.0075C62.8819 53.0075 63.549 52.3404 63.549 51.5175C63.549 50.6945 62.8819 50.0274 62.0589 50.0274C61.236 50.0274 60.5688 50.6945 60.5688 51.5175C60.5688 52.3404 61.236 53.0075 62.0589 53.0075Z"
        fill="white"
      />
      <path
        d="M311.984 101.767C312.809 101.767 313.478 101.098 313.478 100.273C313.478 99.4485 312.809 98.7798 311.984 98.7798C311.16 98.7798 310.491 99.4485 310.491 100.273C310.491 101.098 311.16 101.767 311.984 101.767Z"
        fill="white"
      />
      <path
        d="M147.404 174.949C148.233 174.949 148.905 174.277 148.905 173.448C148.905 172.62 148.233 171.948 147.404 171.948C146.575 171.948 145.903 172.62 145.903 173.448C145.903 174.277 146.575 174.949 147.404 174.949Z"
        fill="white"
      />
      <path
        d="M275.424 77.3588C276.241 77.3588 276.903 76.6964 276.903 75.8794C276.903 75.0623 276.241 74.4 275.424 74.4C274.607 74.4 273.944 75.0623 273.944 75.8794C273.944 76.6964 274.607 77.3588 275.424 77.3588Z"
        fill="white"
      />
      <path
        d="M251.012 65.1921C251.829 65.1921 252.491 64.5297 252.491 63.7127C252.491 62.8956 251.829 62.2333 251.012 62.2333C250.195 62.2333 249.533 62.8956 249.533 63.7127C249.533 64.5297 250.195 65.1921 251.012 65.1921Z"
        fill="white"
      />
      <path
        d="M190.061 34.7165C190.878 34.7165 191.54 34.0541 191.54 33.2371C191.54 32.42 190.878 31.7577 190.061 31.7577C189.244 31.7577 188.581 32.42 188.581 33.2371C188.581 34.0541 189.244 34.7165 190.061 34.7165Z"
        fill="white"
      />
      <path
        d="M257.115 65.1921C257.932 65.1921 258.594 64.5297 258.594 63.7127C258.594 62.8956 257.932 62.2333 257.115 62.2333C256.298 62.2333 255.635 62.8956 255.635 63.7127C255.635 64.5297 256.298 65.1921 257.115 65.1921Z"
        fill="white"
      />
      <path
        d="M244.92 65.185C245.741 65.185 246.406 64.5194 246.406 63.6984C246.406 62.8774 245.741 62.2119 244.92 62.2119C244.099 62.2119 243.433 62.8774 243.433 63.6984C243.433 64.5194 244.099 65.185 244.92 65.185Z"
        fill="white"
      />
      <path
        d="M86.4422 101.735C87.2613 101.735 87.9252 101.071 87.9252 100.252C87.9252 99.433 87.2613 98.7691 86.4422 98.7691C85.6232 98.7691 84.9593 99.433 84.9593 100.252C84.9593 101.071 85.6232 101.735 86.4422 101.735Z"
        fill="white"
      />
      <path
        d="M354.627 181.009C355.45 181.009 356.117 180.342 356.117 179.519C356.117 178.696 355.45 178.029 354.627 178.029C353.804 178.029 353.137 178.696 353.137 179.519C353.137 180.342 353.804 181.009 354.627 181.009Z"
        fill="white"
      />
      <path
        d="M55.956 107.87C56.773 107.87 57.4353 107.208 57.4353 106.391C57.4353 105.574 56.773 104.911 55.956 104.911C55.1389 104.911 54.4766 105.574 54.4766 106.391C54.4766 107.208 55.1389 107.87 55.956 107.87Z"
        fill="white"
      />
      <path
        d="M238.813 59.057C239.63 59.057 240.293 58.3947 240.293 57.5776C240.293 56.7606 239.63 56.0982 238.813 56.0982C237.996 56.0982 237.334 56.7606 237.334 57.5776C237.334 58.3947 237.996 59.057 238.813 59.057Z"
        fill="white"
      />
      <path
        d="M226.639 40.7802C227.456 40.7802 228.119 40.1179 228.119 39.3008C228.119 38.4838 227.456 37.8214 226.639 37.8214C225.822 37.8214 225.16 38.4838 225.16 39.3008C225.16 40.1179 225.822 40.7802 226.639 40.7802Z"
        fill="white"
      />
      <path
        d="M263.196 71.263C264.016 71.263 264.679 70.599 264.679 69.78C264.679 68.961 264.016 68.297 263.196 68.297C262.377 68.297 261.714 68.961 261.714 69.78C261.714 70.599 262.377 71.263 263.196 71.263Z"
        fill="white"
      />
      <path
        d="M232.721 40.7874C233.54 40.7874 234.204 40.1234 234.204 39.3044C234.204 38.4854 233.54 37.8214 232.721 37.8214C231.902 37.8214 231.238 38.4854 231.238 39.3044C231.238 40.1234 231.902 40.7874 232.721 40.7874Z"
        fill="white"
      />
      <path
        d="M299.768 95.6677C300.589 95.6677 301.254 95.0021 301.254 94.1811C301.254 93.3602 300.589 92.6946 299.768 92.6946C298.947 92.6946 298.281 93.3602 298.281 94.1811C298.281 95.0021 298.947 95.6677 299.768 95.6677Z"
        fill="white"
      />
      <path
        d="M293.654 89.5469C294.469 89.5469 295.13 88.8861 295.13 88.0711C295.13 87.256 294.469 86.5952 293.654 86.5952C292.839 86.5952 292.178 87.256 292.178 88.0711C292.178 88.8861 292.839 89.5469 293.654 89.5469Z"
        fill="white"
      />
      <path
        d="M275.409 229.737C276.223 229.737 276.882 229.078 276.882 228.265C276.882 227.451 276.223 226.792 275.409 226.792C274.596 226.792 273.937 227.451 273.937 228.265C273.937 229.078 274.596 229.737 275.409 229.737Z"
        fill="white"
      />
      <path
        d="M275.409 83.4653C276.229 83.4653 276.892 82.8014 276.892 81.9824C276.892 81.1633 276.229 80.4994 275.409 80.4994C274.59 80.4994 273.927 81.1633 273.927 81.9824C273.927 82.8014 274.59 83.4653 275.409 83.4653Z"
        fill="white"
      />
      <path
        d="M37.6791 101.771C38.4962 101.771 39.1585 101.108 39.1585 100.291C39.1585 99.4742 38.4962 98.8119 37.6791 98.8119C36.8621 98.8119 36.1997 99.4742 36.1997 100.291C36.1997 101.108 36.8621 101.771 37.6791 101.771Z"
        fill="white"
      />
      <path
        d="M159.571 65.1778C160.384 65.1778 161.043 64.5187 161.043 63.7056C161.043 62.8925 160.384 62.2333 159.571 62.2333C158.758 62.2333 158.099 62.8925 158.099 63.7056C158.099 64.5187 158.758 65.1778 159.571 65.1778Z"
        fill="white"
      />
      <path
        d="M257.118 71.2629C257.932 71.2629 258.591 70.6038 258.591 69.7907C258.591 68.9776 257.932 68.3184 257.118 68.3184C256.305 68.3184 255.646 68.9776 255.646 69.7907C255.646 70.6038 256.305 71.2629 257.118 71.2629Z"
        fill="white"
      />
      <path
        d="M318.062 101.721C318.872 101.721 319.528 101.065 319.528 100.256C319.528 99.4464 318.872 98.7905 318.062 98.7905C317.253 98.7905 316.597 99.4464 316.597 100.256C316.597 101.065 317.253 101.721 318.062 101.721Z"
        fill="white"
      />
      <path
        d="M281.498 89.5398C282.309 89.5398 282.967 88.8822 282.967 88.0711C282.967 87.2599 282.309 86.6024 281.498 86.6024C280.687 86.6024 280.03 87.2599 280.03 88.0711C280.03 88.8822 280.687 89.5398 281.498 89.5398Z"
        fill="white"
      />
      <path
        d="M257.129 211.442C257.938 211.442 258.594 210.786 258.594 209.977C258.594 209.168 257.938 208.512 257.129 208.512C256.32 208.512 255.664 209.168 255.664 209.977C255.664 210.786 256.32 211.442 257.129 211.442Z"
        fill="white"
      />
      <path
        d="M318.048 107.802C318.857 107.802 319.513 107.146 319.513 106.337C319.513 105.528 318.857 104.872 318.048 104.872C317.239 104.872 316.583 105.528 316.583 106.337C316.583 107.146 317.239 107.802 318.048 107.802Z"
        fill="white"
      />
      <path
        d="M281.495 83.4475C282.306 83.4475 282.963 82.7899 282.963 81.9788C282.963 81.1676 282.306 80.5101 281.495 80.5101C280.683 80.5101 280.026 81.1676 280.026 81.9788C280.026 82.7899 280.683 83.4475 281.495 83.4475Z"
        fill="white"
      />
      <path
        d="M263.211 40.7731C264.022 40.7731 264.679 40.1155 264.679 39.3044C264.679 38.4933 264.022 37.8357 263.211 37.8357C262.4 37.8357 261.742 38.4933 261.742 39.3044C261.742 40.1155 262.4 40.7731 263.211 40.7731Z"
        fill="white"
      />
      <path
        d="M318.059 126.108C318.868 126.108 319.524 125.452 319.524 124.643C319.524 123.833 318.868 123.177 318.059 123.177C317.25 123.177 316.594 123.833 316.594 124.643C316.594 125.452 317.25 126.108 318.059 126.108Z"
        fill="white"
      />
      <path
        d="M311.974 107.799C312.779 107.799 313.432 107.146 313.432 106.341C313.432 105.536 312.779 104.883 311.974 104.883C311.169 104.883 310.516 105.536 310.516 106.341C310.516 107.146 311.169 107.799 311.974 107.799Z"
        fill="white"
      />
      <path
        d="M43.7678 83.4511C44.5731 83.4511 45.2258 82.7983 45.2258 81.9931C45.2258 81.1878 44.5731 80.535 43.7678 80.535C42.9626 80.535 42.3098 81.1878 42.3098 81.9931C42.3098 82.7983 42.9626 83.4511 43.7678 83.4511Z"
        fill="white"
      />
      <path
        d="M226.611 52.9755C227.42 52.9755 228.076 52.3195 228.076 51.5103C228.076 50.7012 227.42 50.0452 226.611 50.0452C225.802 50.0452 225.146 50.7012 225.146 51.5103C225.146 52.3195 225.802 52.9755 226.611 52.9755Z"
        fill="white"
      />
      <path
        d="M232.735 52.9576C233.542 52.9576 234.197 52.3033 234.197 51.4961C234.197 50.6889 233.542 50.0345 232.735 50.0345C231.928 50.0345 231.274 50.6889 231.274 51.4961C231.274 52.3033 231.928 52.9576 232.735 52.9576Z"
        fill="white"
      />
      <path
        d="M263.186 77.3267C263.991 77.3267 264.644 76.674 264.644 75.8687C264.644 75.0635 263.991 74.4107 263.186 74.4107C262.381 74.4107 261.728 75.0635 261.728 75.8687C261.728 76.674 262.381 77.3267 263.186 77.3267Z"
        fill="white"
      />
      <path
        d="M238.813 52.9612C239.616 52.9612 240.268 52.31 240.268 51.5068C240.268 50.7035 239.616 50.0523 238.813 50.0523C238.01 50.0523 237.359 50.7035 237.359 51.5068C237.359 52.31 238.01 52.9612 238.813 52.9612Z"
        fill="white"
      />
      <path
        d="M25.4875 120.023C26.2888 120.023 26.9384 119.373 26.9384 118.572C26.9384 117.77 26.2888 117.121 25.4875 117.121C24.6862 117.121 24.0366 117.77 24.0366 118.572C24.0366 119.373 24.6862 120.023 25.4875 120.023Z"
        fill="white"
      />
      <path
        d="M232.71 46.8511C233.515 46.8511 234.168 46.1983 234.168 45.3931C234.168 44.5879 233.515 43.9351 232.71 43.9351C231.905 43.9351 231.252 44.5879 231.252 45.3931C231.252 46.1983 231.905 46.8511 232.71 46.8511Z"
        fill="white"
      />
      <path
        d="M305.874 113.909C306.678 113.909 307.329 113.258 307.329 112.454C307.329 111.651 306.678 111 305.874 111C305.071 111 304.42 111.651 304.42 112.454C304.42 113.258 305.071 113.909 305.874 113.909Z"
        fill="white"
      />
      <path
        d="M305.874 101.71C306.674 101.71 307.322 101.062 307.322 100.263C307.322 99.4634 306.674 98.8154 305.874 98.8154C305.075 98.8154 304.427 99.4634 304.427 100.263C304.427 101.062 305.075 101.71 305.874 101.71Z"
        fill="white"
      />
      <path
        d="M74.2078 40.7767C75.0091 40.7767 75.6587 40.1271 75.6587 39.3258C75.6587 38.5245 75.0091 37.8749 74.2078 37.8749C73.4065 37.8749 72.7569 38.5245 72.7569 39.3258C72.7569 40.1271 73.4065 40.7767 74.2078 40.7767Z"
        fill="white"
      />
      <path
        d="M43.7678 77.3267C44.5652 77.3267 45.2116 76.6803 45.2116 75.883C45.2116 75.0856 44.5652 74.4392 43.7678 74.4392C42.9705 74.4392 42.3241 75.0856 42.3241 75.883C42.3241 76.6803 42.9705 77.3267 43.7678 77.3267Z"
        fill="white"
      />
      <path
        d="M55.9559 101.749C56.7513 101.749 57.3961 101.104 57.3961 100.309C57.3961 99.5137 56.7513 98.8689 55.9559 98.8689C55.1606 98.8689 54.5158 99.5137 54.5158 100.309C54.5158 101.104 55.1606 101.749 55.9559 101.749Z"
        fill="white"
      />
      <path
        d="M348.552 205.329C349.348 205.329 349.993 204.684 349.993 203.888C349.993 203.093 349.348 202.448 348.552 202.448C347.757 202.448 347.112 203.093 347.112 203.888C347.112 204.684 347.757 205.329 348.552 205.329Z"
        fill="white"
      />
      <path
        d="M244.888 211.403C245.679 211.403 246.321 210.761 246.321 209.97C246.321 209.178 245.679 208.537 244.888 208.537C244.096 208.537 243.455 209.178 243.455 209.97C243.455 210.761 244.096 211.403 244.888 211.403Z"
        fill="white"
      />
      <path
        d="M238.827 22.4571C239.619 22.4571 240.26 21.8155 240.26 21.024C240.26 20.2326 239.619 19.591 238.827 19.591C238.036 19.591 237.394 20.2326 237.394 21.024C237.394 21.8155 238.036 22.4571 238.827 22.4571Z"
        fill="white"
      />
      <path
        d="M293.676 95.6213C294.471 95.6213 295.116 94.9766 295.116 94.1812C295.116 93.3858 294.471 92.741 293.676 92.741C292.88 92.741 292.235 93.3858 292.235 94.1812C292.235 94.9766 292.88 95.6213 293.676 95.6213Z"
        fill="white"
      />
      <path
        d="M318.07 113.859C318.853 113.859 319.488 113.224 319.488 112.44C319.488 111.657 318.853 111.021 318.07 111.021C317.286 111.021 316.651 111.657 316.651 112.44C316.651 113.224 317.286 113.859 318.07 113.859Z"
        fill="white"
      />
      <path
        d="M299.779 101.706C300.562 101.706 301.197 101.071 301.197 100.288C301.197 99.5041 300.562 98.8689 299.779 98.8689C298.995 98.8689 298.36 99.5041 298.36 100.288C298.36 101.071 298.995 101.706 299.779 101.706Z"
        fill="white"
      />
      <path
        d="M62.0375 107.802C62.8211 107.802 63.4563 107.167 63.4563 106.384C63.4563 105.6 62.8211 104.965 62.0375 104.965C61.2539 104.965 60.6187 105.6 60.6187 106.384C60.6187 107.167 61.2539 107.802 62.0375 107.802Z"
        fill="white"
      />
      <path
        d="M92.5345 95.5999C93.324 95.5999 93.964 94.9599 93.964 94.1705C93.964 93.381 93.324 92.741 92.5345 92.741C91.745 92.741 91.105 93.381 91.105 94.1705C91.105 94.9599 91.745 95.5999 92.5345 95.5999Z"
        fill="white"
      />
      <path
        d="M324.173 119.965C324.952 119.965 325.584 119.333 325.584 118.554C325.584 117.774 324.952 117.142 324.173 117.142C323.393 117.142 322.761 117.774 322.761 118.554C322.761 119.333 323.393 119.965 324.173 119.965Z"
        fill="white"
      />
      <path
        d="M318.059 95.5572C318.841 95.5572 319.474 94.9236 319.474 94.1419C319.474 93.3603 318.841 92.7267 318.059 92.7267C317.277 92.7267 316.644 93.3603 316.644 94.1419C316.644 94.9236 317.277 95.5572 318.059 95.5572Z"
        fill="white"
      />
      <path
        d="M55.9559 95.5643C56.7356 95.5643 57.3676 94.9323 57.3676 94.1526C57.3676 93.373 56.7356 92.741 55.9559 92.741C55.1763 92.741 54.5443 93.373 54.5443 94.1526C54.5443 94.9323 55.1763 95.5643 55.9559 95.5643Z"
        fill="white"
      />
      <path
        d="M324.158 107.767C324.936 107.767 325.566 107.136 325.566 106.359C325.566 105.581 324.936 104.95 324.158 104.95C323.381 104.95 322.75 105.581 322.75 106.359C322.75 107.136 323.381 107.767 324.158 107.767Z"
        fill="white"
      />
      <path
        d="M62.0304 95.5679C62.8061 95.5679 63.4349 94.939 63.4349 94.1633C63.4349 93.3876 62.8061 92.7588 62.0304 92.7588C61.2547 92.7588 60.6259 93.3876 60.6259 94.1633C60.6259 94.939 61.2547 95.5679 62.0304 95.5679Z"
        fill="white"
      />
      <path
        d="M171.784 4.13036C172.56 4.13036 173.188 3.50154 173.188 2.72583C173.188 1.95013 172.56 1.3213 171.784 1.3213C171.008 1.3213 170.379 1.95013 170.379 2.72583C170.379 3.50154 171.008 4.13036 171.784 4.13036Z"
        fill="white"
      />
      <path
        d="M269.314 83.3584C270.087 83.3584 270.715 82.7311 270.715 81.9574C270.715 81.1837 270.087 80.5564 269.314 80.5564C268.54 80.5564 267.913 81.1837 267.913 81.9574C267.913 82.7311 268.54 83.3584 269.314 83.3584Z"
        fill="white"
      />
      <path
        d="M324.158 113.891C324.938 113.891 325.57 113.259 325.57 112.479C325.57 111.7 324.938 111.068 324.158 111.068C323.379 111.068 322.747 111.7 322.747 112.479C322.747 113.259 323.379 113.891 324.158 113.891Z"
        fill="white"
      />
      <path
        d="M62.0518 89.4792C62.8216 89.4792 63.4456 88.8551 63.4456 88.0853C63.4456 87.3155 62.8216 86.6915 62.0518 86.6915C61.282 86.6915 60.6579 87.3155 60.6579 88.0853C60.6579 88.8551 61.282 89.4792 62.0518 89.4792Z"
        fill="white"
      />
      <path
        d="M263.221 217.467C263.995 217.467 264.622 216.839 264.622 216.066C264.622 215.292 263.995 214.665 263.221 214.665C262.448 214.665 261.82 215.292 261.82 216.066C261.82 216.839 262.448 217.467 263.221 217.467Z"
        fill="white"
      />
      <path
        d="M68.1797 83.3905C68.9515 83.3905 69.5771 82.7648 69.5771 81.9931C69.5771 81.2213 68.9515 80.5956 68.1797 80.5956C67.4079 80.5956 66.7823 81.2213 66.7823 81.9931C66.7823 82.7648 67.4079 83.3905 68.1797 83.3905Z"
        fill="white"
      />
      <path
        d="M62.0518 40.7089C62.8157 40.7089 63.4349 40.0897 63.4349 39.3258C63.4349 38.5619 62.8157 37.9426 62.0518 37.9426C61.2879 37.9426 60.6686 38.5619 60.6686 39.3258C60.6686 40.0897 61.2879 40.7089 62.0518 40.7089Z"
        fill="white"
      />
      <path
        d="M281.502 223.555C282.266 223.555 282.885 222.936 282.885 222.172C282.885 221.408 282.266 220.789 281.502 220.789C280.738 220.789 280.119 221.408 280.119 222.172C280.119 222.936 280.738 223.555 281.502 223.555Z"
        fill="white"
      />
      <path
        d="M98.6696 16.3327C99.4374 16.3327 100.06 15.7103 100.06 14.9425C100.06 14.1746 99.4374 13.5522 98.6696 13.5522C97.9017 13.5522 97.2793 14.1746 97.2793 14.9425C97.2793 15.7103 97.9017 16.3327 98.6696 16.3327Z"
        fill="white"
      />
      <path
        d="M354.648 174.789C355.408 174.789 356.024 174.173 356.024 173.413C356.024 172.653 355.408 172.037 354.648 172.037C353.888 172.037 353.272 172.653 353.272 173.413C353.272 174.173 353.888 174.789 354.648 174.789Z"
        fill="white"
      />
      <path
        d="M330.268 132.15C331.032 132.15 331.652 131.531 331.652 130.767C331.652 130.003 331.032 129.384 330.268 129.384C329.505 129.384 328.885 130.003 328.885 130.767C328.885 131.531 329.505 132.15 330.268 132.15Z"
        fill="white"
      />
      <path
        d="M336.357 138.203C337.121 138.203 337.74 137.584 337.74 136.82C337.74 136.056 337.121 135.437 336.357 135.437C335.593 135.437 334.974 136.056 334.974 136.82C334.974 137.584 335.593 138.203 336.357 138.203Z"
        fill="white"
      />
      <path
        d="M324.148 126.011C324.91 126.011 325.527 125.394 325.527 124.632C325.527 123.87 324.91 123.252 324.148 123.252C323.386 123.252 322.768 123.87 322.768 124.632C322.768 125.394 323.386 126.011 324.148 126.011Z"
        fill="white"
      />
      <path
        d="M251.015 205.279C251.781 205.279 252.402 204.658 252.402 203.892C252.402 203.126 251.781 202.505 251.015 202.505C250.25 202.505 249.629 203.126 249.629 203.892C249.629 204.658 250.25 205.279 251.015 205.279Z"
        fill="white"
      />
      <path
        d="M202.267 52.8828C203.027 52.8828 203.643 52.2667 203.643 51.5068C203.643 50.7468 203.027 50.1307 202.267 50.1307C201.507 50.1307 200.891 50.7468 200.891 51.5068C200.891 52.2667 201.507 52.8828 202.267 52.8828Z"
        fill="white"
      />
      <path
        d="M330.276 125.994C331.036 125.994 331.652 125.378 331.652 124.618C331.652 123.858 331.036 123.242 330.276 123.242C329.516 123.242 328.9 123.858 328.9 124.618C328.9 125.378 329.516 125.994 330.276 125.994Z"
        fill="white"
      />
      <path
        d="M19.3988 71.1774C20.1568 71.1774 20.7712 70.5629 20.7712 69.805C20.7712 69.047 20.1568 68.4325 19.3988 68.4325C18.6408 68.4325 18.0263 69.047 18.0263 69.805C18.0263 70.5629 18.6408 71.1774 19.3988 71.1774Z"
        fill="white"
      />
      <path
        d="M55.9666 77.2483C56.7207 77.2483 57.332 76.637 57.332 75.883C57.332 75.1289 56.7207 74.5176 55.9666 74.5176C55.2126 74.5176 54.6013 75.1289 54.6013 75.883C54.6013 76.637 55.2126 77.2483 55.9666 77.2483Z"
        fill="white"
      />
      <path
        d="M31.5726 132.111C32.3267 132.111 32.9379 131.499 32.9379 130.745C32.9379 129.991 32.3267 129.38 31.5726 129.38C30.8186 129.38 30.2073 129.991 30.2073 130.745C30.2073 131.499 30.8186 132.111 31.5726 132.111Z"
        fill="white"
      />
      <path
        d="M153.486 71.156C154.24 71.156 154.851 70.5447 154.851 69.7907C154.851 69.0366 154.24 68.4254 153.486 68.4254C152.732 68.4254 152.12 69.0366 152.12 69.7907C152.12 70.5447 152.732 71.156 153.486 71.156Z"
        fill="white"
      />
      <path
        d="M141.226 83.3477C141.98 83.3477 142.592 82.7364 142.592 81.9824C142.592 81.2283 141.98 80.6171 141.226 80.6171C140.472 80.6171 139.861 81.2283 139.861 81.9824C139.861 82.7364 140.472 83.3477 141.226 83.3477Z"
        fill="white"
      />
      <path
        d="M190.064 16.2721C190.818 16.2721 191.43 15.6608 191.43 14.9068C191.43 14.1528 190.818 13.5415 190.064 13.5415C189.31 13.5415 188.699 14.1528 188.699 14.9068C188.699 15.6608 189.31 16.2721 190.064 16.2721Z"
        fill="white"
      />
      <path
        d="M336.343 144.277C337.091 144.277 337.698 143.671 337.698 142.923C337.698 142.175 337.091 141.568 336.343 141.568C335.595 141.568 334.988 142.175 334.988 142.923C334.988 143.671 335.595 144.277 336.343 144.277Z"
        fill="white"
      />
      <path
        d="M202.267 46.7762C203.015 46.7762 203.621 46.1698 203.621 45.4216C203.621 44.6735 203.015 44.067 202.267 44.067C201.518 44.067 200.912 44.6735 200.912 45.4216C200.912 46.1698 201.518 46.7762 202.267 46.7762Z"
        fill="white"
      />
      <path
        d="M348.549 168.654C349.291 168.654 349.893 168.052 349.893 167.31C349.893 166.568 349.291 165.966 348.549 165.966C347.807 165.966 347.205 166.568 347.205 167.31C347.205 168.052 347.807 168.654 348.549 168.654Z"
        fill="white"
      />
      <path
        d="M348.549 174.432C349.112 174.432 349.568 173.976 349.568 173.413C349.568 172.85 349.112 172.393 348.549 172.393C347.986 172.393 347.529 172.85 347.529 173.413C347.529 173.976 347.986 174.432 348.549 174.432Z"
        fill="white"
      />
      <path
        d="M116.907 150.366C117.642 150.366 118.237 149.771 118.237 149.037C118.237 148.302 117.642 147.707 116.907 147.707C116.173 147.707 115.577 148.302 115.577 149.037C115.577 149.771 116.173 150.366 116.907 150.366Z"
        fill="white"
      />
      <path
        d="M49.8708 65.0495C50.6032 65.0495 51.1969 64.4558 51.1969 63.7234C51.1969 62.991 50.6032 62.3973 49.8708 62.3973C49.1384 62.3973 48.5447 62.991 48.5447 63.7234C48.5447 64.4558 49.1384 65.0495 49.8708 65.0495Z"
        fill="white"
      />
      <path
        d="M342.424 150.359C343.159 150.359 343.754 149.764 343.754 149.029C343.754 148.295 343.159 147.7 342.424 147.7C341.69 147.7 341.095 148.295 341.095 149.029C341.095 149.764 341.69 150.359 342.424 150.359Z"
        fill="white"
      />
      <path
        d="M330.24 119.891C330.974 119.891 331.57 119.295 331.57 118.561C331.57 117.827 330.974 117.231 330.24 117.231C329.506 117.231 328.91 117.827 328.91 118.561C328.91 119.295 329.506 119.891 330.24 119.891Z"
        fill="white"
      />
      <path
        d="M342.428 199.122C343.156 199.122 343.747 198.532 343.747 197.803C343.747 197.075 343.156 196.484 342.428 196.484C341.7 196.484 341.109 197.075 341.109 197.803C341.109 198.532 341.7 199.122 342.428 199.122Z"
        fill="white"
      />
      <path
        d="M25.4875 125.983C26.214 125.983 26.8029 125.394 26.8029 124.667C26.8029 123.941 26.214 123.352 25.4875 123.352C24.761 123.352 24.1721 123.941 24.1721 124.667C24.1721 125.394 24.761 125.983 25.4875 125.983Z"
        fill="white"
      />
      <path
        d="M238.82 46.7335C239.543 46.7335 240.129 46.1477 240.129 45.4252C240.129 44.7026 239.543 44.1169 238.82 44.1169C238.098 44.1169 237.512 44.7026 237.512 45.4252C237.512 46.1477 238.098 46.7335 238.82 46.7335Z"
        fill="white"
      />
      <path
        d="M336.357 132.018C337.078 132.018 337.662 131.434 337.662 130.713C337.662 129.993 337.078 129.409 336.357 129.409C335.637 129.409 335.052 129.993 335.052 130.713C335.052 131.434 335.637 132.018 336.357 132.018Z"
        fill="white"
      />
      <path
        d="M104.723 95.5073C105.443 95.5073 106.027 94.9231 106.027 94.2026C106.027 93.482 105.443 92.8978 104.723 92.8978C104.002 92.8978 103.418 93.482 103.418 94.2026C103.418 94.9231 104.002 95.5073 104.723 95.5073Z"
        fill="white"
      />
      <path
        d="M165.692 180.785C166.406 180.785 166.986 180.205 166.986 179.491C166.986 178.776 166.406 178.197 165.692 178.197C164.977 178.197 164.398 178.776 164.398 179.491C164.398 180.205 164.977 180.785 165.692 180.785Z"
        fill="white"
      />
      <path
        d="M116.911 83.2586C117.623 83.2586 118.201 82.6808 118.201 81.9681C118.201 81.2554 117.623 80.6776 116.911 80.6776C116.198 80.6776 115.62 81.2554 115.62 81.9681C115.62 82.6808 116.198 83.2586 116.911 83.2586Z"
        fill="white"
      />
      <path
        d="M275.424 223.448C276.136 223.448 276.714 222.871 276.714 222.158C276.714 221.445 276.136 220.868 275.424 220.868C274.711 220.868 274.133 221.445 274.133 222.158C274.133 222.871 274.711 223.448 275.424 223.448Z"
        fill="white"
      />
      <path
        d="M318.073 119.834C318.788 119.834 319.367 119.254 319.367 118.54C319.367 117.825 318.788 117.246 318.073 117.246C317.359 117.246 316.779 117.825 316.779 118.54C316.779 119.254 317.359 119.834 318.073 119.834Z"
        fill="white"
      />
      <path
        d="M165.688 58.8681C166.401 58.8681 166.979 58.2903 166.979 57.5776C166.979 56.8649 166.401 56.2872 165.688 56.2872C164.975 56.2872 164.398 56.8649 164.398 57.5776C164.398 58.2903 164.975 58.8681 165.688 58.8681Z"
        fill="white"
      />
      <path
        d="M31.5726 107.66C32.2755 107.66 32.8453 107.09 32.8453 106.387C32.8453 105.684 32.2755 105.114 31.5726 105.114C30.8698 105.114 30.3 105.684 30.3 106.387C30.3 107.09 30.8698 107.66 31.5726 107.66Z"
        fill="white"
      />
      <path
        d="M348.577 144.199C349.276 144.199 349.843 143.632 349.843 142.934C349.843 142.235 349.276 141.668 348.577 141.668C347.878 141.668 347.312 142.235 347.312 142.934C347.312 143.632 347.878 144.199 348.577 144.199Z"
        fill="white"
      />
      <path
        d="M330.24 113.723C330.939 113.723 331.505 113.157 331.505 112.458C331.505 111.759 330.939 111.192 330.24 111.192C329.541 111.192 328.974 111.759 328.974 112.458C328.974 113.157 329.541 113.723 330.24 113.723Z"
        fill="white"
      />
      <path
        d="M123.035 150.27C123.734 150.27 124.301 149.703 124.301 149.004C124.301 148.305 123.734 147.739 123.035 147.739C122.336 147.739 121.77 148.305 121.77 149.004C121.77 149.703 122.336 150.27 123.035 150.27Z"
        fill="white"
      />
      <path
        d="M336.375 125.926C337.07 125.926 337.633 125.362 337.633 124.667C337.633 123.972 337.07 123.409 336.375 123.409C335.68 123.409 335.117 123.972 335.117 124.667C335.117 125.362 335.68 125.926 336.375 125.926Z"
        fill="white"
      />
      <path
        d="M348.542 211.246C349.241 211.246 349.807 210.68 349.807 209.981C349.807 209.282 349.241 208.715 348.542 208.715C347.843 208.715 347.276 209.282 347.276 209.981C347.276 210.68 347.843 211.246 348.542 211.246Z"
        fill="white"
      />
      <path
        d="M281.484 95.4431C282.177 95.4431 282.739 94.8813 282.739 94.1883C282.739 93.4953 282.177 92.9335 281.484 92.9335C280.791 92.9335 280.229 93.4953 280.229 94.1883C280.229 94.8813 280.791 95.4431 281.484 95.4431Z"
        fill="white"
      />
      <path
        d="M287.612 94.6909C287.889 94.6909 288.115 94.4659 288.115 94.1883C288.115 93.9107 287.889 93.6857 287.612 93.6857C287.334 93.6857 287.109 93.9107 287.109 94.1883C287.109 94.4659 287.334 94.6909 287.612 94.6909Z"
        fill="white"
      />
      <path
        d="M330.243 144.217C330.935 144.217 331.495 143.657 331.495 142.966C331.495 142.275 330.935 141.714 330.243 141.714C329.552 141.714 328.992 142.275 328.992 142.966C328.992 143.657 329.552 144.217 330.243 144.217Z"
        fill="white"
      />
      <path
        d="M305.885 107.621C306.576 107.621 307.136 107.06 307.136 106.369C307.136 105.678 306.576 105.118 305.885 105.118C305.194 105.118 304.634 105.678 304.634 106.369C304.634 107.06 305.194 107.621 305.885 107.621Z"
        fill="white"
      />
      <path
        d="M348.552 180.763C349.247 180.763 349.811 180.2 349.811 179.505C349.811 178.81 349.247 178.247 348.552 178.247C347.857 178.247 347.294 178.81 347.294 179.505C347.294 180.2 347.857 180.763 348.552 180.763Z"
        fill="white"
      />
      <path
        d="M37.6791 144.199C38.3623 144.199 38.9161 143.645 38.9161 142.962C38.9161 142.279 38.3623 141.725 37.6791 141.725C36.996 141.725 36.4422 142.279 36.4422 142.962C36.4422 143.645 36.996 144.199 37.6791 144.199Z"
        fill="white"
      />
      <path
        d="M62.0518 77.1199C62.7349 77.1199 63.2888 76.5661 63.2888 75.883C63.2888 75.1998 62.7349 74.646 62.0518 74.646C61.3686 74.646 60.8148 75.1998 60.8148 75.883C60.8148 76.5661 61.3686 77.1199 62.0518 77.1199Z"
        fill="white"
      />
      <path
        d="M342.464 180.717C343.147 180.717 343.701 180.163 343.701 179.48C343.701 178.797 343.147 178.243 342.464 178.243C341.781 178.243 341.227 178.797 341.227 179.48C341.227 180.163 341.781 180.717 342.464 180.717Z"
        fill="white"
      />
      <path
        d="M183.958 16.1687C184.641 16.1687 185.195 15.6149 185.195 14.9318C185.195 14.2486 184.641 13.6948 183.958 13.6948C183.275 13.6948 182.721 14.2486 182.721 14.9318C182.721 15.6149 183.275 16.1687 183.958 16.1687Z"
        fill="white"
      />
      <path
        d="M342.414 144.181C343.093 144.181 343.644 143.631 343.644 142.951C343.644 142.272 343.093 141.722 342.414 141.722C341.735 141.722 341.184 142.272 341.184 142.951C341.184 143.631 341.735 144.181 342.414 144.181Z"
        fill="white"
      />
      <path
        d="M324.155 101.457C324.834 101.457 325.385 100.906 325.385 100.227C325.385 99.5479 324.834 98.9972 324.155 98.9972C323.476 98.9972 322.925 99.5479 322.925 100.227C322.925 100.906 323.476 101.457 324.155 101.457Z"
        fill="white"
      />
      <path
        d="M110.836 156.394C111.512 156.394 112.059 155.847 112.059 155.172C112.059 154.496 111.512 153.949 110.836 153.949C110.161 153.949 109.614 154.496 109.614 155.172C109.614 155.847 110.161 156.394 110.836 156.394Z"
        fill="white"
      />
      <path
        d="M190.05 186.827C190.721 186.827 191.266 186.283 191.266 185.612C191.266 184.94 190.721 184.396 190.05 184.396C189.379 184.396 188.834 184.94 188.834 185.612C188.834 186.283 189.379 186.827 190.05 186.827Z"
        fill="white"
      />
      <path
        d="M238.842 205.111C239.517 205.111 240.064 204.564 240.064 203.888C240.064 203.213 239.517 202.666 238.842 202.666C238.166 202.666 237.619 203.213 237.619 203.888C237.619 204.564 238.166 205.111 238.842 205.111Z"
        fill="white"
      />
      <path
        d="M269.307 217.296C269.982 217.296 270.529 216.748 270.529 216.073C270.529 215.398 269.982 214.85 269.307 214.85C268.631 214.85 268.084 215.398 268.084 216.073C268.084 216.748 268.631 217.296 269.307 217.296Z"
        fill="white"
      />
      <path
        d="M257.108 217.121C257.687 217.121 258.156 216.652 258.156 216.073C258.156 215.494 257.687 215.025 257.108 215.025C256.529 215.025 256.06 215.494 256.06 216.073C256.06 216.652 256.529 217.121 257.108 217.121Z"
        fill="white"
      />
      <path
        d="M43.7821 101.521C44.4594 101.521 45.0084 100.972 45.0084 100.295C45.0084 99.6176 44.4594 99.0685 43.7821 99.0685C43.1048 99.0685 42.5558 99.6176 42.5558 100.295C42.5558 100.972 43.1048 101.521 43.7821 101.521Z"
        fill="white"
      />
      <path
        d="M7.2071 125.869C7.87452 125.869 8.41557 125.328 8.41557 124.66C8.41557 123.993 7.87452 123.452 7.2071 123.452C6.53968 123.452 5.99863 123.993 5.99863 124.66C5.99863 125.328 6.53968 125.869 7.2071 125.869Z"
        fill="white"
      />
      <path
        d="M281.484 229.466C282.149 229.466 282.689 228.926 282.689 228.261C282.689 227.596 282.149 227.056 281.484 227.056C280.819 227.056 280.279 227.596 280.279 228.261C280.279 228.926 280.819 229.466 281.484 229.466Z"
        fill="white"
      />
      <path
        d="M220.543 10.048C221.209 10.048 221.748 9.5085 221.748 8.84304C221.748 8.17759 221.209 7.63815 220.543 7.63815C219.878 7.63815 219.339 8.17759 219.339 8.84304C219.339 9.5085 219.878 10.048 220.543 10.048Z"
        fill="white"
      />
      <path
        d="M342.435 138.036C343.101 138.036 343.64 137.496 343.64 136.831C343.64 136.165 343.101 135.626 342.435 135.626C341.77 135.626 341.23 136.165 341.23 136.831C341.23 137.496 341.77 138.036 342.435 138.036Z"
        fill="white"
      />
      <path
        d="M110.833 89.2582C111.498 89.2582 112.038 88.7187 112.038 88.0533C112.038 87.3878 111.498 86.8483 110.833 86.8483C110.167 86.8483 109.628 87.3878 109.628 88.0533C109.628 88.7187 110.167 89.2582 110.833 89.2582Z"
        fill="white"
      />
      <path
        d="M49.8744 77.0843C50.5378 77.0843 51.0757 76.5464 51.0757 75.883C51.0757 75.2195 50.5378 74.6816 49.8744 74.6816C49.2109 74.6816 48.673 75.2195 48.673 75.883C48.673 76.5464 49.2109 77.0843 49.8744 77.0843Z"
        fill="white"
      />
      <path
        d="M293.686 107.588C294.35 107.588 294.888 107.051 294.888 106.387C294.888 105.724 294.35 105.186 293.686 105.186C293.023 105.186 292.485 105.724 292.485 106.387C292.485 107.051 293.023 107.588 293.686 107.588Z"
        fill="white"
      />
      <path
        d="M226.643 198.972C227.296 198.972 227.826 198.443 227.826 197.789C227.826 197.135 227.296 196.605 226.643 196.605C225.989 196.605 225.459 197.135 225.459 197.789C225.459 198.443 225.989 198.972 226.643 198.972Z"
        fill="white"
      />
      <path
        d="M226.643 192.335C227.015 192.335 227.317 192.033 227.317 191.661C227.317 191.289 227.015 190.987 226.643 190.987C226.271 190.987 225.969 191.289 225.969 191.661C225.969 192.033 226.271 192.335 226.643 192.335Z"
        fill="white"
      />
      <path
        d="M348.527 162.408C349.181 162.408 349.711 161.878 349.711 161.225C349.711 160.571 349.181 160.041 348.527 160.041C347.874 160.041 347.344 160.571 347.344 161.225C347.344 161.878 347.874 162.408 348.527 162.408Z"
        fill="white"
      />
      <path
        d="M336.346 119.734C337 119.734 337.53 119.204 337.53 118.55C337.53 117.897 337 117.367 336.346 117.367C335.693 117.367 335.163 117.897 335.163 118.55C335.163 119.204 335.693 119.734 336.346 119.734Z"
        fill="white"
      />
      <path
        d="M55.9738 70.9885C56.6274 70.9885 57.1573 70.4586 57.1573 69.8049C57.1573 69.1513 56.6274 68.6214 55.9738 68.6214C55.3201 68.6214 54.7903 69.1513 54.7903 69.8049C54.7903 70.4586 55.3201 70.9885 55.9738 70.9885Z"
        fill="white"
      />
      <path
        d="M62.066 150.216C62.7157 150.216 63.2424 149.69 63.2424 149.04C63.2424 148.39 62.7157 147.864 62.066 147.864C61.4163 147.864 60.8897 148.39 60.8897 149.04C60.8897 149.69 61.4163 150.216 62.066 150.216Z"
        fill="white"
      />
      <path
        d="M348.542 156.294C349.191 156.294 349.718 155.768 349.718 155.118C349.718 154.468 349.191 153.942 348.542 153.942C347.892 153.942 347.365 154.468 347.365 155.118C347.365 155.768 347.892 156.294 348.542 156.294Z"
        fill="white"
      />
      <path
        d="M238.813 64.8748C239.459 64.8748 239.982 64.3513 239.982 63.7056C239.982 63.0598 239.459 62.5363 238.813 62.5363C238.167 62.5363 237.644 63.0598 237.644 63.7056C237.644 64.3513 238.167 64.8748 238.813 64.8748Z"
        fill="white"
      />
      <path
        d="M49.8637 119.748C50.5094 119.748 51.0329 119.225 51.0329 118.579C51.0329 117.933 50.5094 117.409 49.8637 117.409C49.2179 117.409 48.6944 117.933 48.6944 118.579C48.6944 119.225 49.2179 119.748 49.8637 119.748Z"
        fill="white"
      />
      <path
        d="M263.218 83.1409C263.858 83.1409 264.376 82.6222 264.376 81.9824C264.376 81.3425 263.858 80.8238 263.218 80.8238C262.578 80.8238 262.059 81.3425 262.059 81.9824C262.059 82.6222 262.578 83.1409 263.218 83.1409Z"
        fill="white"
      />
      <path
        d="M171.791 52.6653C172.431 52.6653 172.95 52.1466 172.95 51.5068C172.95 50.8669 172.431 50.3482 171.791 50.3482C171.151 50.3482 170.632 50.8669 170.632 51.5068C170.632 52.1466 171.151 52.6653 171.791 52.6653Z"
        fill="white"
      />
      <path
        d="M37.6791 131.918C38.3249 131.918 38.8484 131.395 38.8484 130.749C38.8484 130.103 38.3249 129.58 37.6791 129.58C37.0334 129.58 36.5099 130.103 36.5099 130.749C36.5099 131.395 37.0334 131.918 37.6791 131.918Z"
        fill="white"
      />
      <path
        d="M238.813 70.9314C239.451 70.9314 239.968 70.4143 239.968 69.7764C239.968 69.1385 239.451 68.6214 238.813 68.6214C238.175 68.6214 237.658 69.1385 237.658 69.7764C237.658 70.4143 238.175 70.9314 238.813 70.9314Z"
        fill="white"
      />
      <path
        d="M135.195 77.0451C135.833 77.0451 136.35 76.528 136.35 75.8901C136.35 75.2522 135.833 74.7351 135.195 74.7351C134.557 74.7351 134.04 75.2522 134.04 75.8901C134.04 76.528 134.557 77.0451 135.195 77.0451Z"
        fill="white"
      />
      <path
        d="M110.833 95.2898C111.469 95.2898 111.984 94.7743 111.984 94.1384C111.984 93.5025 111.469 92.987 110.833 92.987C110.197 92.987 109.681 93.5025 109.681 94.1384C109.681 94.7743 110.197 95.2898 110.833 95.2898Z"
        fill="white"
      />
      <path
        d="M116.921 168.486C117.555 168.486 118.069 167.972 118.069 167.338C118.069 166.704 117.555 166.19 116.921 166.19C116.287 166.19 115.774 166.704 115.774 167.338C115.774 167.972 116.287 168.486 116.921 168.486Z"
        fill="white"
      />
      <path
        d="M80.35 95.2934C80.978 95.2934 81.4871 94.7842 81.4871 94.1562C81.4871 93.5282 80.978 93.019 80.35 93.019C79.7219 93.019 79.2128 93.5282 79.2128 94.1562C79.2128 94.7842 79.7219 95.2934 80.35 95.2934Z"
        fill="white"
      />
      <path
        d="M19.3988 131.9C20.0268 131.9 20.5359 131.391 20.5359 130.763C20.5359 130.135 20.0268 129.626 19.3988 129.626C18.7707 129.626 18.2616 130.135 18.2616 130.763C18.2616 131.391 18.7707 131.9 19.3988 131.9Z"
        fill="white"
      />
      <path
        d="M92.5274 162.376C93.1515 162.376 93.6574 161.87 93.6574 161.246C93.6574 160.622 93.1515 160.116 92.5274 160.116C91.9033 160.116 91.3973 160.622 91.3973 161.246C91.3973 161.87 91.9033 162.376 92.5274 162.376Z"
        fill="white"
      />
      <path
        d="M348.549 150.159C349.169 150.159 349.672 149.657 349.672 149.037C349.672 148.416 349.169 147.914 348.549 147.914C347.929 147.914 347.426 148.416 347.426 149.037C347.426 149.657 347.929 150.159 348.549 150.159Z"
        fill="white"
      />
      <path
        d="M147.411 77.0059C148.031 77.0059 148.534 76.5031 148.534 75.883C148.534 75.2628 148.031 74.76 147.411 74.76C146.791 74.76 146.288 75.2628 146.288 75.883C146.288 76.5031 146.791 77.0059 147.411 77.0059Z"
        fill="white"
      />
      <path
        d="M135.17 174.553C135.79 174.553 136.293 174.051 136.293 173.431C136.293 172.81 135.79 172.308 135.17 172.308C134.55 172.308 134.047 172.81 134.047 173.431C134.047 174.051 134.55 174.553 135.17 174.553Z"
        fill="white"
      />
      <path
        d="M68.1797 89.1869C68.7881 89.1869 69.2812 88.6937 69.2812 88.0853C69.2812 87.477 68.7881 86.9838 68.1797 86.9838C67.5713 86.9838 67.0782 87.477 67.0782 88.0853C67.0782 88.6937 67.5713 89.1869 68.1797 89.1869Z"
        fill="white"
      />
      <path
        d="M43.7857 144.003C44.3842 144.003 44.8694 143.518 44.8694 142.919C44.8694 142.321 44.3842 141.836 43.7857 141.836C43.1872 141.836 42.702 142.321 42.702 142.919C42.702 143.518 43.1872 144.003 43.7857 144.003Z"
        fill="white"
      />
      <path
        d="M37.6791 113.535C38.2737 113.535 38.7557 113.053 38.7557 112.458C38.7557 111.863 38.2737 111.381 37.6791 111.381C37.0846 111.381 36.6026 111.863 36.6026 112.458C36.6026 113.053 37.0846 113.535 37.6791 113.535Z"
        fill="white"
      />
      <path
        d="M25.4875 113.535C26.082 113.535 26.564 113.053 26.564 112.458C26.564 111.863 26.082 111.381 25.4875 111.381C24.8929 111.381 24.4109 111.863 24.4109 112.458C24.4109 113.053 24.8929 113.535 25.4875 113.535Z"
        fill="white"
      />
      <path
        d="M98.6696 107.453C99.2563 107.453 99.7319 106.977 99.7319 106.391C99.7319 105.804 99.2563 105.328 98.6696 105.328C98.0829 105.328 97.6072 105.804 97.6072 106.391C97.6072 106.977 98.0829 107.453 98.6696 107.453Z"
        fill="white"
      />
      <path
        d="M177.898 46.4697C178.488 46.4697 178.967 45.9909 178.967 45.4002C178.967 44.8096 178.488 44.3308 177.898 44.3308C177.307 44.3308 176.828 44.8096 176.828 45.4002C176.828 45.9909 177.307 46.4697 177.898 46.4697Z"
        fill="white"
      />
      <path
        d="M183.968 21.7869C184.354 21.7869 184.667 21.4741 184.667 21.0882C184.667 20.7023 184.354 20.3895 183.968 20.3895C183.583 20.3895 183.27 20.7023 183.27 21.0882C183.27 21.4741 183.583 21.7869 183.968 21.7869Z"
        fill="white"
      />
      <path
        d="M342.417 131.811C343.004 131.811 343.48 131.336 343.48 130.749C343.48 130.162 343.004 129.687 342.417 129.687C341.831 129.687 341.355 130.162 341.355 130.749C341.355 131.336 341.831 131.811 342.417 131.811Z"
        fill="white"
      />
      <path
        d="M287.612 101.343C288.197 101.343 288.671 100.869 288.671 100.284C288.671 99.6994 288.197 99.2254 287.612 99.2254C287.027 99.2254 286.553 99.6994 286.553 100.284C286.553 100.869 287.027 101.343 287.612 101.343Z"
        fill="white"
      />
      <path
        d="M80.3607 156.216C80.9415 156.216 81.4123 155.745 81.4123 155.164C81.4123 154.584 80.9415 154.113 80.3607 154.113C79.7799 154.113 79.309 154.584 79.309 155.164C79.309 155.745 79.7799 156.216 80.3607 156.216Z"
        fill="white"
      />
      <path
        d="M269.289 89.1655C269.868 89.1655 270.337 88.6962 270.337 88.1174C270.337 87.5386 269.868 87.0694 269.289 87.0694C268.71 87.0694 268.241 87.5386 268.241 88.1174C268.241 88.6962 268.71 89.1655 269.289 89.1655Z"
        fill="white"
      />
      <path
        d="M116.907 95.2328C117.486 95.2328 117.955 94.7636 117.955 94.1847C117.955 93.6059 117.486 93.1367 116.907 93.1367C116.328 93.1367 115.859 93.6059 115.859 94.1847C115.859 94.7636 116.328 95.2328 116.907 95.2328Z"
        fill="white"
      />
      <path
        d="M251.019 76.9524C251.598 76.9524 252.067 76.4832 252.067 75.9044C252.067 75.3255 251.598 74.8563 251.019 74.8563C250.44 74.8563 249.971 75.3255 249.971 75.9044C249.971 76.4832 250.44 76.9524 251.019 76.9524Z"
        fill="white"
      />
      <path
        d="M232.728 64.7857C233.305 64.7857 233.772 64.318 233.772 63.7412C233.772 63.1643 233.305 62.6967 232.728 62.6967C232.151 62.6967 231.684 63.1643 231.684 63.7412C231.684 64.318 232.151 64.7857 232.728 64.7857Z"
        fill="white"
      />
      <path
        d="M220.501 58.6614C221.078 58.6614 221.545 58.1937 221.545 57.6169C221.545 57.04 221.078 56.5724 220.501 56.5724C219.924 56.5724 219.456 57.04 219.456 57.6169C219.456 58.1937 219.924 58.6614 220.501 58.6614Z"
        fill="white"
      />
      <path
        d="M98.6054 162.244C99.1803 162.244 99.6463 161.778 99.6463 161.203C99.6463 160.628 99.1803 160.162 98.6054 160.162C98.0305 160.162 97.5645 160.628 97.5645 161.203C97.5645 161.778 98.0305 162.244 98.6054 162.244Z"
        fill="white"
      />
      <path
        d="M153.486 64.775C154.059 64.775 154.523 64.3106 154.523 63.7376C154.523 63.1647 154.059 62.7003 153.486 62.7003C152.913 62.7003 152.448 63.1647 152.448 63.7376C152.448 64.3106 152.913 64.775 153.486 64.775Z"
        fill="white"
      />
      <path
        d="M336.364 156.173C336.929 156.173 337.387 155.715 337.387 155.15C337.387 154.585 336.929 154.127 336.364 154.127C335.799 154.127 335.341 154.585 335.341 155.15C335.341 155.715 335.799 156.173 336.364 156.173Z"
        fill="white"
      />
      <path
        d="M214.448 198.819C215.017 198.819 215.478 198.358 215.478 197.789C215.478 197.22 215.017 196.759 214.448 196.759C213.879 196.759 213.417 197.22 213.417 197.789C213.417 198.358 213.879 198.819 214.448 198.819Z"
        fill="white"
      />
      <path
        d="M74.2577 156.141C74.8149 156.141 75.2666 155.69 75.2666 155.132C75.2666 154.575 74.8149 154.124 74.2577 154.124C73.7005 154.124 73.2489 154.575 73.2489 155.132C73.2489 155.69 73.7005 156.141 74.2577 156.141Z"
        fill="white"
      />
      <path
        d="M208.359 52.5513C208.922 52.5513 209.378 52.0948 209.378 51.5317C209.378 50.9686 208.922 50.5122 208.359 50.5122C207.796 50.5122 207.339 50.9686 207.339 51.5317C207.339 52.0948 207.796 52.5513 208.359 52.5513Z"
        fill="white"
      />
      <path
        d="M116.907 89.0585C117.462 89.0585 117.912 88.6084 117.912 88.0532C117.912 87.498 117.462 87.048 116.907 87.048C116.352 87.048 115.902 87.498 115.902 88.0532C115.902 88.6084 116.352 89.0585 116.907 89.0585Z"
        fill="white"
      />
      <path
        d="M55.9559 150.013C56.5111 150.013 56.9612 149.563 56.9612 149.008C56.9612 148.453 56.5111 148.003 55.9559 148.003C55.4007 148.003 54.9507 148.453 54.9507 149.008C54.9507 149.563 55.4007 150.013 55.9559 150.013Z"
        fill="white"
      />
      <path
        d="M49.8672 70.8067C50.4205 70.8067 50.869 70.3582 50.869 69.8049C50.869 69.2517 50.4205 68.8032 49.8672 68.8032C49.314 68.8032 48.8655 69.2517 48.8655 69.8049C48.8655 70.3582 49.314 70.8067 49.8672 70.8067Z"
        fill="white"
      />
      <path
        d="M123.035 82.9876C123.578 82.9876 124.019 82.5471 124.019 82.0037C124.019 81.4604 123.578 81.0199 123.035 81.0199C122.492 81.0199 122.051 81.4604 122.051 82.0037C122.051 82.5471 122.492 82.9876 123.035 82.9876Z"
        fill="white"
      />
      <path
        d="M123.035 76.3785C123.311 76.3785 123.534 76.155 123.534 75.8794C123.534 75.6038 123.311 75.3803 123.035 75.3803C122.759 75.3803 122.536 75.6038 122.536 75.8794C122.536 76.155 122.759 76.3785 123.035 76.3785Z"
        fill="white"
      />
      <path
        d="M342.464 156.102C343.005 156.102 343.444 155.663 343.444 155.122C343.444 154.58 343.005 154.141 342.464 154.141C341.922 154.141 341.483 154.58 341.483 155.122C341.483 155.663 341.922 156.102 342.464 156.102Z"
        fill="white"
      />
      <path
        d="M196.181 192.641C196.723 192.641 197.162 192.202 197.162 191.661C197.162 191.12 196.723 190.681 196.181 190.681C195.64 190.681 195.201 191.12 195.201 191.661C195.201 192.202 195.64 192.641 196.181 192.641Z"
        fill="white"
      />
      <path
        d="M92.5595 143.939C93.1029 143.939 93.5434 143.498 93.5434 142.955C93.5434 142.412 93.1029 141.971 92.5595 141.971C92.0161 141.971 91.5756 142.412 91.5756 142.955C91.5756 143.498 92.0161 143.939 92.5595 143.939Z"
        fill="white"
      />
      <path
        d="M43.7821 119.509C44.3137 119.509 44.7446 119.078 44.7446 118.547C44.7446 118.015 44.3137 117.584 43.7821 117.584C43.2505 117.584 42.8196 118.015 42.8196 118.547C42.8196 119.078 43.2505 119.509 43.7821 119.509Z"
        fill="white"
      />
      <path
        d="M312.009 113.417C312.537 113.417 312.965 112.989 312.965 112.462C312.965 111.934 312.537 111.506 312.009 111.506C311.482 111.506 311.054 111.934 311.054 112.462C311.054 112.989 311.482 113.417 312.009 113.417Z"
        fill="white"
      />
      <path
        d="M129.127 89.0336C129.645 89.0336 130.065 88.6138 130.065 88.096C130.065 87.5782 129.645 87.1585 129.127 87.1585C128.61 87.1585 128.19 87.5782 128.19 88.096C128.19 88.6138 128.61 89.0336 129.127 89.0336Z"
        fill="white"
      />
      <path
        d="M123.021 89.0336C123.539 89.0336 123.958 88.6138 123.958 88.096C123.958 87.5782 123.539 87.1585 123.021 87.1585C122.503 87.1585 122.083 87.5782 122.083 88.096C122.083 88.6138 122.503 89.0336 123.021 89.0336Z"
        fill="white"
      />
      <path
        d="M25.4875 137.804C26.0053 137.804 26.425 137.384 26.425 136.866C26.425 136.348 26.0053 135.929 25.4875 135.929C24.9697 135.929 24.5499 136.348 24.5499 136.866C24.5499 137.384 24.9697 137.804 25.4875 137.804Z"
        fill="white"
      />
      <path
        d="M147.401 70.7532C147.907 70.7532 148.317 70.343 148.317 69.837C148.317 69.331 147.907 68.9209 147.401 68.9209C146.895 68.9209 146.484 69.331 146.484 69.837C146.484 70.343 146.895 70.7532 147.401 70.7532Z"
        fill="white"
      />
      <path
        d="M92.5345 101.193C93.0405 101.193 93.4507 100.783 93.4507 100.277C93.4507 99.771 93.0405 99.3608 92.5345 99.3608C92.0285 99.3608 91.6184 99.771 91.6184 100.277C91.6184 100.783 92.0285 101.193 92.5345 101.193Z"
        fill="white"
      />
      <path
        d="M86.4422 95.026C86.9384 95.026 87.3406 94.6238 87.3406 94.1277C87.3406 93.6315 86.9384 93.2294 86.4422 93.2294C85.9461 93.2294 85.5439 93.6315 85.5439 94.1277C85.5439 94.6238 85.9461 95.026 86.4422 95.026Z"
        fill="white"
      />
      <path
        d="M129.102 82.8807C129.599 82.8807 130.001 82.4785 130.001 81.9824C130.001 81.4862 129.599 81.084 129.102 81.084C128.606 81.084 128.204 81.4862 128.204 81.9824C128.204 82.4785 128.606 82.8807 129.102 82.8807Z"
        fill="white"
      />
      <path
        d="M135.188 82.8807C135.682 82.8807 136.082 82.4801 136.082 81.9859C136.082 81.4918 135.682 81.0912 135.188 81.0912C134.693 81.0912 134.293 81.4918 134.293 81.9859C134.293 82.4801 134.693 82.8807 135.188 82.8807Z"
        fill="white"
      />
      <path
        d="M251.008 52.3873C251.501 52.3873 251.9 51.9883 251.9 51.4961C251.9 51.0039 251.501 50.6049 251.008 50.6049C250.516 50.6049 250.117 51.0039 250.117 51.4961C250.117 51.9883 250.516 52.3873 251.008 52.3873Z"
        fill="white"
      />
      <path
        d="M7.2071 119.445C7.69339 119.445 8.08761 119.051 8.08761 118.564C8.08761 118.078 7.69339 117.684 7.2071 117.684C6.72081 117.684 6.32659 118.078 6.32659 118.564C6.32659 119.051 6.72081 119.445 7.2071 119.445Z"
        fill="white"
      />
      <path
        d="M257.133 204.751C257.615 204.751 258.006 204.36 258.006 203.878C258.006 203.395 257.615 203.004 257.133 203.004C256.65 203.004 256.259 203.395 256.259 203.878C256.259 204.36 256.65 204.751 257.133 204.751Z"
        fill="white"
      />
      <path
        d="M80.3607 137.732C80.8391 137.732 81.2269 137.345 81.2269 136.866C81.2269 136.388 80.8391 136 80.3607 136C79.8823 136 79.4944 136.388 79.4944 136.866C79.4944 137.345 79.8823 137.732 80.3607 137.732Z"
        fill="white"
      />
      <path
        d="M43.7465 58.4724C44.217 58.4724 44.5984 58.091 44.5984 57.6204C44.5984 57.1499 44.217 56.7684 43.7465 56.7684C43.2759 56.7684 42.8945 57.1499 42.8945 57.6204C42.8945 58.091 43.2759 58.4724 43.7465 58.4724Z"
        fill="white"
      />
      <path
        d="M251.019 40.16C251.49 40.16 251.871 39.7785 251.871 39.308C251.871 38.8374 251.49 38.456 251.019 38.456C250.549 38.456 250.167 38.8374 250.167 39.308C250.167 39.7785 250.549 40.16 251.019 40.16Z"
        fill="white"
      />
      <path
        d="M141.301 76.7777C141.778 76.7777 142.164 76.3915 142.164 75.9151C142.164 75.4386 141.778 75.0524 141.301 75.0524C140.825 75.0524 140.438 75.4386 140.438 75.9151C140.438 76.3915 140.825 76.7777 141.301 76.7777Z"
        fill="white"
      />
      <path
        d="M244.884 52.3516C245.351 52.3516 245.729 51.9734 245.729 51.5068C245.729 51.0402 245.351 50.6619 244.884 50.6619C244.417 50.6619 244.039 51.0402 244.039 51.5068C244.039 51.9734 244.417 52.3516 244.884 52.3516Z"
        fill="white"
      />
      <path
        d="M238.817 40.1956C239.289 40.1956 239.672 39.8126 239.672 39.34C239.672 38.8675 239.289 38.4845 238.817 38.4845C238.344 38.4845 237.961 38.8675 237.961 39.34C237.961 39.8126 238.344 40.1956 238.817 40.1956Z"
        fill="white"
      />
      <path
        d="M37.6791 119.427C38.1457 119.427 38.524 119.049 38.524 118.582C38.524 118.116 38.1457 117.737 37.6791 117.737C37.2125 117.737 36.8343 118.116 36.8343 118.582C36.8343 119.049 37.2125 119.427 37.6791 119.427Z"
        fill="white"
      />
      <path
        d="M43.7714 113.335C44.238 113.335 44.6163 112.957 44.6163 112.49C44.6163 112.023 44.238 111.645 43.7714 111.645C43.3048 111.645 42.9265 112.023 42.9265 112.49C42.9265 112.957 43.3048 113.335 43.7714 113.335Z"
        fill="white"
      />
      <path
        d="M31.5726 119.427C32.0392 119.427 32.4175 119.049 32.4175 118.582C32.4175 118.116 32.0392 117.737 31.5726 117.737C31.106 117.737 30.7277 118.116 30.7277 118.582C30.7277 119.049 31.106 119.427 31.5726 119.427Z"
        fill="white"
      />
      <path
        d="M208.341 192.577C208.814 192.577 209.197 192.194 209.197 191.722C209.197 191.249 208.814 190.866 208.341 190.866C207.869 190.866 207.486 191.249 207.486 191.722C207.486 192.194 207.869 192.577 208.341 192.577Z"
        fill="white"
      />
      <path
        d="M244.93 46.2344C245.393 46.2344 245.768 45.8593 245.768 45.3967C245.768 44.934 245.393 44.5589 244.93 44.5589C244.468 44.5589 244.093 44.934 244.093 45.3967C244.093 45.8593 244.468 46.2344 244.93 46.2344Z"
        fill="white"
      />
      <path
        d="M31.5726 88.9231C32.0353 88.9231 32.4103 88.548 32.4103 88.0853C32.4103 87.6227 32.0353 87.2476 31.5726 87.2476C31.1099 87.2476 30.7349 87.6227 30.7349 88.0853C30.7349 88.548 31.1099 88.9231 31.5726 88.9231Z"
        fill="white"
      />
      <path
        d="M251.03 46.2344C251.492 46.2344 251.867 45.8593 251.867 45.3967C251.867 44.934 251.492 44.5589 251.03 44.5589C250.567 44.5589 250.192 44.934 250.192 45.3967C250.192 45.8593 250.567 46.2344 251.03 46.2344Z"
        fill="white"
      />
      <path
        d="M74.2149 137.665C74.6776 137.665 75.0527 137.29 75.0527 136.827C75.0527 136.364 74.6776 135.989 74.2149 135.989C73.7523 135.989 73.3772 136.364 73.3772 136.827C73.3772 137.29 73.7523 137.665 74.2149 137.665Z"
        fill="white"
      />
      <path
        d="M74.2149 131.316C74.5122 131.316 74.7532 131.075 74.7532 130.778C74.7532 130.48 74.5122 130.239 74.2149 130.239C73.9176 130.239 73.6766 130.48 73.6766 130.778C73.6766 131.075 73.9176 131.316 74.2149 131.316Z"
        fill="white"
      />
      <path
        d="M238.852 34.057C239.315 34.057 239.69 33.6819 239.69 33.2192C239.69 32.7566 239.315 32.3815 238.852 32.3815C238.39 32.3815 238.015 32.7566 238.015 33.2192C238.015 33.6819 238.39 34.057 238.852 34.057Z"
        fill="white"
      />
      <path
        d="M226.604 33.7789C226.925 33.7789 227.185 33.5188 227.185 33.1979C227.185 32.877 226.925 32.6168 226.604 32.6168C226.283 32.6168 226.023 32.877 226.023 33.1979C226.023 33.5188 226.283 33.7789 226.604 33.7789Z"
        fill="white"
      />
      <path
        d="M244.902 40.1421C245.353 40.1421 245.718 39.7766 245.718 39.3258C245.718 38.8749 245.353 38.5094 244.902 38.5094C244.451 38.5094 244.085 38.8749 244.085 39.3258C244.085 39.7766 244.451 40.1421 244.902 40.1421Z"
        fill="white"
      />
      <path
        d="M244.902 34.0356C245.353 34.0356 245.718 33.6701 245.718 33.2193C245.718 32.7684 245.353 32.4029 244.902 32.4029C244.451 32.4029 244.085 32.7684 244.085 33.2193C244.085 33.6701 244.451 34.0356 244.902 34.0356Z"
        fill="white"
      />
      <path
        d="M43.7714 94.9619C44.1927 94.9619 44.5343 94.6203 44.5343 94.199C44.5343 93.7777 44.1927 93.4361 43.7714 93.4361C43.3501 93.4361 43.0085 93.7777 43.0085 94.199C43.0085 94.6203 43.3501 94.9619 43.7714 94.9619Z"
        fill="white"
      />
      <path
        d="M37.6791 94.9619C38.1005 94.9619 38.442 94.6203 38.442 94.199C38.442 93.7777 38.1005 93.4361 37.6791 93.4361C37.2578 93.4361 36.9163 93.7777 36.9163 94.199C36.9163 94.6203 37.2578 94.9619 37.6791 94.9619Z"
        fill="white"
      />
      <path
        d="M135.202 3.48871C135.623 3.48871 135.965 3.14716 135.965 2.72584C135.965 2.30452 135.623 1.96297 135.202 1.96297C134.78 1.96297 134.439 2.30452 134.439 2.72584C134.439 3.14716 134.78 3.48871 135.202 3.48871Z"
        fill="white"
      />
      <path
        d="M251.026 58.3155C251.434 58.3155 251.764 57.9852 251.764 57.5776C251.764 57.1701 251.434 56.8397 251.026 56.8397C250.619 56.8397 250.288 57.1701 250.288 57.5776C250.288 57.9852 250.619 58.3155 251.026 58.3155Z"
        fill="white"
      />
      <path
        d="M244.92 58.3155C245.327 58.3155 245.658 57.9852 245.658 57.5776C245.658 57.1701 245.327 56.8397 244.92 56.8397C244.512 56.8397 244.182 57.1701 244.182 57.5776C244.182 57.9852 244.512 58.3155 244.92 58.3155Z"
        fill="white"
      />
      <path
        d="M275.434 216.846C275.85 216.846 276.187 216.51 276.187 216.094C276.187 215.679 275.85 215.342 275.434 215.342C275.019 215.342 274.682 215.679 274.682 216.094C274.682 216.51 275.019 216.846 275.434 216.846Z"
        fill="white"
      />
      <path
        d="M31.5726 137.604C31.9821 137.604 32.3141 137.272 32.3141 136.863C32.3141 136.453 31.9821 136.121 31.5726 136.121C31.1631 136.121 30.8311 136.453 30.8311 136.863C30.8311 137.272 31.1631 137.604 31.5726 137.604Z"
        fill="white"
      />
      <path
        d="M122.974 168.037C123.366 168.037 123.684 167.719 123.684 167.328C123.684 166.936 123.366 166.618 122.974 166.618C122.583 166.618 122.265 166.936 122.265 167.328C122.265 167.719 122.583 168.037 122.974 168.037Z"
        fill="white"
      />
      <path
        d="M110.836 161.909C111.189 161.909 111.474 161.623 111.474 161.271C111.474 160.919 111.189 160.633 110.836 160.633C110.484 160.633 110.198 160.919 110.198 161.271C110.198 161.623 110.484 161.909 110.836 161.909Z"
        fill="white"
      />
      <path
        d="M244.884 204.526C245.236 204.526 245.522 204.241 245.522 203.888C245.522 203.536 245.236 203.25 244.884 203.25C244.532 203.25 244.246 203.536 244.246 203.888C244.246 204.241 244.532 204.526 244.884 204.526Z"
        fill="white"
      />
      <path
        d="M116.911 155.792C117.263 155.792 117.549 155.506 117.549 155.154C117.549 154.801 117.263 154.516 116.911 154.516C116.558 154.516 116.273 154.801 116.273 155.154C116.273 155.506 116.558 155.792 116.911 155.792Z"
        fill="white"
      />
      <path
        d="M141.33 155.792C141.682 155.792 141.968 155.506 141.968 155.154C141.968 154.801 141.682 154.516 141.33 154.516C140.977 154.516 140.692 154.801 140.692 155.154C140.692 155.506 140.977 155.792 141.33 155.792Z"
        fill="white"
      />
      <path
        d="M159.546 161.87C159.898 161.87 160.184 161.584 160.184 161.232C160.184 160.879 159.898 160.594 159.546 160.594C159.193 160.594 158.908 160.879 158.908 161.232C158.908 161.584 159.193 161.87 159.546 161.87Z"
        fill="white"
      />
      <path
        d="M159.546 180.535C160.131 180.535 160.605 180.061 160.605 179.476C160.605 178.892 160.131 178.418 159.546 178.418C158.961 178.418 158.487 178.892 158.487 179.476C158.487 180.061 158.961 180.535 159.546 180.535Z"
        fill="white"
      />
      <path
        d="M177.876 186.667C178.461 186.667 178.935 186.193 178.935 185.608C178.935 185.023 178.461 184.549 177.876 184.549C177.291 184.549 176.817 185.023 176.817 185.608C176.817 186.193 177.291 186.667 177.876 186.667Z"
        fill="white"
      />
      <path
        d="M86.4993 143.49C86.834 143.49 87.1053 143.218 87.1053 142.884C87.1053 142.549 86.834 142.278 86.4993 142.278C86.1646 142.278 85.8932 142.549 85.8932 142.884C85.8932 143.218 86.1646 143.49 86.4993 143.49Z"
        fill="white"
      />
      <path
        d="M86.4993 155.653C86.7651 155.653 86.9805 155.437 86.9805 155.172C86.9805 154.906 86.7651 154.69 86.4993 154.69C86.2335 154.69 86.018 154.906 86.018 155.172C86.018 155.437 86.2335 155.653 86.4993 155.653Z"
        fill="white"
      />
      <path
        d="M80.35 100.869C80.6847 100.869 80.956 100.597 80.956 100.263C80.956 99.928 80.6847 99.6567 80.35 99.6567C80.0153 99.6567 79.7439 99.928 79.7439 100.263C79.7439 100.597 80.0153 100.869 80.35 100.869Z"
        fill="white"
      />
      <path
        d="M92.5345 106.997C92.8692 106.997 93.1405 106.725 93.1405 106.391C93.1405 106.056 92.8692 105.785 92.5345 105.785C92.1998 105.785 91.9285 106.056 91.9285 106.391C91.9285 106.725 92.1998 106.997 92.5345 106.997Z"
        fill="white"
      />
      <path
        d="M37.6791 52.0629C37.9902 52.0629 38.2424 51.8107 38.2424 51.4996C38.2424 51.1886 37.9902 50.9364 37.6791 50.9364C37.3681 50.9364 37.1159 51.1886 37.1159 51.4996C37.1159 51.8107 37.3681 52.0629 37.6791 52.0629Z"
        fill="white"
      />
      <path
        d="M43.7857 45.9813C44.0967 45.9813 44.3489 45.7291 44.3489 45.4181C44.3489 45.107 44.0967 44.8548 43.7857 44.8548C43.4746 44.8548 43.2224 45.107 43.2224 45.4181C43.2224 45.7291 43.4746 45.9813 43.7857 45.9813Z"
        fill="white"
      />
      <path
        d="M37.6791 58.0161C37.8977 58.0161 38.0748 57.839 38.0748 57.6204C38.0748 57.4019 37.8977 57.2247 37.6791 57.2247C37.4606 57.2247 37.2834 57.4019 37.2834 57.6204C37.2834 57.839 37.4606 58.0161 37.6791 58.0161Z"
        fill="white"
      />
      <path
        d="M31.5726 64.1191C31.7911 64.1191 31.9683 63.9419 31.9683 63.7234C31.9683 63.5048 31.7911 63.3277 31.5726 63.3277C31.3541 63.3277 31.1769 63.5048 31.1769 63.7234C31.1769 63.9419 31.3541 64.1191 31.5726 64.1191Z"
        fill="white"
      />
      <path
        d="M25.4875 70.2007C25.706 70.2007 25.8832 70.0235 25.8832 69.805C25.8832 69.5864 25.706 69.4093 25.4875 69.4093C25.2689 69.4093 25.0918 69.5864 25.0918 69.805C25.0918 70.0235 25.2689 70.2007 25.4875 70.2007Z"
        fill="white"
      />
      <path
        d="M31.5726 70.4324C31.9191 70.4324 32.2 70.1515 32.2 69.805C32.2 69.4585 31.9191 69.1776 31.5726 69.1776C31.2261 69.1776 30.9452 69.4585 30.9452 69.805C30.9452 70.1515 31.2261 70.4324 31.5726 70.4324Z"
        fill="white"
      />
      <path
        d="M19.3988 76.5104C19.7453 76.5104 20.0262 76.2295 20.0262 75.883C20.0262 75.5365 19.7453 75.2556 19.3988 75.2556C19.0523 75.2556 18.7714 75.5365 18.7714 75.883C18.7714 76.2295 19.0523 76.5104 19.3988 76.5104Z"
        fill="white"
      />
      <path
        d="M37.6791 64.2759C37.9843 64.2759 38.2317 64.0285 38.2317 63.7234C38.2317 63.4182 37.9843 63.1708 37.6791 63.1708C37.374 63.1708 37.1266 63.4182 37.1266 63.7234C37.1266 64.0285 37.374 64.2759 37.6791 64.2759Z"
        fill="white"
      />
      <path
        d="M31.5726 58.173C31.8778 58.173 32.1252 57.9256 32.1252 57.6204C32.1252 57.3153 31.8778 57.0679 31.5726 57.0679C31.2674 57.0679 31.0201 57.3153 31.0201 57.6204C31.0201 57.9256 31.2674 58.173 31.5726 58.173Z"
        fill="white"
      />
      <path
        d="M25.4875 64.2759C25.7926 64.2759 26.04 64.0285 26.04 63.7234C26.04 63.4182 25.7926 63.1708 25.4875 63.1708C25.1823 63.1708 24.9349 63.4182 24.9349 63.7234C24.9349 64.0285 25.1823 64.2759 25.4875 64.2759Z"
        fill="white"
      />
      <path
        d="M13.2851 119.11C13.5726 119.11 13.8056 118.877 13.8056 118.589C13.8056 118.302 13.5726 118.069 13.2851 118.069C12.9977 118.069 12.7646 118.302 12.7646 118.589C12.7646 118.877 12.9977 119.11 13.2851 119.11Z"
        fill="white"
      />
      <path
        d="M13.2851 125.199C13.5726 125.199 13.8056 124.966 13.8056 124.678C13.8056 124.391 13.5726 124.158 13.2851 124.158C12.9977 124.158 12.7646 124.391 12.7646 124.678C12.7646 124.966 12.9977 125.199 13.2851 125.199Z"
        fill="white"
      />
      <path
        d="M1.1077 125.527C1.57628 125.527 1.95613 125.147 1.95613 124.678C1.95613 124.21 1.57628 123.83 1.1077 123.83C0.639131 123.83 0.259277 124.21 0.259277 124.678C0.259277 125.147 0.639131 125.527 1.1077 125.527Z"
        fill="white"
      />
      <path
        d="M7.2071 131.17C7.44139 131.17 7.63131 130.98 7.63131 130.745C7.63131 130.511 7.44139 130.321 7.2071 130.321C6.97282 130.321 6.78289 130.511 6.78289 130.745C6.78289 130.98 6.97282 131.17 7.2071 131.17Z"
        fill="white"
      />
      <path
        d="M19.3988 137.29C19.6331 137.29 19.823 137.101 19.823 136.866C19.823 136.632 19.6331 136.442 19.3988 136.442C19.1645 136.442 18.9746 136.632 18.9746 136.866C18.9746 137.101 19.1645 137.29 19.3988 137.29Z"
        fill="white"
      />
      <path
        d="M25.4875 88.5666C25.7533 88.5666 25.9687 88.3511 25.9687 88.0853C25.9687 87.8196 25.7533 87.6041 25.4875 87.6041C25.2217 87.6041 25.0062 87.8196 25.0062 88.0853C25.0062 88.3511 25.2217 88.5666 25.4875 88.5666Z"
        fill="white"
      />
      <path
        d="M25.4875 94.6767C25.7533 94.6767 25.9687 94.4612 25.9687 94.1954C25.9687 93.9296 25.7533 93.7142 25.4875 93.7142C25.2217 93.7142 25.0062 93.9296 25.0062 94.1954C25.0062 94.4612 25.2217 94.6767 25.4875 94.6767Z"
        fill="white"
      />
      <path
        d="M13.2851 94.6767C13.5509 94.6767 13.7664 94.4612 13.7664 94.1954C13.7664 93.9296 13.5509 93.7142 13.2851 93.7142C13.0193 93.7142 12.8039 93.9296 12.8039 94.1954C12.8039 94.4612 13.0193 94.6767 13.2851 94.6767Z"
        fill="white"
      />
      <path
        d="M19.3988 94.6767C19.6646 94.6767 19.88 94.4612 19.88 94.1954C19.88 93.9296 19.6646 93.7142 19.3988 93.7142C19.133 93.7142 18.9175 93.9296 18.9175 94.1954C18.9175 94.4612 19.133 94.6767 19.3988 94.6767Z"
        fill="white"
      />
      <path
        d="M19.3988 88.5666C19.6646 88.5666 19.88 88.3511 19.88 88.0853C19.88 87.8196 19.6646 87.6041 19.3988 87.6041C19.133 87.6041 18.9175 87.8196 18.9175 88.0853C18.9175 88.3511 19.133 88.5666 19.3988 88.5666Z"
        fill="white"
      />
      <path
        d="M25.4875 100.772C25.7533 100.772 25.9687 100.557 25.9687 100.291C25.9687 100.025 25.7533 99.81 25.4875 99.81C25.2217 99.81 25.0062 100.025 25.0062 100.291C25.0062 100.557 25.2217 100.772 25.4875 100.772Z"
        fill="white"
      />
      <path
        d="M98.6695 76.3642C98.9353 76.3642 99.1508 76.1487 99.1508 75.883C99.1508 75.6172 98.9353 75.4017 98.6695 75.4017C98.4038 75.4017 98.1883 75.6172 98.1883 75.883C98.1883 76.1487 98.4038 76.3642 98.6695 76.3642Z"
        fill="white"
      />
      <path
        d="M92.5345 70.2862C92.8003 70.2862 93.0158 70.0707 93.0158 69.805C93.0158 69.5392 92.8003 69.3237 92.5345 69.3237C92.2687 69.3237 92.0533 69.5392 92.0533 69.805C92.0533 70.0707 92.2687 70.2862 92.5345 70.2862Z"
        fill="white"
      />
      <path
        d="M92.5345 76.464C92.8554 76.464 93.1156 76.2039 93.1156 75.8829C93.1156 75.562 92.8554 75.3019 92.5345 75.3019C92.2136 75.3019 91.9534 75.562 91.9534 75.8829C91.9534 76.2039 92.2136 76.464 92.5345 76.464Z"
        fill="white"
      />
      <path
        d="M86.4422 70.386C86.7632 70.386 87.0233 70.1259 87.0233 69.8049C87.0233 69.484 86.7632 69.2239 86.4422 69.2239C86.1213 69.2239 85.8612 69.484 85.8612 69.8049C85.8612 70.1259 86.1213 70.386 86.4422 70.386Z"
        fill="white"
      />
      <path
        d="M98.6695 70.2755C98.9294 70.2755 99.1401 70.0648 99.1401 69.805C99.1401 69.5451 98.9294 69.3344 98.6695 69.3344C98.4097 69.3344 98.199 69.5451 98.199 69.805C98.199 70.0648 98.4097 70.2755 98.6695 70.2755Z"
        fill="white"
      />
      <path
        d="M104.723 70.2755C104.982 70.2755 105.193 70.0648 105.193 69.805C105.193 69.5451 104.982 69.3344 104.723 69.3344C104.463 69.3344 104.252 69.5451 104.252 69.805C104.252 70.0648 104.463 70.2755 104.723 70.2755Z"
        fill="white"
      />
      <path
        d="M104.723 64.1939C104.982 64.1939 105.193 63.9833 105.193 63.7234C105.193 63.4635 104.982 63.2528 104.723 63.2528C104.463 63.2528 104.252 63.4635 104.252 63.7234C104.252 63.9833 104.463 64.1939 104.723 64.1939Z"
        fill="white"
      />
      <path
        d="M86.4422 45.8993C86.708 45.8993 86.9235 45.6838 86.9235 45.418C86.9235 45.1523 86.708 44.9368 86.4422 44.9368C86.1765 44.9368 85.961 45.1523 85.961 45.418C85.961 45.6838 86.1765 45.8993 86.4422 45.8993Z"
        fill="white"
      />
      <path
        d="M92.5345 45.8993C92.8003 45.8993 93.0158 45.6838 93.0158 45.418C93.0158 45.1523 92.8003 44.9368 92.5345 44.9368C92.2687 44.9368 92.0533 45.1523 92.0533 45.418C92.0533 45.6838 92.2687 45.8993 92.5345 45.8993Z"
        fill="white"
      />
      <path
        d="M92.5345 39.725C92.755 39.725 92.9338 39.5463 92.9338 39.3258C92.9338 39.1053 92.755 38.9265 92.5345 38.9265C92.314 38.9265 92.1352 39.1053 92.1352 39.3258C92.1352 39.5463 92.314 39.725 92.5345 39.725Z"
        fill="white"
      />
      <path
        d="M92.5345 33.6043C92.755 33.6043 92.9338 33.4255 92.9338 33.205C92.9338 32.9845 92.755 32.8057 92.5345 32.8057C92.314 32.8057 92.1352 32.9845 92.1352 33.205C92.1352 33.4255 92.314 33.6043 92.5345 33.6043Z"
        fill="white"
      />
      <path
        d="M80.35 33.729C80.6394 33.729 80.874 33.4944 80.874 33.205C80.874 32.9156 80.6394 32.681 80.35 32.681C80.0606 32.681 79.826 32.9156 79.826 33.205C79.826 33.4944 80.0606 33.729 80.35 33.729Z"
        fill="white"
      />
      <path
        d="M86.4422 33.6043C86.6628 33.6043 86.8415 33.4255 86.8415 33.205C86.8415 32.9845 86.6628 32.8057 86.4422 32.8057C86.2217 32.8057 86.043 32.9845 86.043 33.205C86.043 33.4255 86.2217 33.6043 86.4422 33.6043Z"
        fill="white"
      />
      <path
        d="M80.35 39.725C80.5705 39.725 80.7492 39.5463 80.7492 39.3258C80.7492 39.1053 80.5705 38.9265 80.35 38.9265C80.1295 38.9265 79.9507 39.1053 79.9507 39.3258C79.9507 39.5463 80.1295 39.725 80.35 39.725Z"
        fill="white"
      />
      <path
        d="M80.35 45.8173C80.5705 45.8173 80.7492 45.6386 80.7492 45.4181C80.7492 45.1976 80.5705 45.0188 80.35 45.0188C80.1295 45.0188 79.9507 45.1976 79.9507 45.4181C79.9507 45.6386 80.1295 45.8173 80.35 45.8173Z"
        fill="white"
      />
      <path
        d="M74.2078 45.8173C74.4283 45.8173 74.6071 45.6386 74.6071 45.4181C74.6071 45.1976 74.4283 45.0188 74.2078 45.0188C73.9873 45.0188 73.8085 45.1976 73.8085 45.4181C73.8085 45.6386 73.9873 45.8173 74.2078 45.8173Z"
        fill="white"
      />
      <path
        d="M74.2078 51.9167C74.4283 51.9167 74.6071 51.738 74.6071 51.5175C74.6071 51.297 74.4283 51.1182 74.2078 51.1182C73.9873 51.1182 73.8085 51.297 73.8085 51.5175C73.8085 51.738 73.9873 51.9167 74.2078 51.9167Z"
        fill="white"
      />
      <path
        d="M74.2078 58.0197C74.4283 58.0197 74.6071 57.8409 74.6071 57.6204C74.6071 57.3999 74.4283 57.2212 74.2078 57.2212C73.9873 57.2212 73.8085 57.3999 73.8085 57.6204C73.8085 57.8409 73.9873 58.0197 74.2078 58.0197Z"
        fill="white"
      />
      <path
        d="M92.5345 21.6086C92.8495 21.6086 93.1049 21.3533 93.1049 21.0383C93.1049 20.7233 92.8495 20.4679 92.5345 20.4679C92.2195 20.4679 91.9641 20.7233 91.9641 21.0383C91.9641 21.3533 92.2195 21.6086 92.5345 21.6086Z"
        fill="white"
      />
      <path
        d="M86.4422 39.7892C86.6982 39.7892 86.9057 39.5817 86.9057 39.3258C86.9057 39.0698 86.6982 38.8624 86.4422 38.8624C86.1863 38.8624 85.9788 39.0698 85.9788 39.3258C85.9788 39.5817 86.1863 39.7892 86.4422 39.7892Z"
        fill="white"
      />
      <path
        d="M25.4875 106.868C25.7533 106.868 25.9687 106.653 25.9687 106.387C25.9687 106.121 25.7533 105.906 25.4875 105.906C25.2217 105.906 25.0062 106.121 25.0062 106.387C25.0062 106.653 25.2217 106.868 25.4875 106.868Z"
        fill="white"
      />
      <path
        d="M19.3988 106.868C19.6646 106.868 19.88 106.653 19.88 106.387C19.88 106.121 19.6646 105.906 19.3988 105.906C19.133 105.906 18.9175 106.121 18.9175 106.387C18.9175 106.653 19.133 106.868 19.3988 106.868Z"
        fill="white"
      />
      <path
        d="M19.3988 100.769C19.6646 100.769 19.88 100.553 19.88 100.288C19.88 100.022 19.6646 99.8064 19.3988 99.8064C19.133 99.8064 18.9175 100.022 18.9175 100.288C18.9175 100.553 19.133 100.769 19.3988 100.769Z"
        fill="white"
      />
      <path
        d="M13.2851 106.868C13.5509 106.868 13.7664 106.653 13.7664 106.387C13.7664 106.121 13.5509 105.906 13.2851 105.906C13.0193 105.906 12.8039 106.121 12.8039 106.387C12.8039 106.653 13.0193 106.868 13.2851 106.868Z"
        fill="white"
      />
      <path
        d="M19.3988 112.857C19.6193 112.857 19.798 112.678 19.798 112.458C19.798 112.237 19.6193 112.059 19.3988 112.059C19.1783 112.059 18.9995 112.237 18.9995 112.458C18.9995 112.678 19.1783 112.857 19.3988 112.857Z"
        fill="white"
      />
      <path
        d="M13.2851 100.687C13.5056 100.687 13.6844 100.508 13.6844 100.288C13.6844 100.067 13.5056 99.8884 13.2851 99.8884C13.0646 99.8884 12.8858 100.067 12.8858 100.288C12.8858 100.508 13.0646 100.687 13.2851 100.687Z"
        fill="white"
      />
      <path
        d="M19.3988 119.067C19.6961 119.067 19.9371 118.826 19.9371 118.529C19.9371 118.232 19.6961 117.991 19.3988 117.991C19.1015 117.991 18.8605 118.232 18.8605 118.529C18.8605 118.826 19.1015 119.067 19.3988 119.067Z"
        fill="white"
      />
      <path
        d="M13.2851 113.028C13.5824 113.028 13.8234 112.787 13.8234 112.49C13.8234 112.193 13.5824 111.952 13.2851 111.952C12.9878 111.952 12.7468 112.193 12.7468 112.49C12.7468 112.787 12.9878 113.028 13.2851 113.028Z"
        fill="white"
      />
      <path
        d="M86.4422 58.1017C86.708 58.1017 86.9235 57.8862 86.9235 57.6204C86.9235 57.3546 86.708 57.1392 86.4422 57.1392C86.1765 57.1392 85.961 57.3546 85.961 57.6204C85.961 57.8862 86.1765 58.1017 86.4422 58.1017Z"
        fill="white"
      />
      <path
        d="M80.35 58.1017C80.6158 58.1017 80.8312 57.8862 80.8312 57.6204C80.8312 57.3546 80.6158 57.1392 80.35 57.1392C80.0842 57.1392 79.8687 57.3546 79.8687 57.6204C79.8687 57.8862 80.0842 58.1017 80.35 58.1017Z"
        fill="white"
      />
      <path
        d="M68.1797 58.2835C68.5459 58.2835 68.8427 57.9866 68.8427 57.6204C68.8427 57.2542 68.5459 56.9574 68.1797 56.9574C67.8135 56.9574 67.5166 57.2542 67.5166 57.6204C67.5166 57.9866 67.8135 58.2835 68.1797 58.2835Z"
        fill="white"
      />
      <path
        d="M68.1797 52.1805C68.5459 52.1805 68.8427 51.8837 68.8427 51.5175C68.8427 51.1513 68.5459 50.8544 68.1797 50.8544C67.8135 50.8544 67.5166 51.1513 67.5166 51.5175C67.5166 51.8837 67.8135 52.1805 68.1797 52.1805Z"
        fill="white"
      />
      <path
        d="M68.1797 64.3223C68.5105 64.3223 68.7786 64.0541 68.7786 63.7234C68.7786 63.3926 68.5105 63.1245 68.1797 63.1245C67.8489 63.1245 67.5808 63.3926 67.5808 63.7234C67.5808 64.0541 67.8489 64.3223 68.1797 64.3223Z"
        fill="white"
      />
      <path
        d="M68.1797 70.575C68.605 70.575 68.9497 70.2302 68.9497 69.805C68.9497 69.3797 68.605 69.035 68.1797 69.035C67.7544 69.035 67.4097 69.3797 67.4097 69.805C67.4097 70.2302 67.7544 70.575 68.1797 70.575Z"
        fill="white"
      />
      <path
        d="M86.4422 51.9987C86.708 51.9987 86.9235 51.7832 86.9235 51.5175C86.9235 51.2517 86.708 51.0362 86.4422 51.0362C86.1765 51.0362 85.961 51.2517 85.961 51.5175C85.961 51.7832 86.1765 51.9987 86.4422 51.9987Z"
        fill="white"
      />
      <path
        d="M80.35 51.9381C80.5823 51.9381 80.7706 51.7498 80.7706 51.5175C80.7706 51.2851 80.5823 51.0968 80.35 51.0968C80.1177 51.0968 79.9293 51.2851 79.9293 51.5175C79.9293 51.7498 80.1177 51.9381 80.35 51.9381Z"
        fill="white"
      />
      <path
        d="M86.4422 64.2046C86.708 64.2046 86.9235 63.9892 86.9235 63.7234C86.9235 63.4576 86.708 63.2421 86.4422 63.2421C86.1765 63.2421 85.961 63.4576 85.961 63.7234C85.961 63.9892 86.1765 64.2046 86.4422 64.2046Z"
        fill="white"
      />
      <path
        d="M80.35 64.2046C80.6158 64.2046 80.8312 63.9892 80.8312 63.7234C80.8312 63.4576 80.6158 63.2421 80.35 63.2421C80.0842 63.2421 79.8687 63.4576 79.8687 63.7234C79.8687 63.9892 80.0842 64.2046 80.35 64.2046Z"
        fill="white"
      />
      <path
        d="M80.35 70.1828C80.5587 70.1828 80.7278 70.0137 80.7278 69.805C80.7278 69.5963 80.5587 69.4271 80.35 69.4271C80.1413 69.4271 79.9721 69.5963 79.9721 69.805C79.9721 70.0137 80.1413 70.1828 80.35 70.1828Z"
        fill="white"
      />
      <path
        d="M74.2078 70.1828C74.4165 70.1828 74.5857 70.0137 74.5857 69.805C74.5857 69.5963 74.4165 69.4271 74.2078 69.4271C73.9991 69.4271 73.8299 69.5963 73.8299 69.805C73.8299 70.0137 73.9991 70.1828 74.2078 70.1828Z"
        fill="white"
      />
      <path
        d="M74.2078 76.2608C74.4165 76.2608 74.5857 76.0917 74.5857 75.883C74.5857 75.6743 74.4165 75.5051 74.2078 75.5051C73.9991 75.5051 73.8299 75.6743 73.8299 75.883C73.8299 76.0917 73.9991 76.2608 74.2078 76.2608Z"
        fill="white"
      />
      <path
        d="M74.2078 82.3709C74.4165 82.3709 74.5857 82.2018 74.5857 81.9931C74.5857 81.7844 74.4165 81.6152 74.2078 81.6152C73.9991 81.6152 73.8299 81.7844 73.8299 81.9931C73.8299 82.2018 73.9991 82.3709 74.2078 82.3709Z"
        fill="white"
      />
      <path
        d="M80.35 82.3709C80.5587 82.3709 80.7278 82.2018 80.7278 81.9931C80.7278 81.7844 80.5587 81.6152 80.35 81.6152C80.1413 81.6152 79.9721 81.7844 79.9721 81.9931C79.9721 82.2018 80.1413 82.3709 80.35 82.3709Z"
        fill="white"
      />
      <path
        d="M80.35 88.4632C80.5587 88.4632 80.7278 88.294 80.7278 88.0853C80.7278 87.8766 80.5587 87.7075 80.35 87.7075C80.1413 87.7075 79.9721 87.8766 79.9721 88.0853C79.9721 88.294 80.1413 88.4632 80.35 88.4632Z"
        fill="white"
      />
      <path
        d="M86.4422 82.3709C86.6509 82.3709 86.8201 82.2018 86.8201 81.9931C86.8201 81.7844 86.6509 81.6152 86.4422 81.6152C86.2335 81.6152 86.0644 81.7844 86.0644 81.9931C86.0644 82.2018 86.2335 82.3709 86.4422 82.3709Z"
        fill="white"
      />
      <path
        d="M25.4875 76.3642C25.7533 76.3642 25.9687 76.1487 25.9687 75.883C25.9687 75.6172 25.7533 75.4017 25.4875 75.4017C25.2217 75.4017 25.0062 75.6172 25.0062 75.883C25.0062 76.1487 25.2217 76.3642 25.4875 76.3642Z"
        fill="white"
      />
      <path
        d="M25.4875 82.4743C25.7533 82.4743 25.9687 82.2589 25.9687 81.9931C25.9687 81.7273 25.7533 81.5118 25.4875 81.5118C25.2217 81.5118 25.0062 81.7273 25.0062 81.9931C25.0062 82.2589 25.2217 82.4743 25.4875 82.4743Z"
        fill="white"
      />
      <path
        d="M19.3988 82.4743C19.6646 82.4743 19.88 82.2589 19.88 81.9931C19.88 81.7273 19.6646 81.5118 19.3988 81.5118C19.133 81.5118 18.9175 81.7273 18.9175 81.9931C18.9175 82.2589 19.133 82.4743 19.3988 82.4743Z"
        fill="white"
      />
      <path
        d="M31.5726 76.4141C31.866 76.4141 32.1038 76.1763 32.1038 75.883C32.1038 75.5896 31.866 75.3518 31.5726 75.3518C31.2793 75.3518 31.0415 75.5896 31.0415 75.883C31.0415 76.1763 31.2793 76.4141 31.5726 76.4141Z"
        fill="white"
      />
      <path
        d="M31.5726 82.5991C31.9073 82.5991 32.1786 82.3277 32.1786 81.993C32.1786 81.6584 31.9073 81.387 31.5726 81.387C31.2379 81.387 30.9666 81.6584 30.9666 81.993C30.9666 82.3277 31.2379 82.5991 31.5726 82.5991Z"
        fill="white"
      />
      <path
        d="M110.833 70.1187C111.006 70.1187 111.146 69.9782 111.146 69.805C111.146 69.6317 111.006 69.4913 110.833 69.4913C110.659 69.4913 110.519 69.6317 110.519 69.805C110.519 69.9782 110.659 70.1187 110.833 70.1187Z"
        fill="white"
      />
      <path
        d="M110.833 64.169C111.079 64.169 111.278 63.9695 111.278 63.7234C111.278 63.4773 111.079 63.2778 110.833 63.2778C110.587 63.2778 110.387 63.4773 110.387 63.7234C110.387 63.9695 110.587 64.169 110.833 64.169Z"
        fill="white"
      />
      <path
        d="M110.833 58.066C111.079 58.066 111.278 57.8665 111.278 57.6204C111.278 57.3743 111.079 57.1748 110.833 57.1748C110.587 57.1748 110.387 57.3743 110.387 57.6204C110.387 57.8665 110.587 58.066 110.833 58.066Z"
        fill="white"
      />
      <path
        d="M110.833 51.9631C111.079 51.9631 111.278 51.7636 111.278 51.5175C111.278 51.2714 111.079 51.0719 110.833 51.0719C110.587 51.0719 110.387 51.2714 110.387 51.5175C110.387 51.7636 110.587 51.9631 110.833 51.9631Z"
        fill="white"
      />
      <path
        d="M110.833 45.8637C111.079 45.8637 111.278 45.6642 111.278 45.4181C111.278 45.172 111.079 44.9725 110.833 44.9725C110.587 44.9725 110.387 45.172 110.387 45.4181C110.387 45.6642 110.587 45.8637 110.833 45.8637Z"
        fill="white"
      />
      <path
        d="M116.918 51.8633C117.109 51.8633 117.264 51.7084 117.264 51.5175C117.264 51.3265 117.109 51.1717 116.918 51.1717C116.727 51.1717 116.572 51.3265 116.572 51.5175C116.572 51.7084 116.727 51.8633 116.918 51.8633Z"
        fill="white"
      />
      <path
        d="M104.723 58.066C104.969 58.066 105.168 57.8665 105.168 57.6204C105.168 57.3743 104.969 57.1748 104.723 57.1748C104.477 57.1748 104.277 57.3743 104.277 57.6204C104.277 57.8665 104.477 58.066 104.723 58.066Z"
        fill="white"
      />
      <path
        d="M104.723 51.9631C104.969 51.9631 105.168 51.7636 105.168 51.5175C105.168 51.2714 104.969 51.0719 104.723 51.0719C104.477 51.0719 104.277 51.2714 104.277 51.5175C104.277 51.7636 104.477 51.9631 104.723 51.9631Z"
        fill="white"
      />
      <path
        d="M104.723 45.8637C104.969 45.8637 105.168 45.6642 105.168 45.4181C105.168 45.172 104.969 44.9725 104.723 44.9725C104.477 44.9725 104.277 45.172 104.277 45.4181C104.277 45.6642 104.477 45.8637 104.723 45.8637Z"
        fill="white"
      />
      <path
        d="M104.723 39.7714C104.969 39.7714 105.168 39.5719 105.168 39.3258C105.168 39.0797 104.969 38.8802 104.723 38.8802C104.477 38.8802 104.277 39.0797 104.277 39.3258C104.277 39.5719 104.477 39.7714 104.723 39.7714Z"
        fill="white"
      />
      <path
        d="M104.723 33.6506C104.969 33.6506 105.168 33.4511 105.168 33.205C105.168 32.9589 104.969 32.7594 104.723 32.7594C104.477 32.7594 104.277 32.9589 104.277 33.205C104.277 33.4511 104.477 33.6506 104.723 33.6506Z"
        fill="white"
      />
      <path
        d="M110.833 27.594C111.079 27.594 111.278 27.3945 111.278 27.1484C111.278 26.9023 111.079 26.7028 110.833 26.7028C110.587 26.7028 110.387 26.9023 110.387 27.1484C110.387 27.3945 110.587 27.594 110.833 27.594Z"
        fill="white"
      />
      <path
        d="M98.6696 33.6506C98.9157 33.6506 99.1152 33.4511 99.1152 33.205C99.1152 32.9589 98.9157 32.7594 98.6696 32.7594C98.4235 32.7594 98.224 32.9589 98.224 33.205C98.224 33.4511 98.4235 33.6506 98.6696 33.6506Z"
        fill="white"
      />
      <path
        d="M110.833 39.7072C111.043 39.7072 111.214 39.5364 111.214 39.3258C111.214 39.1151 111.043 38.9444 110.833 38.9444C110.622 38.9444 110.451 39.1151 110.451 39.3258C110.451 39.5364 110.622 39.7072 110.833 39.7072Z"
        fill="white"
      />
      <path
        d="M110.833 33.5864C111.043 33.5864 111.214 33.4157 111.214 33.205C111.214 32.9944 111.043 32.8236 110.833 32.8236C110.622 32.8236 110.451 32.9944 110.451 33.205C110.451 33.4157 110.622 33.5864 110.833 33.5864Z"
        fill="white"
      />
      <path
        d="M116.907 39.7072C117.118 39.7072 117.289 39.5364 117.289 39.3258C117.289 39.1151 117.118 38.9444 116.907 38.9444C116.696 38.9444 116.526 39.1151 116.526 39.3258C116.526 39.5364 116.696 39.7072 116.907 39.7072Z"
        fill="white"
      />
      <path
        d="M116.907 33.5864C117.118 33.5864 117.289 33.4157 117.289 33.205C117.289 32.9944 117.118 32.8236 116.907 32.8236C116.696 32.8236 116.526 32.9944 116.526 33.205C116.526 33.4157 116.696 33.5864 116.907 33.5864Z"
        fill="white"
      />
      <path
        d="M123.017 33.5864C123.228 33.5864 123.399 33.4157 123.399 33.205C123.399 32.9944 123.228 32.8236 123.017 32.8236C122.807 32.8236 122.636 32.9944 122.636 33.205C122.636 33.4157 122.807 33.5864 123.017 33.5864Z"
        fill="white"
      />
      <path
        d="M123.017 27.5298C123.228 27.5298 123.399 27.359 123.399 27.1484C123.399 26.9377 123.228 26.7669 123.017 26.7669C122.807 26.7669 122.636 26.9377 122.636 27.1484C122.636 27.359 122.807 27.5298 123.017 27.5298Z"
        fill="white"
      />
      <path
        d="M123.017 21.491C123.267 21.491 123.47 21.2883 123.47 21.0383C123.47 20.7882 123.267 20.5855 123.017 20.5855C122.767 20.5855 122.564 20.7882 122.564 21.0383C122.564 21.2883 122.767 21.491 123.017 21.491Z"
        fill="white"
      />
      <path
        d="M116.907 21.491C117.157 21.491 117.36 21.2883 117.36 21.0383C117.36 20.7882 117.157 20.5855 116.907 20.5855C116.657 20.5855 116.454 20.7882 116.454 21.0383C116.454 21.2883 116.657 21.491 116.907 21.491Z"
        fill="white"
      />
      <path
        d="M116.907 9.34213C117.157 9.34213 117.36 9.13943 117.36 8.88939C117.36 8.63935 117.157 8.43666 116.907 8.43666C116.657 8.43666 116.454 8.63935 116.454 8.88939C116.454 9.13943 116.657 9.34213 116.907 9.34213Z"
        fill="white"
      />
      <path
        d="M104.723 15.3952C104.973 15.3952 105.175 15.1925 105.175 14.9425C105.175 14.6924 104.973 14.4897 104.723 14.4897C104.473 14.4897 104.27 14.6924 104.27 14.9425C104.27 15.1925 104.473 15.3952 104.723 15.3952Z"
        fill="white"
      />
      <path
        d="M129.174 27.5298C129.384 27.5298 129.555 27.359 129.555 27.1484C129.555 26.9377 129.384 26.7669 129.174 26.7669C128.963 26.7669 128.792 26.9377 128.792 27.1484C128.792 27.359 128.963 27.5298 129.174 27.5298Z"
        fill="white"
      />
      <path
        d="M129.174 21.4197C129.384 21.4197 129.555 21.249 129.555 21.0383C129.555 20.8276 129.384 20.6569 129.174 20.6569C128.963 20.6569 128.792 20.8276 128.792 21.0383C128.792 21.249 128.963 21.4197 129.174 21.4197Z"
        fill="white"
      />
      <path
        d="M135.23 21.4197C135.441 21.4197 135.612 21.249 135.612 21.0383C135.612 20.8276 135.441 20.6569 135.23 20.6569C135.02 20.6569 134.849 20.8276 134.849 21.0383C134.849 21.249 135.02 21.4197 135.23 21.4197Z"
        fill="white"
      />
      <path
        d="M135.23 15.3132C135.441 15.3132 135.612 15.1424 135.612 14.9318C135.612 14.7211 135.441 14.5503 135.23 14.5503C135.02 14.5503 134.849 14.7211 134.849 14.9318C134.849 15.1424 135.02 15.3132 135.23 15.3132Z"
        fill="white"
      />
      <path
        d="M141.312 15.3132C141.523 15.3132 141.693 15.1424 141.693 14.9318C141.693 14.7211 141.523 14.5503 141.312 14.5503C141.101 14.5503 140.93 14.7211 140.93 14.9318C140.93 15.1424 141.101 15.3132 141.312 15.3132Z"
        fill="white"
      />
      <path
        d="M141.312 3.10727C141.523 3.10727 141.693 2.9365 141.693 2.72584C141.693 2.51518 141.523 2.34441 141.312 2.34441C141.101 2.34441 140.93 2.51518 140.93 2.72584C140.93 2.9365 141.101 3.10727 141.312 3.10727Z"
        fill="white"
      />
      <path
        d="M147.383 3.10727C147.593 3.10727 147.764 2.9365 147.764 2.72584C147.764 2.51518 147.593 2.34441 147.383 2.34441C147.172 2.34441 147.001 2.51518 147.001 2.72584C147.001 2.9365 147.172 3.10727 147.383 3.10727Z"
        fill="white"
      />
      <path
        d="M153.471 3.10727C153.682 3.10727 153.853 2.9365 153.853 2.72584C153.853 2.51518 153.682 2.34441 153.471 2.34441C153.261 2.34441 153.09 2.51518 153.09 2.72584C153.09 2.9365 153.261 3.10727 153.471 3.10727Z"
        fill="white"
      />
      <path
        d="M123.039 39.6466C123.216 39.6466 123.359 39.503 123.359 39.3258C123.359 39.1486 123.216 39.005 123.039 39.005C122.861 39.005 122.718 39.1486 122.718 39.3258C122.718 39.503 122.861 39.6466 123.039 39.6466Z"
        fill="white"
      />
      <path
        d="M98.6696 45.8637C98.9157 45.8637 99.1152 45.6642 99.1152 45.4181C99.1152 45.172 98.9157 44.9725 98.6696 44.9725C98.4235 44.9725 98.224 45.172 98.224 45.4181C98.224 45.6642 98.4235 45.8637 98.6696 45.8637Z"
        fill="white"
      />
      <path
        d="M98.6696 39.7714C98.9157 39.7714 99.1152 39.5719 99.1152 39.3258C99.1152 39.0797 98.9157 38.8802 98.6696 38.8802C98.4235 38.8802 98.224 39.0797 98.224 39.3258C98.224 39.5719 98.4235 39.7714 98.6696 39.7714Z"
        fill="white"
      />
      <path
        d="M98.6696 51.9631C98.9157 51.9631 99.1152 51.7636 99.1152 51.5175C99.1152 51.2714 98.9157 51.0719 98.6696 51.0719C98.4235 51.0719 98.224 51.2714 98.224 51.5175C98.224 51.7636 98.4235 51.9631 98.6696 51.9631Z"
        fill="white"
      />
      <path
        d="M98.6696 58.066C98.9157 58.066 99.1152 57.8665 99.1152 57.6204C99.1152 57.3743 98.9157 57.1748 98.6696 57.1748C98.4235 57.1748 98.224 57.3743 98.224 57.6204C98.224 57.8665 98.4235 58.066 98.6696 58.066Z"
        fill="white"
      />
      <path
        d="M98.6696 64.169C98.9157 64.169 99.1152 63.9695 99.1152 63.7234C99.1152 63.4773 98.9157 63.2778 98.6696 63.2778C98.4235 63.2778 98.224 63.4773 98.224 63.7234C98.224 63.9695 98.4235 64.169 98.6696 64.169Z"
        fill="white"
      />
      <path
        d="M92.5345 64.169C92.7806 64.169 92.9801 63.9695 92.9801 63.7234C92.9801 63.4773 92.7806 63.2778 92.5345 63.2778C92.2884 63.2778 92.0889 63.4773 92.0889 63.7234C92.0889 63.9695 92.2884 64.169 92.5345 64.169Z"
        fill="white"
      />
      <path
        d="M92.5345 58.066C92.7806 58.066 92.9801 57.8665 92.9801 57.6204C92.9801 57.3743 92.7806 57.1748 92.5345 57.1748C92.2884 57.1748 92.0889 57.3743 92.0889 57.6204C92.0889 57.8665 92.2884 58.066 92.5345 58.066Z"
        fill="white"
      />
      <path
        d="M92.5345 51.9631C92.7806 51.9631 92.9801 51.7636 92.9801 51.5175C92.9801 51.2714 92.7806 51.0719 92.5345 51.0719C92.2884 51.0719 92.0889 51.2714 92.0889 51.5175C92.0889 51.7636 92.2884 51.9631 92.5345 51.9631Z"
        fill="white"
      />
      <path
        d="M110.833 21.352C111.006 21.352 111.146 21.2115 111.146 21.0383C111.146 20.865 111.006 20.7246 110.833 20.7246C110.659 20.7246 110.519 20.865 110.519 21.0383C110.519 21.2115 110.659 21.352 110.833 21.352Z"
        fill="white"
      />
      <path
        d="M92.5345 27.4621C92.7078 27.4621 92.8482 27.3216 92.8482 27.1484C92.8482 26.9751 92.7078 26.8347 92.5345 26.8347C92.3613 26.8347 92.2208 26.9751 92.2208 27.1484C92.2208 27.3216 92.3613 27.4621 92.5345 27.4621Z"
        fill="white"
      />
      <path
        d="M110.833 82.3068C111.006 82.3068 111.146 82.1663 111.146 81.9931C111.146 81.8198 111.006 81.6794 110.833 81.6794C110.659 81.6794 110.519 81.8198 110.519 81.9931C110.519 82.1663 110.659 82.3068 110.833 82.3068Z"
        fill="white"
      />
      <path
        d="M92.5345 82.3531C92.7334 82.3531 92.8945 82.1919 92.8945 81.993C92.8945 81.7942 92.7334 81.633 92.5345 81.633C92.3357 81.633 92.1745 81.7942 92.1745 81.993C92.1745 82.1919 92.3357 82.3531 92.5345 82.3531Z"
        fill="white"
      />
    </svg>
  )
}

export default GlassisTeaserGlassesSvg
